import slugify from 'slugify';
import * as i1$2 from '@angular/common/http';
import { HttpErrorResponse, HttpParams, HttpHeaders, HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BehaviorSubject, of, fromEvent, throwError, Subject, interval, timer, Observable } from 'rxjs';
import { map, publishBehavior, refCount, switchMap, filter, take, finalize, catchError, tap, startWith, concatMap, skipWhile, takeWhile, delay, takeUntil, distinctUntilChanged, delayWhen, debounceTime, mergeMap } from 'rxjs/operators';
import * as i0 from '@angular/core';
import { Injectable, Inject, Directive, Input, NgModule, InjectionToken, EventEmitter, Pipe, Optional, HostListener, Component, ChangeDetectionStrategy, Output, SkipSelf, HostBinding } from '@angular/core';
import * as i1$4 from '@angular/common';
import { DOCUMENT, CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import jwtDecode from 'jwt-decode';
import * as i1 from '@angular/platform-browser';
import * as i1$3 from '@angular/forms';
import { UntypedFormArray, NgForm, UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { DateTime, Duration } from 'luxon';
import * as i1$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';
import { __decorate } from 'tslib';
import { io } from 'socket.io-client';

/**
 * Source: https://github.com/fannarsh/country-list
 */
var CountryCode;
(function (CountryCode) {
    CountryCode["AD"] = "ad";
    CountryCode["AE"] = "ae";
    CountryCode["AF"] = "af";
    CountryCode["AG"] = "ag";
    CountryCode["AI"] = "ai";
    CountryCode["AL"] = "al";
    CountryCode["AM"] = "am";
    CountryCode["AO"] = "ao";
    CountryCode["AQ"] = "aq";
    CountryCode["AR"] = "ar";
    CountryCode["AS"] = "as";
    CountryCode["AT"] = "at";
    CountryCode["AU"] = "au";
    CountryCode["AW"] = "aw";
    CountryCode["AX"] = "ax";
    CountryCode["AZ"] = "az";
    CountryCode["BA"] = "ba";
    CountryCode["BB"] = "bb";
    CountryCode["BD"] = "bd";
    CountryCode["BE"] = "be";
    CountryCode["BF"] = "bf";
    CountryCode["BG"] = "bg";
    CountryCode["BH"] = "bh";
    CountryCode["BI"] = "bi";
    CountryCode["BJ"] = "bj";
    CountryCode["BL"] = "bl";
    CountryCode["BM"] = "bm";
    CountryCode["BN"] = "bn";
    CountryCode["BO"] = "bo";
    CountryCode["BQ"] = "bq";
    CountryCode["BR"] = "br";
    CountryCode["BS"] = "bs";
    CountryCode["BT"] = "bt";
    CountryCode["BV"] = "bv";
    CountryCode["BW"] = "bw";
    CountryCode["BY"] = "by";
    CountryCode["BZ"] = "bz";
    CountryCode["CA"] = "ca";
    CountryCode["CC"] = "cc";
    CountryCode["CD"] = "cd";
    CountryCode["CF"] = "cf";
    CountryCode["CG"] = "cg";
    CountryCode["CH"] = "ch";
    CountryCode["CI"] = "ci";
    CountryCode["CK"] = "ck";
    CountryCode["CL"] = "cl";
    CountryCode["CM"] = "cm";
    CountryCode["CN"] = "cn";
    CountryCode["CO"] = "co";
    CountryCode["CR"] = "cr";
    CountryCode["CU"] = "cu";
    CountryCode["CV"] = "cv";
    CountryCode["CW"] = "cw";
    CountryCode["CX"] = "cx";
    CountryCode["CY"] = "cy";
    CountryCode["CZ"] = "cz";
    CountryCode["DE"] = "de";
    CountryCode["DJ"] = "dj";
    CountryCode["DK"] = "dk";
    CountryCode["DM"] = "dm";
    CountryCode["DO"] = "do";
    CountryCode["DZ"] = "dz";
    CountryCode["EC"] = "ec";
    CountryCode["EE"] = "ee";
    CountryCode["EG"] = "eg";
    CountryCode["EH"] = "eh";
    CountryCode["ER"] = "er";
    CountryCode["ES"] = "es";
    CountryCode["ET"] = "et";
    CountryCode["FI"] = "fi";
    CountryCode["FJ"] = "fj";
    CountryCode["FK"] = "fk";
    CountryCode["FM"] = "fm";
    CountryCode["FO"] = "fo";
    CountryCode["FR"] = "fr";
    CountryCode["GA"] = "ga";
    CountryCode["GB"] = "gb";
    CountryCode["GD"] = "gd";
    CountryCode["GE"] = "ge";
    CountryCode["GF"] = "gf";
    CountryCode["GG"] = "gg";
    CountryCode["GH"] = "gh";
    CountryCode["GI"] = "gi";
    CountryCode["GL"] = "gl";
    CountryCode["GM"] = "gm";
    CountryCode["GN"] = "gn";
    CountryCode["GP"] = "gp";
    CountryCode["GQ"] = "gq";
    CountryCode["GR"] = "gr";
    CountryCode["GS"] = "gs";
    CountryCode["GT"] = "gt";
    CountryCode["GU"] = "gu";
    CountryCode["GW"] = "gw";
    CountryCode["GY"] = "gy";
    CountryCode["HK"] = "hk";
    CountryCode["HM"] = "hm";
    CountryCode["HN"] = "hn";
    CountryCode["HR"] = "hr";
    CountryCode["HT"] = "ht";
    CountryCode["HU"] = "hu";
    CountryCode["ID"] = "id";
    CountryCode["IE"] = "ie";
    CountryCode["IL"] = "il";
    CountryCode["IM"] = "im";
    CountryCode["IN"] = "in";
    CountryCode["IO"] = "io";
    CountryCode["IQ"] = "iq";
    CountryCode["IR"] = "ir";
    CountryCode["IS"] = "is";
    CountryCode["IT"] = "it";
    CountryCode["JE"] = "je";
    CountryCode["JM"] = "jm";
    CountryCode["JO"] = "jo";
    CountryCode["JP"] = "jp";
    CountryCode["KE"] = "ke";
    CountryCode["KG"] = "kg";
    CountryCode["KH"] = "kh";
    CountryCode["KI"] = "ki";
    CountryCode["KM"] = "km";
    CountryCode["KN"] = "kn";
    CountryCode["KP"] = "kp";
    CountryCode["KR"] = "kr";
    CountryCode["KW"] = "kw";
    CountryCode["KY"] = "ky";
    CountryCode["KZ"] = "kz";
    CountryCode["LA"] = "la";
    CountryCode["LB"] = "lb";
    CountryCode["LC"] = "lc";
    CountryCode["LI"] = "li";
    CountryCode["LK"] = "lk";
    CountryCode["LR"] = "lr";
    CountryCode["LS"] = "ls";
    CountryCode["LT"] = "lt";
    CountryCode["LU"] = "lu";
    CountryCode["LV"] = "lv";
    CountryCode["LY"] = "ly";
    CountryCode["MA"] = "ma";
    CountryCode["MC"] = "mc";
    CountryCode["MD"] = "md";
    CountryCode["ME"] = "me";
    CountryCode["MF"] = "mf";
    CountryCode["MG"] = "mg";
    CountryCode["MH"] = "mh";
    CountryCode["MK"] = "mk";
    CountryCode["ML"] = "ml";
    CountryCode["MM"] = "mm";
    CountryCode["MN"] = "mn";
    CountryCode["MO"] = "mo";
    CountryCode["MP"] = "mp";
    CountryCode["MQ"] = "mq";
    CountryCode["MR"] = "mr";
    CountryCode["MS"] = "ms";
    CountryCode["MT"] = "mt";
    CountryCode["MU"] = "mu";
    CountryCode["MV"] = "mv";
    CountryCode["MW"] = "mw";
    CountryCode["MX"] = "mx";
    CountryCode["MY"] = "my";
    CountryCode["MZ"] = "mz";
    CountryCode["NA"] = "na";
    CountryCode["NC"] = "nc";
    CountryCode["NE"] = "ne";
    CountryCode["NF"] = "nf";
    CountryCode["NG"] = "ng";
    CountryCode["NI"] = "ni";
    CountryCode["NL"] = "nl";
    CountryCode["NO"] = "no";
    CountryCode["NP"] = "np";
    CountryCode["NR"] = "nr";
    CountryCode["NU"] = "nu";
    CountryCode["NZ"] = "nz";
    CountryCode["OM"] = "om";
    CountryCode["PA"] = "pa";
    CountryCode["PE"] = "pe";
    CountryCode["PF"] = "pf";
    CountryCode["PG"] = "pg";
    CountryCode["PH"] = "ph";
    CountryCode["PK"] = "pk";
    CountryCode["PL"] = "pl";
    CountryCode["PM"] = "pm";
    CountryCode["PN"] = "pn";
    CountryCode["PR"] = "pr";
    CountryCode["PS"] = "ps";
    CountryCode["PT"] = "pt";
    CountryCode["PW"] = "pw";
    CountryCode["PY"] = "py";
    CountryCode["QA"] = "qa";
    CountryCode["RE"] = "re";
    CountryCode["RO"] = "ro";
    CountryCode["RS"] = "rs";
    CountryCode["RU"] = "ru";
    CountryCode["RW"] = "rw";
    CountryCode["SA"] = "sa";
    CountryCode["SB"] = "sb";
    CountryCode["SC"] = "sc";
    CountryCode["SD"] = "sd";
    CountryCode["SE"] = "se";
    CountryCode["SG"] = "sg";
    CountryCode["SH"] = "sh";
    CountryCode["SI"] = "si";
    CountryCode["SJ"] = "sj";
    CountryCode["SK"] = "sk";
    CountryCode["SL"] = "sl";
    CountryCode["SM"] = "sm";
    CountryCode["SN"] = "sn";
    CountryCode["SO"] = "so";
    CountryCode["SR"] = "sr";
    CountryCode["SS"] = "ss";
    CountryCode["ST"] = "st";
    CountryCode["SV"] = "sv";
    CountryCode["SX"] = "sx";
    CountryCode["SY"] = "sy";
    CountryCode["SZ"] = "sz";
    CountryCode["TC"] = "tc";
    CountryCode["TD"] = "td";
    CountryCode["TF"] = "tf";
    CountryCode["TG"] = "tg";
    CountryCode["TH"] = "th";
    CountryCode["TJ"] = "tj";
    CountryCode["TK"] = "tk";
    CountryCode["TL"] = "tl";
    CountryCode["TM"] = "tm";
    CountryCode["TN"] = "tn";
    CountryCode["TO"] = "to";
    CountryCode["TR"] = "tr";
    CountryCode["TT"] = "tt";
    CountryCode["TV"] = "tv";
    CountryCode["TW"] = "tw";
    CountryCode["TZ"] = "tz";
    CountryCode["UA"] = "ua";
    CountryCode["UG"] = "ug";
    CountryCode["UM"] = "um";
    CountryCode["US"] = "us";
    CountryCode["UY"] = "uy";
    CountryCode["UZ"] = "uz";
    CountryCode["VA"] = "va";
    CountryCode["VC"] = "vc";
    CountryCode["VE"] = "ve";
    CountryCode["VG"] = "vg";
    CountryCode["VI"] = "vi";
    CountryCode["VN"] = "vn";
    CountryCode["VU"] = "vu";
    CountryCode["WF"] = "wf";
    CountryCode["WS"] = "ws";
    CountryCode["XK"] = "xk";
    CountryCode["YE"] = "ye";
    CountryCode["YT"] = "yt";
    CountryCode["ZA"] = "za";
    CountryCode["ZM"] = "zm";
    CountryCode["ZW"] = "zw";
})(CountryCode || (CountryCode = {}));

var RegionCode;
(function (RegionCode) {
    RegionCode["AFRICA"] = "af";
    RegionCode["ANTARCTICA"] = "an";
    RegionCode["ASIA"] = "as";
    RegionCode["EUROPEAN_UNION"] = "eu";
    RegionCode["NORTH_AMERICA"] = "na";
    RegionCode["OCEANIA"] = "os";
    RegionCode["REST_OF_EUROPEAN_UNION"] = "roeu";
    RegionCode["SOUTH_AMERICA"] = "sa";
})(RegionCode || (RegionCode = {}));

const countryListByRegion = {
    [RegionCode.AFRICA]: [CountryCode.DZ, CountryCode.AO, CountryCode.BJ, CountryCode.BW, CountryCode.BF, CountryCode.BI, CountryCode.KM, CountryCode.TD, CountryCode.ZA, CountryCode.SS, CountryCode.DJ, CountryCode.GQ, CountryCode.EG, CountryCode.CI, CountryCode.ER, CountryCode.ET, CountryCode.GA, CountryCode.GM, CountryCode.GH, CountryCode.GN, CountryCode.GW, CountryCode.CM, CountryCode.KE, CountryCode.CG, CountryCode.CD, CountryCode.CF, CountryCode.LS, CountryCode.LR, CountryCode.LY, CountryCode.MG, CountryCode.MW, CountryCode.ML, CountryCode.MA, CountryCode.MR, CountryCode.MU, CountryCode.YT, CountryCode.MZ, CountryCode.NA, CountryCode.NE, CountryCode.NG, CountryCode.RE, CountryCode.RW, CountryCode.ST, CountryCode.SC, CountryCode.SL, CountryCode.EH, CountryCode.SH, CountryCode.SN, CountryCode.SO, CountryCode.SD, CountryCode.SZ, CountryCode.TZ, CountryCode.TG, CountryCode.TN, CountryCode.UG, CountryCode.ZM, CountryCode.ZW, CountryCode.CV],
    [RegionCode.ANTARCTICA]: [CountryCode.AQ, CountryCode.GS, CountryCode.TF],
    [RegionCode.ASIA]: [CountryCode.AF, CountryCode.AZ, CountryCode.BH, CountryCode.BD, CountryCode.BT, CountryCode.IO, CountryCode.BN, CountryCode.KR, CountryCode.AE, CountryCode.KP, CountryCode.PH, CountryCode.GE, CountryCode.HK, CountryCode.IN, CountryCode.ID, CountryCode.IQ, CountryCode.IR, CountryCode.IL, CountryCode.JP, CountryCode.YE, CountryCode.JO, CountryCode.KH, CountryCode.CX, CountryCode.QA, CountryCode.KZ, CountryCode.TL, CountryCode.CN, CountryCode.KG, CountryCode.CC, CountryCode.KW, CountryCode.LA, CountryCode.LB, CountryCode.MO, CountryCode.MY, CountryCode.MV, CountryCode.MM, CountryCode.MN, CountryCode.NP, CountryCode.OM, CountryCode.AM, CountryCode.PK, CountryCode.PS, CountryCode.LK, CountryCode.SA, CountryCode.SG, CountryCode.SY, CountryCode.TJ, CountryCode.TW, CountryCode.TH, CountryCode.TR, CountryCode.TM, CountryCode.UZ, CountryCode.VN],
    [RegionCode.EUROPEAN_UNION]: [CountryCode.AT, CountryCode.BE, CountryCode.BG, CountryCode.CY, CountryCode.CZ, CountryCode.DK, CountryCode.EE, CountryCode.FI, CountryCode.FR, CountryCode.GR, CountryCode.NL, CountryCode.HR, CountryCode.IE, CountryCode.PL, CountryCode.LV, CountryCode.LT, CountryCode.LU, CountryCode.HU, CountryCode.MT, CountryCode.DE, CountryCode.IT, CountryCode.PT, CountryCode.RO, CountryCode.ES, CountryCode.SE, CountryCode.SK, CountryCode.SI],
    [RegionCode.NORTH_AMERICA]: [CountryCode.US, CountryCode.VI, CountryCode.AI, CountryCode.AG, CountryCode.AW, CountryCode.BS, CountryCode.BB, CountryCode.BZ, CountryCode.BM, CountryCode.VG, CountryCode.CR, CountryCode.CW, CountryCode.DM, CountryCode.DO, CountryCode.GD, CountryCode.GL, CountryCode.GP, CountryCode.GT, CountryCode.HT, CountryCode.BQ, CountryCode.HN, CountryCode.JM, CountryCode.KY, CountryCode.CA, CountryCode.CU, CountryCode.MQ, CountryCode.MX, CountryCode.MS, CountryCode.NI, CountryCode.PA, CountryCode.PR, CountryCode.BL, CountryCode.KN, CountryCode.LC, CountryCode.MF, CountryCode.VC, CountryCode.SV, CountryCode.SX, CountryCode.PM, CountryCode.TT, CountryCode.TC],
    [RegionCode.OCEANIA]: [CountryCode.AS, CountryCode.AU, CountryCode.CK, CountryCode.MP, CountryCode.FJ, CountryCode.PF, CountryCode.GU, CountryCode.KI, CountryCode.MH, CountryCode.FM, CountryCode.NR, CountryCode.NU, CountryCode.NF, CountryCode.WS, CountryCode.PW, CountryCode.PG, CountryCode.PN, CountryCode.SB, CountryCode.TK, CountryCode.TO, CountryCode.TV, CountryCode.NC, CountryCode.NZ, CountryCode.VU, CountryCode.WF],
    [RegionCode.REST_OF_EUROPEAN_UNION]: [CountryCode.AX, CountryCode.AL, CountryCode.AD, CountryCode.BY, CountryCode.BA, CountryCode.GB, CountryCode.FO, CountryCode.GI, CountryCode.GG, CountryCode.IS, CountryCode.JE, CountryCode.XK, CountryCode.LI, CountryCode.MK, CountryCode.IM, CountryCode.MD, CountryCode.MC, CountryCode.ME, CountryCode.NO, CountryCode.RU, CountryCode.SM, CountryCode.CH, CountryCode.SJ, CountryCode.RS, CountryCode.UA, CountryCode.VA],
    [RegionCode.SOUTH_AMERICA]: [CountryCode.AR, CountryCode.BO, CountryCode.BR, CountryCode.CL, CountryCode.EC, CountryCode.FK, CountryCode.GF, CountryCode.GY, CountryCode.CO, CountryCode.PY, CountryCode.PE, CountryCode.SR, CountryCode.UY, CountryCode.VE],
};

var DateTimeFormat;
(function (DateTimeFormat) {
    DateTimeFormat["TIME_MED"] = "time_medium";
    DateTimeFormat["TIME_DAY"] = "time_day";
    DateTimeFormat["DAY_MED"] = "day_short";
    DateTimeFormat["DAY_OF_MONTH"] = "day_of_month";
    DateTimeFormat["DAY_NAME_MED"] = "day_name_medium";
    DateTimeFormat["YEAR_MONTH_FULL"] = "year_month_full";
    DateTimeFormat["YEAR_MONTH_MED"] = "year_month_med";
    DateTimeFormat["DATE_SHORT"] = "date_short";
    DateTimeFormat["DATE_MED"] = "date_medium";
    DateTimeFormat["DATE_FULL"] = "date_full";
    DateTimeFormat["DATE_HUGE"] = "date_huge";
    DateTimeFormat["DATE_MONTH"] = "date_month";
    DateTimeFormat["DATE_MONTH_SHORT"] = "date_month_short";
    DateTimeFormat["DATE_DAY"] = "date_day";
    DateTimeFormat["DATETIME_SHORT_WITHOUT_YEAR"] = "datetime_short_without_year";
    DateTimeFormat["DATETIME_SHORT_WITH_SEC"] = "datetime_short_with_sec";
    DateTimeFormat["DATETIME_SHORT"] = "datetime_short";
    DateTimeFormat["DATETIME_MED"] = "datetime_medium";
    DateTimeFormat["DATETIME_FULL"] = "datetime_full";
    DateTimeFormat["DATETIME_HUGE"] = "datetime_huge";
    DateTimeFormat["DATETIME_OFFSET"] = "datetime_offset";
})(DateTimeFormat || (DateTimeFormat = {}));

var LanguageCode;
(function (LanguageCode) {
    LanguageCode["HU"] = "hu";
    LanguageCode["EN"] = "en";
    LanguageCode["DA"] = "da";
    LanguageCode["PL"] = "pl";
    LanguageCode["SK"] = "sk";
    LanguageCode["IT"] = "it";
    LanguageCode["FR"] = "fr";
    LanguageCode["DE"] = "de";
})(LanguageCode || (LanguageCode = {}));

/**
 * Names and format tokens by Luxon
 * {@link} https://moment.github.io/luxon/docs/manual/formatting.html
 */
const DATE_TIME_FORMATS = {
    [LanguageCode.DA]: {
        [DateTimeFormat.TIME_MED]: 'HH:mm',
        [DateTimeFormat.TIME_DAY]: 'cccc HH:mm',
        [DateTimeFormat.DAY_MED]: 'LLL d',
        [DateTimeFormat.DAY_OF_MONTH]: 'dd',
        [DateTimeFormat.DAY_NAME_MED]: 'ccc',
        [DateTimeFormat.YEAR_MONTH_FULL]: 'LLLL y',
        [DateTimeFormat.YEAR_MONTH_MED]: 'LLL y',
        [DateTimeFormat.DATE_SHORT]: 'D',
        [DateTimeFormat.DATE_MED]: 'DD',
        [DateTimeFormat.DATE_FULL]: 'DDD',
        [DateTimeFormat.DATE_HUGE]: 'DDDD',
        [DateTimeFormat.DATE_MONTH]: 'LLLL',
        [DateTimeFormat.DATE_MONTH_SHORT]: 'LLL',
        [DateTimeFormat.DATE_DAY]: 'dd',
        [DateTimeFormat.DATETIME_SHORT_WITHOUT_YEAR]: 'dd. LLL HH:mm',
        [DateTimeFormat.DATETIME_SHORT]: 'D HH:mm',
        [DateTimeFormat.DATETIME_SHORT_WITH_SEC]: 'D HH:mm:ss',
        [DateTimeFormat.DATETIME_MED]: 'dd. LLL y HH:mm',
        [DateTimeFormat.DATETIME_FULL]: 'dd. LLLL y HH:mm',
        [DateTimeFormat.DATETIME_HUGE]: 'cccc dd. LLLL y HH:mm',
        [DateTimeFormat.DATETIME_OFFSET]: `'GMT'Z`, // GMT+0
    },
    [LanguageCode.HU]: {
        [DateTimeFormat.TIME_MED]: 't',
        [DateTimeFormat.TIME_DAY]: 'cccc HH:mm',
        [DateTimeFormat.DAY_MED]: 'LLL d',
        [DateTimeFormat.DAY_OF_MONTH]: 'dd',
        [DateTimeFormat.DAY_NAME_MED]: 'ccc',
        [DateTimeFormat.YEAR_MONTH_FULL]: 'y LLLL',
        [DateTimeFormat.YEAR_MONTH_MED]: 'y LLL',
        [DateTimeFormat.DATE_SHORT]: 'D',
        [DateTimeFormat.DATE_MED]: 'DD',
        [DateTimeFormat.DATE_FULL]: 'DDD',
        [DateTimeFormat.DATE_HUGE]: 'DDDD',
        [DateTimeFormat.DATE_MONTH]: 'LLLL',
        [DateTimeFormat.DATE_MONTH_SHORT]: 'LLL',
        [DateTimeFormat.DATE_DAY]: 'dd',
        [DateTimeFormat.DATETIME_SHORT_WITHOUT_YEAR]: 'LLL dd. t',
        [DateTimeFormat.DATETIME_SHORT]: 'f',
        [DateTimeFormat.DATETIME_SHORT_WITH_SEC]: 'F',
        [DateTimeFormat.DATETIME_MED]: 'ff',
        [DateTimeFormat.DATETIME_FULL]: 'DDD t',
        [DateTimeFormat.DATETIME_HUGE]: 'DDDD t',
        [DateTimeFormat.DATETIME_OFFSET]: `'GMT'Z`, // GMT+0
    },
    [LanguageCode.EN]: {
        [DateTimeFormat.TIME_MED]: 't',
        [DateTimeFormat.TIME_DAY]: 'cccc t',
        [DateTimeFormat.DAY_MED]: 'LLL d',
        [DateTimeFormat.DAY_OF_MONTH]: 'dd',
        [DateTimeFormat.DAY_NAME_MED]: 'ccc',
        [DateTimeFormat.YEAR_MONTH_FULL]: 'LLLL y',
        [DateTimeFormat.YEAR_MONTH_MED]: 'LLL y',
        [DateTimeFormat.DATE_SHORT]: 'D',
        [DateTimeFormat.DATE_MED]: 'DD',
        [DateTimeFormat.DATE_FULL]: 'DDD',
        [DateTimeFormat.DATE_HUGE]: 'DDDD',
        [DateTimeFormat.DATE_MONTH]: 'LLLL',
        [DateTimeFormat.DATE_MONTH_SHORT]: 'LLL',
        [DateTimeFormat.DATE_DAY]: 'dd',
        [DateTimeFormat.DATETIME_SHORT_WITHOUT_YEAR]: 'LLL dd. t',
        [DateTimeFormat.DATETIME_SHORT]: 'f',
        [DateTimeFormat.DATETIME_SHORT_WITH_SEC]: 'F',
        [DateTimeFormat.DATETIME_MED]: 'ff',
        [DateTimeFormat.DATETIME_FULL]: 'DDD t',
        [DateTimeFormat.DATETIME_HUGE]: 'DDDD t',
        [DateTimeFormat.DATETIME_OFFSET]: `'GMT'Z`, // GMT+0
    },
    [LanguageCode.PL]: {
        [DateTimeFormat.TIME_MED]: 't',
        [DateTimeFormat.TIME_DAY]: 'cccc t',
        [DateTimeFormat.DAY_MED]: 'LLL d',
        [DateTimeFormat.DAY_OF_MONTH]: 'dd',
        [DateTimeFormat.DAY_NAME_MED]: 'ccc',
        [DateTimeFormat.YEAR_MONTH_FULL]: 'LLLL y',
        [DateTimeFormat.YEAR_MONTH_MED]: 'LLL y',
        [DateTimeFormat.DATE_SHORT]: 'D',
        [DateTimeFormat.DATE_MED]: 'DD',
        [DateTimeFormat.DATE_FULL]: 'DDD',
        [DateTimeFormat.DATE_HUGE]: 'DDDD',
        [DateTimeFormat.DATE_MONTH]: 'LLLL',
        [DateTimeFormat.DATE_MONTH_SHORT]: 'LLL',
        [DateTimeFormat.DATE_DAY]: 'dd',
        [DateTimeFormat.DATETIME_SHORT_WITHOUT_YEAR]: 'LLL dd. t',
        [DateTimeFormat.DATETIME_SHORT]: 'f',
        [DateTimeFormat.DATETIME_SHORT_WITH_SEC]: 'F',
        [DateTimeFormat.DATETIME_MED]: 'ff',
        [DateTimeFormat.DATETIME_FULL]: 'DDD t',
        [DateTimeFormat.DATETIME_HUGE]: 'DDDD t',
        [DateTimeFormat.DATETIME_OFFSET]: `'GMT'Z`, // GMT+0
    },
    [LanguageCode.IT]: {
        [DateTimeFormat.TIME_MED]: 't',
        [DateTimeFormat.TIME_DAY]: 'cccc t',
        [DateTimeFormat.DAY_MED]: 'LLL d',
        [DateTimeFormat.DAY_OF_MONTH]: 'dd',
        [DateTimeFormat.DAY_NAME_MED]: 'ccc',
        [DateTimeFormat.YEAR_MONTH_FULL]: 'LLLL y',
        [DateTimeFormat.YEAR_MONTH_MED]: 'LLL y',
        [DateTimeFormat.DATE_SHORT]: 'D',
        [DateTimeFormat.DATE_MED]: 'DD',
        [DateTimeFormat.DATE_FULL]: 'DDD',
        [DateTimeFormat.DATE_HUGE]: 'DDDD',
        [DateTimeFormat.DATE_MONTH]: 'LLLL',
        [DateTimeFormat.DATE_MONTH_SHORT]: 'LLL',
        [DateTimeFormat.DATE_DAY]: 'dd',
        [DateTimeFormat.DATETIME_SHORT_WITHOUT_YEAR]: 'LLL dd. t',
        [DateTimeFormat.DATETIME_SHORT]: 'f',
        [DateTimeFormat.DATETIME_SHORT_WITH_SEC]: 'F',
        [DateTimeFormat.DATETIME_MED]: 'ff',
        [DateTimeFormat.DATETIME_FULL]: 'DDD t',
        [DateTimeFormat.DATETIME_HUGE]: 'DDDD t',
        [DateTimeFormat.DATETIME_OFFSET]: `'GMT'Z`, // GMT+0
    },
    [LanguageCode.SK]: {
        [DateTimeFormat.TIME_MED]: 't',
        [DateTimeFormat.TIME_DAY]: 'cccc t',
        [DateTimeFormat.DAY_MED]: 'LLL d',
        [DateTimeFormat.DAY_OF_MONTH]: 'dd',
        [DateTimeFormat.DAY_NAME_MED]: 'ccc',
        [DateTimeFormat.YEAR_MONTH_FULL]: 'LLLL y',
        [DateTimeFormat.YEAR_MONTH_MED]: 'LLL y',
        [DateTimeFormat.DATE_SHORT]: 'D',
        [DateTimeFormat.DATE_MED]: 'DD',
        [DateTimeFormat.DATE_FULL]: 'DDD',
        [DateTimeFormat.DATE_HUGE]: 'DDDD',
        [DateTimeFormat.DATE_MONTH]: 'LLLL',
        [DateTimeFormat.DATE_MONTH_SHORT]: 'LLL',
        [DateTimeFormat.DATE_DAY]: 'dd',
        [DateTimeFormat.DATETIME_SHORT_WITHOUT_YEAR]: 'LLL dd. t',
        [DateTimeFormat.DATETIME_SHORT]: 'f',
        [DateTimeFormat.DATETIME_SHORT_WITH_SEC]: 'F',
        [DateTimeFormat.DATETIME_MED]: 'ff',
        [DateTimeFormat.DATETIME_FULL]: 'DDD t',
        [DateTimeFormat.DATETIME_HUGE]: 'DDDD t',
        [DateTimeFormat.DATETIME_OFFSET]: `'GMT'Z`, // GMT+0
    },
    [LanguageCode.FR]: {
        [DateTimeFormat.TIME_MED]: 't',
        [DateTimeFormat.TIME_DAY]: 'cccc t',
        [DateTimeFormat.DAY_MED]: 'LLL d',
        [DateTimeFormat.DAY_OF_MONTH]: 'dd',
        [DateTimeFormat.DAY_NAME_MED]: 'ccc',
        [DateTimeFormat.YEAR_MONTH_FULL]: 'LLLL y',
        [DateTimeFormat.YEAR_MONTH_MED]: 'LLL y',
        [DateTimeFormat.DATE_SHORT]: 'D',
        [DateTimeFormat.DATE_MED]: 'DD',
        [DateTimeFormat.DATE_FULL]: 'DDD',
        [DateTimeFormat.DATE_HUGE]: 'DDDD',
        [DateTimeFormat.DATE_MONTH]: 'LLLL',
        [DateTimeFormat.DATE_MONTH_SHORT]: 'LLL',
        [DateTimeFormat.DATE_DAY]: 'dd',
        [DateTimeFormat.DATETIME_SHORT_WITHOUT_YEAR]: 'LLL dd. t',
        [DateTimeFormat.DATETIME_SHORT]: 'f',
        [DateTimeFormat.DATETIME_SHORT_WITH_SEC]: 'F',
        [DateTimeFormat.DATETIME_MED]: 'ff',
        [DateTimeFormat.DATETIME_FULL]: 'DDD t',
        [DateTimeFormat.DATETIME_HUGE]: 'DDDD t',
        [DateTimeFormat.DATETIME_OFFSET]: `'GMT'Z`, // GMT+0
    },
    [LanguageCode.DE]: {
        [DateTimeFormat.TIME_MED]: 't',
        [DateTimeFormat.TIME_DAY]: 'cccc t',
        [DateTimeFormat.DAY_MED]: 'LLL d',
        [DateTimeFormat.DAY_OF_MONTH]: 'dd',
        [DateTimeFormat.DAY_NAME_MED]: 'ccc',
        [DateTimeFormat.YEAR_MONTH_FULL]: 'LLLL y',
        [DateTimeFormat.YEAR_MONTH_MED]: 'LLL y',
        [DateTimeFormat.DATE_SHORT]: 'D',
        [DateTimeFormat.DATE_MED]: 'DD',
        [DateTimeFormat.DATE_FULL]: 'DDD',
        [DateTimeFormat.DATE_HUGE]: 'DDDD',
        [DateTimeFormat.DATE_MONTH]: 'LLLL',
        [DateTimeFormat.DATE_MONTH_SHORT]: 'LLL',
        [DateTimeFormat.DATE_DAY]: 'dd',
        [DateTimeFormat.DATETIME_SHORT_WITHOUT_YEAR]: 'LLL dd. t',
        [DateTimeFormat.DATETIME_SHORT]: 'f',
        [DateTimeFormat.DATETIME_SHORT_WITH_SEC]: 'F',
        [DateTimeFormat.DATETIME_MED]: 'ff',
        [DateTimeFormat.DATETIME_FULL]: 'DDD t',
        [DateTimeFormat.DATETIME_HUGE]: 'DDDD t',
        [DateTimeFormat.DATETIME_OFFSET]: `'GMT'Z`, // GMT+1
    },
};

var ContinentCode;
(function (ContinentCode) {
    ContinentCode["AFRICA"] = "af";
    ContinentCode["ANTARCTICA"] = "an";
    ContinentCode["ASIA"] = "as";
    ContinentCode["EUROPE"] = "eu";
    ContinentCode["NORTH_AMERICA"] = "na";
    ContinentCode["OCEANIA"] = "os";
    ContinentCode["SOUTH_AMERICA"] = "sa";
})(ContinentCode || (ContinentCode = {}));

var FileExtension;
(function (FileExtension) {
    FileExtension["JPG"] = "jpg";
    FileExtension["GIF"] = "gif";
    FileExtension["PNG"] = "png";
    FileExtension["ICO"] = "ico";
})(FileExtension || (FileExtension = {}));

var Currency;
(function (Currency) {
    Currency["HUF"] = "HUF";
    Currency["EUR"] = "EUR";
    Currency["USD"] = "USD";
    Currency["DKK"] = "DKK";
    Currency["PLN"] = "PLN";
})(Currency || (Currency = {}));

/**
 * Source: https://www.iana.org/time-zones
 */
var TimeZone;
(function (TimeZone) {
    TimeZone["HU"] = "Europe/Budapest";
    TimeZone["GB"] = "Europe/London";
    TimeZone["DK"] = "Europe/Copenhagen";
    TimeZone["SK"] = "Europe/Bratislava";
    TimeZone["PL"] = "Europe/Warsaw";
    TimeZone["DE"] = "Europe/Berlin";
    TimeZone["MT"] = "Europe/Malta";
    TimeZone["CY"] = "Europe/Nicosia";
    TimeZone["US_NY"] = "America/New_York";
    TimeZone["LOCAL"] = "system"; // default zone of luxon
})(TimeZone || (TimeZone = {}));

var BoxofficePaymentMethod;
(function (BoxofficePaymentMethod) {
    BoxofficePaymentMethod["CARD"] = "CreditCard";
    BoxofficePaymentMethod["CASH"] = "Cash";
    BoxofficePaymentMethod["FREE"] = "Free";
    BoxofficePaymentMethod["SHOPBOX"] = "Shopbox";
})(BoxofficePaymentMethod || (BoxofficePaymentMethod = {}));

var CustomerDataField;
(function (CustomerDataField) {
    CustomerDataField["ZIP_CODE"] = "zipCode";
})(CustomerDataField || (CustomerDataField = {}));

var InvoiceProviderName;
(function (InvoiceProviderName) {
    InvoiceProviderName["SZAMLAZZ_HU"] = "sz\u00E1ml\u00E1zz.hu";
})(InvoiceProviderName || (InvoiceProviderName = {}));

var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["REQUIRED"] = "Required";
    InvoiceStatus["DISABLED"] = "Disabled";
})(InvoiceStatus || (InvoiceStatus = {}));

var OnlinePaymentMethod;
(function (OnlinePaymentMethod) {
    OnlinePaymentMethod["PAYU"] = "PayU";
    OnlinePaymentMethod["QUICKPAY"] = "QuickPay";
    OnlinePaymentMethod["STRIPE"] = "Stripe";
    OnlinePaymentMethod["OTP_SIMPLE"] = "OtpSimple";
    OnlinePaymentMethod["CIB"] = "Cib";
    OnlinePaymentMethod["FREE"] = "Free";
    OnlinePaymentMethod["ST4GIFTCARD"] = "St4GiftCard";
    OnlinePaymentMethod["SHOPBOX"] = "Shopbox";
})(OnlinePaymentMethod || (OnlinePaymentMethod = {}));

var PartnerType;
(function (PartnerType) {
    PartnerType["PLATFORM_PROVIDER"] = "PlatformProvider";
    PartnerType["REGION_PARTNER"] = "RegionPartner";
    PartnerType["PARTNER"] = "Partner";
})(PartnerType || (PartnerType = {}));

var PublicPageTemplate;
(function (PublicPageTemplate) {
    PublicPageTemplate["DEFAULT"] = "default";
    PublicPageTemplate["JEGY_HU"] = "jegy-hu";
})(PublicPageTemplate || (PublicPageTemplate = {}));

const COUNTRY_LIST = [
    { code: CountryCode.HU, label: 'label_country_hu' },
    { code: CountryCode.GB, label: 'label_country_gb' },
    { code: CountryCode.DE, label: 'label_country_de' },
    { code: CountryCode.PL, label: 'label_country_pl' },
    { code: CountryCode.DK, label: 'label_country_dk' },
    { code: CountryCode.SK, label: 'label_country_sk' },
];

const GENERAL_CONFIG = {
    availablePaymentMethods: [
        OnlinePaymentMethod.PAYU,
        OnlinePaymentMethod.QUICKPAY,
        OnlinePaymentMethod.STRIPE,
        OnlinePaymentMethod.OTP_SIMPLE,
        OnlinePaymentMethod.CIB,
        OnlinePaymentMethod.SHOPBOX,
    ],
    countries: COUNTRY_LIST,
    defaultCountryCode: COUNTRY_LIST[0].code,
    defaultCurrency: Currency.EUR,
    defaultTimezone: TimeZone.GB,
    defaultLanguageCode: LanguageCode.HU,
    supportedLanguages: [
        LanguageCode.EN,
        LanguageCode.HU,
        LanguageCode.DA,
    ],
    enabledPaymentMethods: [
        OnlinePaymentMethod.PAYU,
        OnlinePaymentMethod.QUICKPAY,
        OnlinePaymentMethod.STRIPE,
        OnlinePaymentMethod.OTP_SIMPLE,
        OnlinePaymentMethod.CIB,
        OnlinePaymentMethod.SHOPBOX,
    ],
    stem4GiftcardEnabled: false,
    multipleOnlineContentAccess: true,
    defaultEventDuration: 60,
    defaultTaxId: 'eb9bd637-faa9-44d0-a470-03d331ee194a',
    defaultSubCategories: [
        '08a25033-f61d-4141-b772-e5be1efef28c',
        '4379b2ad-0082-4783-94b8-1c5c92ecfb16',
        'a6ff7ac2-2103-4215-af6a-18c6be36c22c',
        '831818db-a5c2-418d-a236-d6eebfece681',
        '5a26d381-8396-43b7-b256-57ab20532a5d',
    ],
    showEventTypeInProgramPages: true,
};

const CARD_CONFIG = {
    hasActive: true,
};

const PARTNER_THEME = {
    coverImage: 'b63eaaeb-58f0-4462-946e-b3cc11c78418',
    darkThemeFooterLogoId: '',
    darkThemeLogoId: '',
    footerLogoId: '7a566407-111f-4ae8-9dfa-9348ffcfd709',
    id: 'c0a23c8f-b1b1-4bf4-a356-248650d3a0f6',
    logoId: '54e69687-fcb6-4435-aaa0-5c42f4737522',
    name: 'Jegy.hu design',
    primaryColor: '#ff5700',
    secondaryColor: '#000',
    showVenueMap: false,
    slug: 'jegy-hu-design',
    template: PublicPageTemplate.JEGY_HU,
    termsLink: 'https://www.jegy.hu/articles/655/adatkezelesi-tajekoztato',
};
const PARTNER_THEME_LIST = [
    ...[PARTNER_THEME],
    {
        coverImage: '',
        darkThemeFooterLogoId: '',
        darkThemeLogoId: '',
        footerLogoId: '7a566407-111f-4ae8-9dfa-9348ffcfd709',
        id: '896d117e-bf74-4d52-a929-eb5ac034718b',
        logoId: '6e1c7880-0e52-453b-ab5a-e7447dd4f77c',
        name: 'InterTicket design',
        primaryColor: '#07f',
        secondaryColor: '#4d4d4d',
        showVenueMap: true,
        slug: 'interticket-design',
        template: PublicPageTemplate.DEFAULT,
        termsLink: '/contact/terms',
    },
];

const WEB_CONFIG = {
    displayAvailableTicketNumberTimeslot: true,
    displayAvailableTicketNumberRecurring: false,
    theme: PARTNER_THEME_LIST[1],
    partnerPageDomain: 'usa-qa.stx.interticket.com',
    regionPartnerRootDomain: 'stx.interticket.com',
    regionPartnerPageDomain: '',
    faviconId: 'd4afb3ee-60e2-4678-aeb6-be61e68c30f7',
    tabText: 'Stenvs Klint',
    webSiteTitle: 'Stenvs Klint',
    shortDescription: 'Az Operaház a Nemzeti Múzeum és a Vigadó mellett Budapest legjelentősebb XIX. századi műemléke. Gazdag díszítés hangsúlyozza az épület reprezentatív funkcióját: a márványból készült előcsarnok és lépcsőház, a márványlapokkal burkolt falak, a szalonok intarziás padlója, a selyemtapéták, a nézőtér aranyvörös ragyogása, a mennyezeteket és oldalfalakat díszítő művészi falfestések és freskók. A patkó alakú, háromemeletes nézőtér lélegzetelállító térélményt ad.',
    footerLinks: [
        {
            label: 'stx_footer_menu_tc',
            url: 'https://corporate.interticket.com/terms/',
            targetBlank: false,
            id: 'footer-terms-link',
        },
        {
            label: 'stx_footer_menu_privacy',
            url: 'https://corporate.interticket.com/privacy-policy/',
            targetBlank: false,
            id: 'footer-privacy-link',
        },
        {
            label: 'stx_footer_menu_pricing',
            url: 'https://corporate.interticket.com/pricing/',
            targetBlank: false,
            id: 'footer-pricing-link',
        },
        {
            label: 'stx_footer_menu_about',
            url: 'https://corporate.interticket.com/why/',
            targetBlank: false,
            id: 'footer-about-link',
        },
        {
            label: 'stx_footer_menu_signup',
            url: 'https://corporate.interticket.com/signup/',
            targetBlank: false,
            id: 'footer-streaming-link',
        },
    ],
};

const PARTNER_CONFIG = {
    general: GENERAL_CONFIG,
    partnerId: 'd7d4146e-4dbc-4390-9463-55e25297c437',
    partnerName: 'Interticket Mock Partner',
    partnerType: PartnerType.PARTNER,
    invoicing: {
        provider: {
            id: '84aaa217-ef0a-4af7-a204-547b89eb47d1',
            name: InvoiceProviderName.SZAMLAZZ_HU,
        },
        status: InvoiceStatus.REQUIRED,
    },
    localization: {
        customerDataFields: [
            CustomerDataField.ZIP_CODE,
        ],
        displayCalendar: false,
        displayTimezone: false,
    },
    web: WEB_CONFIG,
    card: CARD_CONFIG,
};

const PARTNER_WEB_CONFIG = {
    themes: PARTNER_THEME_LIST,
};

class UtilString {
    static truncate(string, limit, suffix = '...') {
        return string.length > limit ? string.slice(0, limit - suffix.length).trim() + suffix : string;
    }
    static concat(string, concatString, limit) {
        const fullString = string.concat(concatString);
        return fullString.length <= limit ? fullString : string;
    }
    static capitalize(string) {
        return string?.charAt(0).toUpperCase() + string?.slice(1);
    }
    static normalize(string) {
        return string?.normalize('NFD')?.replace(new RegExp('[\u0300-\u036f]', 'g'), '');
    }
    static include(stringA, stringB) {
        return UtilString.normalize(stringA)?.toLowerCase().includes(UtilString.normalize(stringB)?.toLowerCase());
    }
    static trimChar(str, chars = '', side = 'both', space = true) {
        const charsEsc = chars.replace(/([.\\^$()?!=*+{}-])/g, '\\$1');
        let regexp = '';
        if (side !== 'right') {
            regexp += `^[${space ? '\\s' : ''}${charsEsc}]+`;
        }
        if (side === 'both') {
            regexp += '|';
        }
        if (side !== 'left') {
            regexp += `[${space ? '\\s' : ''}${charsEsc}]+$`;
        }
        return str.replace(new RegExp(regexp, 'g'), '');
    }
    /**
     * Slugify a string. For example from "Some str'ng!" to "some-strng"
     */
    static slugify(string) {
        return slugify(string, { lower: true, strict: true });
    }
    /**
     * Remove hash and double slashes from a string
     * @param inputStr string value to modify
     * @param searchValue string | RegExp - defaults to '#'
     * @returns string - without hash and double slashes or empty string if input is not a string
     */
    static removeHash(inputStr, searchValue = '#') {
        if (typeof inputStr !== 'string') {
            console.warn('Input value is not a string.');
            return '';
        }
        return inputStr
            .replace(searchValue, '')
            .replace(/\/\/+/g, '/');
    }
}

class Address {
    constructor(iAddress) {
        this.addressGuid = iAddress.addressGuid;
        this.type = iAddress.type;
        this.state = iAddress.state;
        this.country = iAddress.country;
        this.county = iAddress.county;
        this.zipCode = iAddress.zipCode;
        this.postalCode = iAddress.postalCode;
        this.city = iAddress.city;
        this.district = iAddress.district;
        this.street = iAddress.street;
        this.houseNumber = iAddress.houseNumber;
        this.building = iAddress.building;
        this.stairway = iAddress.stairway;
        this.floor = iAddress.floor;
        this.door = iAddress.door;
        this.comment = iAddress.comment;
        this.longitude = iAddress.longitude;
        this.latitude = iAddress.latitude;
        this.timezone = iAddress.timezone;
        this.natureOfPublicSpace = iAddress.natureOfPublicSpace;
        this.fullAddress = iAddress.fullAddress;
    }
    boundHU(floorStr) {
        let address = `${this.zipCode || ''} ${this.city || ''}`;
        if (this.fullAddress) {
            return UtilString.trimChar(`${address}, ${this.fullAddress}`, ',');
        }
        if (this.street) {
            address += `, ${this.street}`;
        }
        if (this.natureOfPublicSpace) {
            address += ` ${this.natureOfPublicSpace}`;
        }
        if (this.houseNumber) {
            address += ` ${this.houseNumber}`;
        }
        if (this.building) {
            address += ` ${this.building}`;
        }
        if (this.floor) {
            address += ` ${this.floor}. ${floorStr}`;
        }
        if (this.door) {
            address += ` ${this.door}`;
        }
        return UtilString.trimChar(address, ',');
    }
    boundEN(floorStr) {
        if (this.fullAddress) {
            return UtilString.trimChar(`${this.fullAddress}, ${this.city || ''} ${this.zipCode || ''}`, ',');
        }
        let address = '';
        if (this.door) {
            address += `${this.door} `;
        }
        if (this.floor) {
            address += `${this.floor}. ${floorStr} `;
        }
        address += ` ${this.houseNumber || ''}`;
        if (this.building) {
            address += `${this.building}`;
        }
        if (this.street) {
            if (this.natureOfPublicSpace) {
                address += ` ${this.street} ${this.natureOfPublicSpace},`;
            }
            else {
                address += ` ${this.street},`;
            }
        }
        address += ` ${this.city || ''} ${this.zipCode || ''}`;
        return UtilString.trimChar(address, ',');
    }
    boundDK(floorStr) {
        if (this.fullAddress) {
            return UtilString.trimChar(`${this.fullAddress}, ${this.zipCode || ''} ${this.city || ''}`, ',');
        }
        return UtilString.trimChar(`${this.street || ''} ${this.houseNumber || ''}, ${this.zipCode || ''} ${this.city || ''}`, ',');
    }
    isValid(requiredFields) {
        return requiredFields.some((field) => this[field]);
    }
    /**
     * Bound the address informations in the specified language format
     */
    bound(lang, floorStr = 'emelet') {
        switch (lang) {
            case LanguageCode.HU: return this.boundHU(floorStr);
            case LanguageCode.EN: return this.boundEN(floorStr);
            case LanguageCode.DA: return this.boundDK(floorStr);
            default: return this.boundEN(floorStr);
        }
    }
    /**
     * Bound the address data to display on Google Maps according to geocoder query format
     * {@link}: https://developers.google.com/maps/faq#geocoder_queryformat
     */
    boundForMap() {
        if (this.street && this.street.includes('+')) {
            return `${this.street}`;
        }
        let address = `${this.houseNumber}, ${this.street}, ${this.city}, ${this.zipCode}`;
        if (this.state) {
            address += `, ${this.state}`;
        }
        if (this.country) {
            address += `, ${this.country}`;
        }
        return address;
    }
}

class ApiErrorMessage {
    constructor(iMessage) {
        Object.assign(this, iMessage);
    }
}

/**
 * Creates an array of instances from an array of interfaces
 *
 * Returns an empty array if the input is not an array
 *
 * @method parseArray<T,K>
 */
const parseArray = (iArray, constructor) => Array.isArray(iArray) ? iArray.map((iItem) => new constructor(iItem)) : [];

class ApiError {
    constructor(iApiError) {
        this.correlationId = iApiError.correlationId;
        this.functionCode = iApiError.functionCode;
        this.messages = parseArray(iApiError.messages, ApiErrorMessage);
    }
    getErrorLabels() {
        return this.messages.map((message) => message.label);
    }
    getErrors() {
        return this.messages;
    }
}

class ApiErrorResponse extends HttpErrorResponse {
    constructor(httpResponse) {
        super(httpResponse);
        this.error = httpResponse.error ? new ApiError(httpResponse.error) : null;
    }
    getErrorLabels() {
        return this.error ? this.error.getErrorLabels() : [];
    }
    getErrors() {
        return this.error ? this.error.getErrors() : [];
    }
}

class Country {
    constructor(iCountry) {
        this.code = iCountry.code;
        this.label = iCountry.label;
    }
}

const fallbackEventDurationInMinutes = 60;
class GeneralConfig {
    constructor(iGeneralConfig) {
        this.availablePaymentMethods = Array.isArray(iGeneralConfig.availablePaymentMethods) ? iGeneralConfig.availablePaymentMethods : [];
        this.countries = Array.isArray(iGeneralConfig.countries) ? iGeneralConfig.countries.map((iCountry) => new Country(iCountry)) : [];
        this.defaultCountryCode = iGeneralConfig.defaultCountryCode;
        this.defaultCurrency = iGeneralConfig.defaultCurrency;
        this.defaultEventDuration = iGeneralConfig.defaultEventDuration ?? fallbackEventDurationInMinutes;
        this.defaultTaxId = iGeneralConfig.defaultTaxId;
        this.defaultSubCategories = Array.isArray(iGeneralConfig.defaultSubCategories) ? iGeneralConfig.defaultSubCategories : [];
        this.defaultTimezone = iGeneralConfig.defaultTimezone;
        this.defaultLanguageCode = iGeneralConfig.defaultLanguageCode;
        this.supportedLanguages = Array.isArray(iGeneralConfig.supportedLanguages) ? iGeneralConfig.supportedLanguages : [];
        this.enabledPaymentMethods = Array.isArray(iGeneralConfig.enabledPaymentMethods) ? iGeneralConfig.enabledPaymentMethods : [];
        this.multipleOnlineContentAccess = iGeneralConfig.multipleOnlineContentAccess;
        this.stem4GiftcardEnabled = iGeneralConfig.stem4GiftcardEnabled;
        this.showPhoneNumberFieldInCustomerDatas = iGeneralConfig.showPhoneNumberFieldInCustomerDatas;
        this.showCountrySelectorInCustomerDatas = iGeneralConfig.showCountrySelectorInCustomerDatas;
        this.showEventTypeInProgramPages = Boolean(iGeneralConfig.showEventTypeInProgramPages);
    }
}

class InvoiceProvider {
    constructor(iInvoiceProvider) {
        this.id = iInvoiceProvider.id;
        this.name = iInvoiceProvider.name;
    }
}

class InvoiceConfig {
    constructor(iInvoiceConfig) {
        this.status = iInvoiceConfig.status;
        this.provider = iInvoiceConfig.provider ? new InvoiceProvider(iInvoiceConfig.provider) : null;
    }
}

class LocalizationConfig {
    constructor(iLocalizationConfig) {
        this.customerDataFields = Array.isArray(iLocalizationConfig.customerDataFields) ? iLocalizationConfig.customerDataFields : [];
        this.displayCalendar = iLocalizationConfig.displayCalendar;
        this.displayTimezone = iLocalizationConfig.displayTimezone;
    }
}

class CardConfig {
    constructor(iCardConfig) {
        this.hasActive = iCardConfig.hasActive;
    }
}

class PartnerWebConfigTheme {
    constructor(iTheme) {
        this.coverImage = iTheme.coverImage;
        this.darkThemeLogoId = iTheme.darkThemeLogoId;
        this.darkThemeFooterLogoId = iTheme.darkThemeFooterLogoId;
        this.id = iTheme.id;
        this.logoId = iTheme.logoId;
        this.name = iTheme.name;
        this.primaryColor = iTheme.primaryColor;
        this.footerLogoId = iTheme.footerLogoId;
        this.secondaryColor = iTheme.secondaryColor;
        this.showVenueMap = iTheme.showVenueMap;
        this.slug = iTheme.slug;
        this.template = iTheme.template;
        this.termsLink = iTheme.termsLink;
    }
}

class WebConfig {
    constructor(iWebConfig) {
        this.displayAvailableTicketNumberRecurring = !!iWebConfig?.displayAvailableTicketNumberRecurring;
        this.displayAvailableTicketNumberTimeslot = !!iWebConfig?.displayAvailableTicketNumberTimeslot;
        this.faviconId = iWebConfig?.faviconId || null;
        this.footerLinks = Array.isArray(iWebConfig?.footerLinks) ? iWebConfig.footerLinks : [];
        this.partnerPageDomain = iWebConfig?.partnerPageDomain || null;
        this.privacy = iWebConfig?.privacy || null;
        this.regionPartnerPageDomain = iWebConfig?.regionPartnerPageDomain || null;
        this.regionPartnerRootDomain = iWebConfig?.regionPartnerRootDomain || null;
        this.shortDescription = iWebConfig?.shortDescription || null;
        this.tabText = iWebConfig?.tabText || null;
        this.terms = iWebConfig?.terms || null;
        this.theme = iWebConfig?.theme ? new PartnerWebConfigTheme(iWebConfig.theme) : null;
        this.webSiteTitle = iWebConfig?.webSiteTitle || null;
        this.welcome = iWebConfig?.welcome || null;
    }
}

class PartnerConfig {
    constructor(iPartnerConfig) {
        this.general = new GeneralConfig(iPartnerConfig.general);
        this.invoicing = new InvoiceConfig(iPartnerConfig.invoicing);
        this.localization = new LocalizationConfig(iPartnerConfig.localization);
        this.partnerId = iPartnerConfig.partnerId;
        this.partnerName = iPartnerConfig.partnerName;
        this.partnerType = iPartnerConfig.partnerType;
        this.regionPartnerName = iPartnerConfig.regionPartnerName;
        this.web = new WebConfig(iPartnerConfig.web);
        this.card = new CardConfig(iPartnerConfig.card);
    }
}

class PartnerWebConfig {
    constructor(iConfig) {
        this.themes = parseArray(iConfig.themes, PartnerWebConfigTheme);
    }
}

class Status {
    constructor(iStatus) {
        this.name = iStatus.name;
        this.label = iStatus.label;
    }
}

class StoreService {
    constructor() {
        this._state$ = new BehaviorSubject(null);
        this.state$ = this._state$.asObservable();
    }
    get state() {
        return this._state$.getValue();
    }
    setState(nextState) {
        this._state$.next(nextState);
    }
    patchState(update) {
        this.setState({ ...this.state, ...update });
    }
    // LocalStorage
    setItem(key, value) {
        if (value === null) {
            localStorage.removeItem(key);
        }
        else {
            localStorage.setItem(key, JSON.stringify(value));
        }
    }
    getItem(key) {
        return JSON.parse(localStorage.getItem(key));
    }
    // publishBehavior + refCount
    // https://itnext.io/the-magic-of-rxjs-sharing-operators-and-their-differences-3a03d699d255
    shareState(mapState) {
        return this.state$.pipe(map(mapState), publishBehavior(null), refCount());
    }
}

// https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
function getQueryParam(name, url) {
    // eslint-disable-next-line no-useless-escape
    const paramName = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + paramName + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

class CustomHttpParamEncoder {
    encodeKey(key) {
        return encodeURIComponent(key);
    }
    encodeValue(value) {
        return encodeURIComponent(value);
    }
    decodeKey(key) {
        return decodeURIComponent(key);
    }
    decodeValue(value) {
        return decodeURIComponent(value);
    }
}

class EncodedHttpParams extends HttpParams {
    constructor(options) {
        super({ ...options, encoder: new CustomHttpParamEncoder() });
    }
}

function _isNode() {
    try {
        return !!process?.versions?.node;
    }
    catch (e) {
        return false;
    }
}
const isNode = _isNode();
const isBrowser = !isNode;

class SsrService {
    constructor(transferState, doc) {
        this.transferState = transferState;
        const document = doc;
        if (isBrowser) {
            const { window, location, navigator, localStorage, history, } = document.defaultView;
            this.document = document;
            this.window = window;
            this.location = location;
            this.navigator = navigator;
            this.localStorage = localStorage;
            this.sessionStorage = sessionStorage;
            this.history = history;
        }
    }
    toTransferStore(key, value) {
        if (!isBrowser) {
            this.transferState.set(key, value);
        }
    }
    toTransferStoreById(key, id, value) {
        if (!isBrowser) {
            const storedValue = this.fromTransferStore(key) || {};
            this.toTransferStore(key, { ...storedValue, [id]: value });
        }
    }
    fromTransferStore(key) {
        return this.transferState.get(key, null);
    }
    fromTransferStore$(key) {
        return of(this.fromTransferStore(key));
    }
    hasStoredValue(key) {
        return this.transferState.hasKey(key);
    }
}
SsrService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: SsrService, deps: [{ token: i1.TransferState }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
SsrService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: SsrService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: SsrService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.TransferState }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

class AuthService {
    constructor(ssrService) {
        this.ssrService = ssrService;
    }
    refreshAuthToken(jwtToken, loginUrl, loginParams) {
        let refreshParams;
        return of(null)
            .pipe(switchMap(() => {
            const { 'X-Auth-Partner': partnerId, guestId } = jwtDecode(jwtToken);
            refreshParams = new EncodedHttpParams({
                fromObject: {
                    ...loginParams,
                    partnerId,
                    redirect_uri: `${this.ssrService.location.origin}/assets/refresh/index.html`,
                    identityconfirmed: 'true',
                    guestId,
                },
            });
            const iframe = this.appendIFrame(loginUrl, refreshParams);
            return fromEvent(this.ssrService.window, 'message')
                .pipe(filter(event => event.data?.includes?.('assets/refresh') || event.data === 'SSO_LOADED'), switchMap(event => {
                this.ssrService.document.body.removeChild(iframe);
                if (event.data === 'SSO_LOADED') {
                    return throwError('Couldn\'t refresh access token');
                }
                const newToken = this.parseRefreshResult(event.data.replace('#', '?'));
                return of(newToken);
            }));
        }), take(1));
    }
    parseRefreshResult(href) {
        const access_token = getQueryParam('access_token', href);
        const token_type = getQueryParam('token_type', href);
        const scope = getQueryParam('scope', href);
        const refresh_token = getQueryParam('refresh_token', href);
        const expires_in = +getQueryParam('expires_in', href);
        return {
            access_token,
            token_type,
            scope,
            refresh_token,
            expires_in,
        };
    }
    appendIFrame(refreshURL, refreshParams) {
        const refreshUrl = `${refreshURL}/callback?${refreshParams.toString()}`;
        const iframe = this.ssrService.document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = refreshUrl;
        this.ssrService.document.body.appendChild(iframe);
        return iframe;
    }
}
AuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: AuthService, deps: [{ token: SsrService }], target: i0.ɵɵFactoryTarget.Injectable });
AuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: AuthService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: AuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: SsrService }]; } });

class BrowserDirective {
    constructor(vcr, templateRef) {
        this.vcr = vcr;
        this.templateRef = templateRef;
        this.browser = true;
    }
    ngOnInit() {
        if (this.browser ? isBrowser : !isBrowser) {
            this.vcr.clear();
        }
        else {
            this.vcr.createEmbeddedView(this.templateRef);
        }
    }
}
BrowserDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: BrowserDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
BrowserDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: BrowserDirective, selector: "[browser]", inputs: { browser: "browser" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: BrowserDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[browser]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i0.TemplateRef }]; }, propDecorators: { browser: [{
                type: Input
            }] } });

class SsrModule {
    static forRoot() {
        return {
            ngModule: SsrModule,
            providers: [
                SsrService,
            ],
        };
    }
}
SsrModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: SsrModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SsrModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: SsrModule, declarations: [BrowserDirective], imports: [CommonModule] });
SsrModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: SsrModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: SsrModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                    ],
                    declarations: [
                        BrowserDirective,
                    ],
                }]
        }] });

class AuthModule {
}
AuthModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: AuthModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AuthModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: AuthModule, imports: [CommonModule,
        SsrModule] });
AuthModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: AuthModule, providers: [
        AuthService,
    ], imports: [CommonModule,
        SsrModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: AuthModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        SsrModule,
                    ],
                    providers: [
                        AuthService,
                    ],
                }]
        }] });

class RefreshStrategy {
    constructor(refreshAuthToken, authorizeRequest) {
        this.refreshAuthToken = refreshAuthToken;
        this.authorizeRequest = authorizeRequest;
        this.onRefresh$ = new Subject();
        this.isRefreshing = false;
    }
    refresh(next, request, err) {
        if (this.isRefreshing) {
            return this.retryAfterRefresh(request, next, err);
        }
        this.isRefreshing = true;
        return this.refreshAuthToken()
            .pipe(finalize(() => this.isRefreshing = false), catchError(error => {
            this.onRefresh$.error(error);
            return throwError(error);
        }), tap(() => this.onRefresh$.next()), switchMap(() => next.handle(this.authorizeRequest(request))));
    }
    retryAfterRefresh(request, next, error) {
        return this.onRefresh$.pipe(take(1), switchMap(() => next.handle(this.authorizeRequest(request))), catchError((e) => {
            console.error('Failed retry after refresh:', e);
            return throwError(error);
        }));
    }
}

var LanguageCountryCode;
(function (LanguageCountryCode) {
    LanguageCountryCode["HU"] = "hu";
    LanguageCountryCode["EN"] = "en-gb";
    LanguageCountryCode["DA"] = "da";
    LanguageCountryCode["PL"] = "pl";
})(LanguageCountryCode || (LanguageCountryCode = {}));

const TRANSLATE_MODULE_CONFIG = new InjectionToken('TRANSLATE_MODULE_CONFIG');
const DEFAULT_TRANSLATE_MODULE_CONFIG = {
    appVersion: 'undefined',
    serviceVersion: 'v1',
};
const LANGUAGE_LOCALE_CODE = {
    [LanguageCode.DA]: LanguageCountryCode.DA,
    [LanguageCode.EN]: LanguageCountryCode.EN,
    [LanguageCode.HU]: LanguageCountryCode.HU,
    [LanguageCode.PL]: LanguageCountryCode.PL,
};
const ALL_SUPPORTED_LANGUAGE = [
    LanguageCode.EN,
    LanguageCode.HU,
    LanguageCode.DA,
    LanguageCode.DE,
    LanguageCode.PL,
    LanguageCode.SK,
    LanguageCode.IT,
    LanguageCode.FR,
];

class ITranslateSource {
}

// @dynamic
class Utils {
    /**
     * Parse an array of strings into query params of a GET request
     *  @param isFirstParam - Set to false if there are other queries in the url before this one.
     */
    static getArrayQueryParams(paramName, array, isFirstParam = true) {
        return (isFirstParam ? '' : '&') + array.map((str) => paramName + '=' + str).join('&');
    }
    /**
     * Decimal rounding
     */
    static round10(value, ndec) {
        if (!ndec || ndec <= 0) {
            return Math.round(value);
        }
        const n = Math.pow(10, ndec);
        return Math.round(value * n) / n;
    }
    /**
     * @param value - string or boolean to convert
     * @returns the converted string value to boolean or the original boolean value if it was passed
     */
    static convertToBoolean(value) {
        return typeof value === 'boolean' ? value : value === 'true';
    }
    /**
     * Check date is a valid Luxon DateTime
     * @param date object to check
     * @returns boolean - type guarded
     */
    static isDateTime(date) {
        return date && date instanceof DateTime && date.isValid;
    }
    /**
     * Check whether the parameter is a valid Luxon DateTime range
     * @param range array to check - containing two elements (from and to DateTime instances)
     * @returns boolean
     */
    static isDateTimeRange(range) {
        if (!Array.isArray(range) || range.length !== 2) {
            return false;
        }
        return range.every(dateTime => Utils.isDateTime(dateTime));
    }
    /**
     * Returns to date string from Luxon DateTime as parameter passed format
     * {@link} https://moment.github.io/luxon/docs/manual/formatting.html#iso-8601
     */
    static dateTimeToISOFormat(date, options = { toUTC: true, format: 'full' }) {
        if (Utils.isDateTime(date)) {
            const dateTime = options.toUTC ? date.toUTC() : date;
            switch (options.format) {
                case 'full': return dateTime.toISO();
                case 'date': return dateTime.toISODate();
                case 'weekDate': return dateTime.toISOWeekDate();
                case 'time': return dateTime.toISOTime();
                default: return dateTime.toISO();
            }
        }
        return null;
    }
    /**
     * Converts ISODateTime to Luxon DateTime
     * @param isoDate - ISODateTime to convert to Luxon DateTime
     * @returns Luxon DateTime or null if the parameter is not a valid ISODateTime
     */
    static isoDateToDateTime(isoDate) {
        const converted = DateTime.fromISO(isoDate);
        return Utils.isDateTime(converted) ? converted : null;
    }
    /**
     * Check date is a valid Date
     * {@link} https://stackoverflow.com/a/44198641/9533324
     */
    static isDate(date) {
        return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
    }
    /**
     * Convert date format to number (timestamp)
     */
    static createDateFromTime(date, params = { hours: 0, minutes: 0, seconds: 0 }) {
        const ret = new Date(date);
        ret.setHours(params.hours, params.minutes, params.seconds, 0);
        return ret.getTime();
    }
    /**
     * Convert date parameter to ISODateTime
     */
    static parseDateTime(date) {
        if (Utils.isDateTime(date)) {
            return Utils.dateTimeToISOFormat(date);
        }
        else if (!date) {
            return null;
        }
        else if (!Number.isNaN(Number(date))) {
            return Utils.dateTimeToISOFormat(DateTime.fromMillis(+date));
        }
        return date;
    }
    /**
     * Round a Date() to the nearest minutes as a parameter
     * {@link} https://stackoverflow.com/questions/10789384/round-a-date-to-the-nearest-5-minutes-in-javascript
     */
    static getRoundedDate(minutes, date = new Date()) {
        const ms = 1000 * 60 * minutes; // convert minutes to ms
        return new Date(Math.round(date.getTime() / ms) * ms);
    }
    /**
     * Capitalize the first letter of a string
     * {@link} https://paulund.co.uk/capitalize-first-letter-string-javascript
     */
    static uppercaseFirstLetter(str) {
        return str.substr(0, 1).toUpperCase() + str.substr(1);
    }
    /**
     * Returns a boolean to show that the parameter passed AbstractControl is invalid
     */
    static isInvalidControl(control) {
        return !!control?.errors && (control.touched || control.dirty);
    }
    /**
     * Returns a boolean to show that the parameter is a whole number
     */
    static isWholeNumber(input, positiveOnly = true) {
        const wholeNumberPattern = positiveOnly ? /^\d+$/ : /^-?\d+$/;
        return wholeNumberPattern.test(input);
    }
    /**
     * Returns a boolean to show that the parameter can be converted to number type
     */
    static isNumeric(valueToCheck) {
        if (typeof valueToCheck === 'number') {
            return true;
        }
        if (typeof valueToCheck !== 'string' || /\s/g.test(valueToCheck)) {
            return false;
        }
        return !Number.isNaN(valueToCheck) && !Number.isNaN(parseFloat(valueToCheck));
    }
    /**
     * Returns a generated unique id
     * {@link}: https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
     */
    static generateGuid() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
    }
    /**
     * Chunks an array into arrays with size elements.
     *
     */
    static chunk(inputArray, size) {
        return inputArray.reduce((all, one, i) => {
            const ch = Math.floor(i / size);
            all[ch] = [].concat((all[ch] || []), one);
            return all;
        }, []);
    }
    /**
     * Shift an array
     * {@link} https://stackoverflow.com/a/16097301/9533324
     */
    static shiftArray(inputArray, direction = 'left', position = 1) {
        const count = direction === 'left' ? inputArray.length - position : position;
        return inputArray.concat(inputArray.splice(0, count));
    }
    /**
     * Megabytes to Bytes converter
     */
    static convertMegabytesToBytes(megabytes) {
        return megabytes * Math.pow(1024, 2);
    }
    /**
     * Sort array alphabetically
     */
    static sortByAlphabet(array, key, lang = LanguageCode.EN, direction = 'asc') {
        return array.sort((a, b) => {
            const result = String(a[key]).localeCompare(String(b[key]), lang);
            return direction === 'asc' ? result : result * -1;
        });
    }
    /**
     * Sort array by pattern
     */
    static sortByPattern(array, key, pattern, direction = 'asc') {
        const _pattern = direction === 'asc' ? pattern : pattern.reverse();
        return array.sort((a, b) => _pattern.indexOf(a[key]) - _pattern.indexOf(b[key]));
    }
    /**
     * Lowercase all key of object
     * {@link} https://stackoverflow.com/a/12540603/13183117
     */
    static lowercaseObjectKeys(obj) {
        const keys = Object.keys(obj);
        let n = keys.length;
        const newObj = {};
        while (n--) {
            const key = keys[n];
            newObj[key.toLowerCase()] = obj[key];
        }
        return newObj;
    }
    /**
     * Get distinct values from an Array of objects by object key
     */
    static getUniqueItems(list, key) {
        return Array.from(new Map(list.map(item => [item[key], item])).values());
    }
    /**
     * Creates a polling observable.
     * Creates polling which is only resolved when @param skipWhileCallback returns false.
     */
    static pollSkipWhile(pollApiCall, skipWhileCallback, pollInterval = 2500) {
        return interval(pollInterval)
            .pipe(startWith(0), concatMap(() => pollApiCall()), skipWhile(skipWhileCallback), take(1));
    }
    /**
     * Creates a polling observable.
     * Creates polling which is only resolved when @param takeWhileCallback returns false.
     */
    static pollTakeWhile(pollApiCall, takeWhileCallback, pollInterval = 2500) {
        return interval(pollInterval)
            .pipe(startWith(0), concatMap(() => pollApiCall()), takeWhile(takeWhileCallback, true));
    }
    /**
     * Detect mobile devices based on touch screen
     * {@link} https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#Mobile_Device_Detection
     */
    static isMobileDevice() {
        let hasTouchScreen = false;
        const nav = window.navigator;
        if (nav.maxTouchPoints) {
            hasTouchScreen = nav.maxTouchPoints > 0;
        }
        else {
            const mQ = window.matchMedia && matchMedia('(pointer:coarse)');
            if (mQ && mQ.media === '(pointer:coarse)') {
                hasTouchScreen = !!mQ.matches;
            }
            else if (window.orientation) {
                hasTouchScreen = true; // deprecated, but good fallback
            }
            else {
                // Only as a last resort, fall back to user agent sniffing
                const UA = nav.userAgent;
                hasTouchScreen = (/\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
                    /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA));
            }
        }
        return hasTouchScreen;
    }
    /**
     * Detect iOS devices
     * {@link} https://stackoverflow.com/a/58065241/13183117
     */
    static isIOSDevice() {
        const nav = window.navigator;
        return /iPad|iPhone|iPod/.test(nav.platform) || (nav.platform === 'MacIntel' && nav.maxTouchPoints > 1);
    }
}

class TranslateService {
    constructor(translateSourceService, ssrService, router, rendererFactory, moduleConfig) {
        this.translateSourceService = translateSourceService;
        this.ssrService = ssrService;
        this.router = router;
        this.rendererFactory = rendererFactory;
        this.moduleConfig = moduleConfig;
        this.TRANSLATIONS_STORAGE_KEY = 'translations';
        this.CURRENT_LANG_STORAKE_KEY = 'current_lang';
        this.TRANSLATIONS_EXPIRE_STORAGE_KEY = 'translations_expire';
        this.TRANSLATIONS_VERSION_STORAGE_KEY = 'translations_version';
        this.PLACEHOLDER = '%';
        this.TRANSLATIONS_EXPIRE_DAYS = 1;
        this.DEFAULT_ERROR_REDIRECT_ROUTE = ['server-error'];
        this.translationsSubject$ = new BehaviorSubject({});
        this.onLangChanged = new EventEmitter();
        /**
         * Get an instance of Renderer2 inside Service
         * {@link} https://stackoverflow.com/a/47925259/13183117
         **/
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }
    async init(config) {
        this.browserLang = this.getBrowserLang();
        this._supportedLangs = config.language?.supported?.length ? config.language.supported : ALL_SUPPORTED_LANGUAGE;
        this.fallbackLang = config.language?.fallback || (this.isSupportedLang(this.browserLang) && this.browserLang) || LanguageCode.EN;
        this._currentLang = this.storedLang || config.language?.default || this.fallbackLang;
        this.translationTags = config.translationTags || [];
        this.setHtmlLangAttribute();
        this.setErrorRedirectRoute(config.errorRedirectRoute);
        this.initTarnslations();
        await this.initCurrentLang();
    }
    /**
     * Set server error redirect route
     */
    setErrorRedirectRoute(route = this.DEFAULT_ERROR_REDIRECT_ROUTE) {
        this.errorRedirectRoute = route;
    }
    /**
     * Update html attribute in root index.html
     */
    setHtmlLangAttribute() {
        isBrowser && this.renderer.setAttribute(this.ssrService.document.querySelector('html'), 'lang', this._currentLang);
    }
    /**
     * Set current language
     */
    use(lang) {
        this._currentLang = lang;
        isBrowser && this.ssrService.localStorage.setItem(this.CURRENT_LANG_STORAKE_KEY, lang);
        this.setHtmlLangAttribute();
        this.onLangChanged.emit(this.currentLang);
    }
    /**
     * Replace placeholders to words in translation
     */
    replace(translation = '', words = '') {
        const values = [].concat(words);
        let newTranslation = translation;
        values.forEach((element, index) => {
            newTranslation = newTranslation.replace(this.PLACEHOLDER.concat(`${index}`), element);
        });
        return newTranslation;
    }
    /**
     * Get translation by language label
     */
    get(label, words) {
        const translation = this.translate(label);
        if (words === undefined) {
            return translation;
        }
        // call replace function
        return this.replace(translation, words);
    }
    /**
     * Refresh translations cache
     */
    refreshTranslations() {
        isBrowser && this.ssrService.localStorage.removeItem(this.TRANSLATIONS_STORAGE_KEY);
        this.setTranslation();
    }
    /**
     * Display language labels instead of translations
     */
    displayLanguageLabels() {
        const supportedLanguages = {};
        for (const langCode of this.supportedLangs) {
            supportedLanguages[langCode] = {};
        }
        this.translationsSubject$.next(supportedLanguages);
        isBrowser && this.ssrService.localStorage.setItem(this.TRANSLATIONS_STORAGE_KEY, JSON.stringify(this.translations));
    }
    /**
     * Public readonly getter for the private value.
     */
    get currentLang() {
        return this._currentLang;
    }
    get supportedLangs() {
        return this._supportedLangs;
    }
    getLocaleId() {
        return LANGUAGE_LOCALE_CODE[this.currentLang] || LANGUAGE_LOCALE_CODE[LanguageCode.EN];
    }
    /**
     * Get label and translations as the parameter passed language
     */
    getTranslations(lang) {
        return this.translateSourceService.getTranslations(lang, this.translationTags)
            .pipe(take(1), map((iTranslations) => Utils.lowercaseObjectKeys(iTranslations.translationsJson)));
    }
    /**
     * Set label and translations by current language
     */
    async setTranslation() {
        return new Promise((resolve) => {
            this.storeTranslation(this.currentLang)
                .pipe(finalize(() => resolve()))
                .subscribe({
                next: () => this.onLangChanged.emit(this.currentLang),
                error: () => isBrowser && this.router.navigate(this.errorRedirectRoute),
            });
        });
    }
    /**
     * Set label and translations by fallback language
     */
    async setFallbackTranslation() {
        return new Promise((resolve) => {
            this.storeTranslation(this.fallbackLang)
                .pipe(finalize(() => resolve()))
                .subscribe({
                error: () => isBrowser && this.router.navigate(this.errorRedirectRoute),
            });
        });
    }
    /**
     * Store label and translations as the parameter passed language
     */
    storeTranslation(lang) {
        return this.getTranslations(lang)
            .pipe(take(1), tap((iTranslation) => {
            const currentTranslations = Object.assign(this.translations, { [lang]: iTranslation });
            // set translations in localstorage
            isBrowser && this.ssrService.localStorage.setItem(this.TRANSLATIONS_STORAGE_KEY, JSON.stringify(currentTranslations));
            // set translations expire datetime in localstorage
            const expireDateTime = DateTime.local().plus({ day: this.TRANSLATIONS_EXPIRE_DAYS }).toISO();
            isBrowser && this.ssrService.localStorage.setItem(this.TRANSLATIONS_EXPIRE_STORAGE_KEY, expireDateTime);
            // set translations version in localstorage
            isBrowser && this.ssrService.localStorage.setItem(this.TRANSLATIONS_VERSION_STORAGE_KEY, this.moduleConfig.appVersion);
            // set current translation object into observable
            this.translationsSubject$.next(currentTranslations);
        }));
    }
    /**
     * Detect the browser language preference
     * {@link} https://stackoverflow.com/a/29106129/13183117
     */
    getBrowserLang() {
        if (isBrowser) {
            const nav = window.navigator;
            let language = nav.languages?.[0] || null;
            if (!language) {
                const browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'];
                language = browserLanguagePropertyKeys
                    .map(key => nav[key])
                    .find((value) => value?.length);
            }
            if (language.indexOf('-') !== -1) {
                language = language.split('-')[0];
            }
            if (language.indexOf('_') !== -1) {
                language = language.split('_')[0];
            }
            return language || null;
        }
    }
    isSupportedLang(langCode) {
        return this.supportedLangs.includes(langCode);
    }
    /**
     * Get stored language
     */
    get storedLang() {
        if (isBrowser) {
            const storedLang = this.ssrService.localStorage.getItem(this.CURRENT_LANG_STORAKE_KEY);
            if (storedLang && this.isSupportedLang(storedLang)) {
                return storedLang;
            }
            this.ssrService.localStorage.removeItem(this.CURRENT_LANG_STORAKE_KEY);
        }
    }
    /**
     * Get translations
     */
    get translations() {
        return this.translationsSubject$.value;
    }
    /**
     * Initialize current language
     */
    async initCurrentLang() {
        if (this.translations.hasOwnProperty(this.currentLang) && this.translations[this.currentLang] === null) {
            await this.setTranslation();
        }
    }
    /**
     * Get stored translations from localstorage
     */
    getStoredTranslations() {
        // get translations expire datetime from localstorage
        const storedExpireDateTime = DateTime.fromISO(this.ssrService.localStorage.getItem(this.TRANSLATIONS_EXPIRE_STORAGE_KEY));
        const isValidTranslations = Utils.isDateTime(storedExpireDateTime) && storedExpireDateTime > DateTime.local();
        // get translations version from localstorage
        const isValidVersion = this.moduleConfig.appVersion === this.ssrService.localStorage.getItem(this.TRANSLATIONS_VERSION_STORAGE_KEY);
        // get translations object from localstorage
        const rawStoredTranslations = this.ssrService.localStorage.getItem(this.TRANSLATIONS_STORAGE_KEY);
        // validate translations
        if (rawStoredTranslations && isValidTranslations && isValidVersion) {
            const storedTranslations = Object.assign(this.translations, JSON.parse(rawStoredTranslations));
            if (this.supportedLangs.every(langCode => storedTranslations.hasOwnProperty(langCode))) {
                return storedTranslations;
            }
        }
    }
    /**
     * Initialize translations
     */
    initTarnslations() {
        // get translations object from localstorage
        const storedTranslations = isBrowser && this.getStoredTranslations();
        if (storedTranslations) {
            this.translationsSubject$.next(storedTranslations);
        }
        else {
            // get supported languages from config
            const supportedLanguages = {};
            for (const langCode of this.supportedLangs) {
                supportedLanguages[langCode] = null;
            }
            // set default translation object by supported languages
            this.translationsSubject$.next(supportedLanguages);
        }
    }
    /**
     * Private perform translation
     */
    translate(label) {
        const key = String(label).toLowerCase();
        // found in current language
        if (this.translations[this.currentLang] && this.translations[this.currentLang][key]) {
            return this.translations[this.currentLang][key];
        }
        // fallback disabled
        if (!this.fallbackLang) {
            return label;
        }
        // found in fallback language
        if (this.translations[this.fallbackLang] && this.translations[this.fallbackLang][key]) {
            return this.translations[this.fallbackLang][key];
        }
        // not found
        return label;
    }
}
TranslateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TranslateService, deps: [{ token: ITranslateSource }, { token: SsrService }, { token: i1$1.Router }, { token: i0.RendererFactory2 }, { token: TRANSLATE_MODULE_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
TranslateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TranslateService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TranslateService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: ITranslateSource }, { type: SsrService }, { type: i1$1.Router }, { type: i0.RendererFactory2 }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLATE_MODULE_CONFIG]
                }] }]; } });

class TranslatePipe {
    constructor(translateService) {
        this.translateService = translateService;
    }
    transform(label, words) {
        return label ? this.translateService.get(label, words) : '';
    }
}
TranslatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TranslatePipe, deps: [{ token: TranslateService }], target: i0.ɵɵFactoryTarget.Pipe });
TranslatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: TranslatePipe, name: "translate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TranslatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'translate',
                }]
        }], ctorParameters: function () { return [{ type: TranslateService }]; } });

const TRANSLATE_HU = {
    translationsJson: {
        programsubtype_id_195: 'Bírkózás',
        label_validation_datetime_min: 'Legkorábbi dátum: %0',
        programsubtype_id_194: 'Néptánc',
        admin_events_program_audit_edit_label: 'Kiválasztott nézőtér szerkesztése',
        label_type: 'Típus',
        lang_first_name: 'Keresztnév',
        admin_menu_articles: 'Bejegyzések',
        label_none: 'Nincs',
        general_lang_search: 'Keresés',
        admin_events_program_venue_create_label: 'Új helyszín létrehozása',
        stemx_partner_roles: 'Partner szerepkörök',
        label_admission_control: 'Beléptetés',
        lang_filter: 'Szűrés',
        admin_gift_card: 'Ajándékkártya',
        label_giftcard_transaction_type: 'Tranzakció típus',
        general_lang_set: 'Beállít',
        general_lang_active: 'Aktív',
        label_smart_city_place_type_museums: 'Múzeumok és Galériák',
        stem_general_paginator_next_page: 'Következő oldal',
        label_gc_request_date: 'Kérelem dátuma',
        stemx_article_content: 'Tartalom',
        label_gc_available_start_date: 'Available start date',
        label_gc_mothername: 'Anyja neve',
        admin_events_program_audit_selected_info: 'Kiválasztott nézőtér adatai',
        label_operations: 'Műveletek',
        label_modify_ticketissuer_data: 'Jegykibocsátó adatainak módosítása',
        stemx_domain_name: 'Domain',
        label_excel_download: 'Excel letöltése',
        stemx_list_edit: 'Szerkesztés',
        label_billing_information: 'Számlázási adatok',
        label_unsuccess_action_try_later: 'A kért műveletet sajnos nem sikerült teljesíteni. Kérjük próbálja később.',
        admin_template_manager: 'Template Manager',
        admin_menu_giftcardbalancedetail: 'Ajándékkártya egyenleg',
        general_lang_birthplace: 'Születés hely',
        general_lang_tags: 'Címkék',
        label_day_long_sat: 'Szombat',
        stemx_government_service_places: 'Önkormányzati szolgáltatás helyszínek',
        admin_menu_survey_create: 'Kérdőív létrehozása',
        'label_bfe290ef-df27-4e73-a2ba-a3dad07ec7bd': 'alma',
        label_country_208: 'Dánia',
        lang_label_hungarian: 'Hungarian',
        stemx_partner_role_translations: 'Szerepkörök fordításai',
        general_lang_add: 'Hozzáad',
        admin_lang_upload_image: 'Képfeltöltés',
        label_status: 'Állapot',
        general_lang_no: 'Nem',
        label_new_audit: 'Új nézőtér',
        stemx_partner_status_inactive: 'Inaktív',
        smart_city_vote_download_file_name: 'VelemenynyilvanitasokListaja',
        smart_city_notification_remove: 'Önkormányzati szolgáltatás törlése',
        'label_98a7956e-8e9e-4b9d-b234-31e3e3c4b31b': 'alma1',
        label_billing_tax_number: 'Adószám',
        label_testtest: 'Magyar teszt2',
        stemx_blog_name: 'Név',
        stemx_back_to_list: 'Vissza a listához',
        lang_label_english: 'English',
        calendar_select_start_date: 'Válassza ki a kezdő dátumot!',
        admin_events_program_add_image: 'Kép hozzáadása',
        label_base_company_contact_person: 'Kapcsolattartó neve',
        stemx_partner_role_delete_error: 'Hiba történt a partner jogosultság törlése közben',
        lang_venue_name: 'Helyszín neve',
        admin_lang_preview: 'Előnézet',
        general_lang_rate: 'Kedvezmény',
        stemx_partner_view: 'Partner adatainak megtekintése',
        label_ticketissuer: 'Jegykibocsátó',
        label_validation_max_length: 'Kérem legfeljebb %0 karaktert adjon meg',
        stemx_partner_name: 'Partner neve',
        label_login_with_google: 'Belépés google+ fiókkal',
        label_drafts: 'Piszkozatok',
        programsubtype_id_166: 'Próza',
        label_gc_card_status: 'Kártya állapot',
        admin_lang_language_choose: 'Válasszon Nyelvet',
        general_lang_address: 'Cím',
        stemx_admin_profile: 'Profil',
        stem_general_paginator_prev_page: 'Előző oldal',
        label_billing_county: 'Megye',
        label_billing_zip: 'Irányítószám',
        label_validation_min_length: 'Kérem adjon meg legalább %0 karaktert',
        label_gc_card_request_detail: 'Kártya kérelem adatok',
        click_create_new_button: 'Új adat felvételéhez kattintson az "Új létrehozása" gombra.',
        opening_hours: 'Nyitvatartás',
        label_max_capacity_info_audit: 'Ennek a nézőtérnek a maximális férőhelye legfeljebb %0 fős lehet.',
        admin_create_event_modify_success: 'Esemény sikeresen módosítva!',
        label_users: 'Felhasználók',
        label_billing_door: 'Ajtó',
        user_statuses_load_fail: 'A felhasználói állapotokat nem sikerült betölteni',
        lang_label_polish: 'Polish',
        label_gc_available_end_date: 'Available end date',
        stemx_tag_delete_error: 'Hiba történt a címke törlése közben',
        email_new_password_again: 'Új jelszó ismét',
        stemx_place_required: 'Helyszín hozzáadása kötelező',
        stemx_blogs_delete_success: 'Blog sikeresen törölve',
        stemx_blogs_view: 'Blog megtekintése',
        lang_label_spanish: 'Spanish',
        stemx_partner_status_active: 'Aktív',
        label_yes: 'Igen',
        admin_menu_smart_city_notification_delete_error_message: 'Hiba történt az értesítés törlése közben',
        stemx_load_blog_statuses_error: 'Blog státuszok betöltése sikertelen',
        'label_ee373951-7527-4789-9c9b-32e883911c63': 'alma',
        label_module_gc_balance: 'Egyenleg',
        label_currency: 'Pénznem',
        stemx_tag_delete_success: 'Címke sikeresen törölve',
        lang_program_name: 'Program neve',
        label_day_long_thu: 'Csütörtök',
        label_giftcard_transaction_amount: 'Tranzakció értéke',
        admin_confirm_delete: 'Biztosan törli?',
        admin_menu_reports: 'Riportok',
        label_events: 'Események',
        admin_import_tickets: 'Jegyek importálása',
        smart_city_vote_edit: 'Véleménynyílvánítás szerkesztése',
        general_lang_password: 'Jelszó',
        admin_admission_report: 'Admission beléptető riport',
        label_domains: 'Doménok',
        label_next: 'Következő',
        admin_menu_settings: 'Beállítások',
        general_lang_lastname: 'Vezetéknév',
        admin_events_program_next_event: 'Esemény időpont',
        remove_profile_picture: 'Profilkép törlése',
        admin_menu_tags: 'Címkék',
        admin_label_description: 'Leírás',
        admin_menu_venues: 'Helyszínek',
        lang_filters: 'Szűrők',
        admin_menu_blog_articles_editor: 'Bejegyzés szerkesztése',
        label_module_reports: 'jelentések',
        label_smart_city_place_name: 'Helyszín neve',
        label_validation_datetime_max: 'Legkésőbbi dátum: %0',
        admin_menu_surveys: 'Kérdőívek',
        admin_label_status: 'státusz',
        general_lang_username: 'Felhasználónév',
        forgot_password_button: 'Új jelszó igénylése',
        label_error_start_date_end_date: 'A befejező dátum kisebb mint a kezdő.',
        stemx_role_permission_editor: 'Szerepkör, jogosultság szerkesztő',
        label_partners: 'Partnerek',
        label_giftcard_transaction_create: 'Új trancakció létrehozása',
        label_create_new_event: 'Új esemény',
        label_subdomain: 'Aldomain',
        label_closed: 'Lezárt',
        admin_address_label_country: 'Ország',
        label_validation_phone: 'Érvénytelen formátum',
        admin_lang_import: 'Import',
        general_lang_type: 'Tipus',
        admin_menu_smart_city_notifications: 'Értesítések',
        smart_city_government_address: 'Cím',
        label_prev: 'Előző',
        label_max_capacity_error_audit: 'A nézőterek össz férőhely kapacitása nem haladhatja meg az előadóhely maximális kapactását',
        admin_digits_only: 'Csak számjegyeket adjon meg',
        label_base_company_email: 'E-mail cím',
        'label_b961fc7f-4105-4ad2-8511-c288a23ecd6f': 'teszt szerepkor mod',
        label_gc_reject: 'Elutasít',
        stemx_partner_edit: 'Partner szerkesztése',
        stemx_tag_name: 'Név',
        label_smart_city_notification_message: 'Üzenet',
        lang_label_label: 'Címke',
        label_back_to_login: 'Vissza a bejelentkezéshez',
        admin_admission_clients_title: 'Beléptető alkalmazások',
        label_gc_image_delete_fail: 'Feltöltött képek törlése sikertelen',
        stem_general_paginator_of: '/',
        admin_menu_smart_city_places: 'Helyszínek',
        admin_events_program_audit: 'Nézőtér',
        admin_address_label_state: 'Állam',
        admin_label_new: 'Új',
        admin_menu_smart_city: 'Város Kártya',
        smart_city_notification_edit: 'Értesítés szerkesztése',
        label_smart_city_notification_status: 'Státusz',
        stemx_article_delete_success: 'Bejegyzés sikeresen törölve',
        general_lang_phone: 'Telefonszám',
        smart_city_notification_create: 'Értesítés létrehozása',
        admin_label_edit: 'Szerkesztés',
        label_ticketissuer_register: 'Új jegykibocsátó felvétele',
        stemx_load_tag_statuses_error: 'Címke státuszok betöltése sikertelen',
        admin_menu_blog_articles_creator: 'Bejegyzés létrehozása',
        general_lang_next: 'Következő',
        admin_admission_edit_endpoint_title: 'Végpontok testreszabása',
        lang_website: 'Website',
        label_min_value: 'Min érték: %0',
        admin_label_delete: 'Törlés',
        label_billing_building: 'Épület',
        label_smart_city_place_type_gastro: 'Gasztronómia',
        stemx_blog_domain: 'Domain',
        admin_menu_smart_city_notification_create_message: 'Az értesítés felvétele megtörtént',
        label_day_long_fri: 'Péntek',
        smart_city_government_delete_error: 'Hiba történt az önkormányzati szolgáltatás törlése közben',
        stemx_log_out: 'Kijelentkezés',
        admin_control_panel: 'Vezérlőpult',
        'label_1d85701a-5a03-40ea-9f36-c5932b347060': 'alma',
        admin_create_event_title_modify: 'Esemény módosítása',
        label_giftcard_transaction_user: 'Felhasználó',
        stemx_partner_status_deleted: 'Törölt',
        admin_menu_distributors: 'Viszonteladó',
        label_date_of_birth: 'Születési dátum',
        general_lang_date: 'Dátum',
        general_lang_barcode: 'Vonalkód',
        label_invoice_settings: 'Számlázási beállítások',
        admin_address_label_city: 'Település',
        general_lang_firstname: 'Keresztnév',
        teszt_uj_egyketto_ujabb_: 'Teszt Valami',
        label_country_348: 'Magyarország',
        min_file_resolution: 'Min felbontás',
        login_wrong_email_or_password: 'A megadott email cím vagy jelszó helytelen. Kérjük próbálja újra.',
        admin_menu_smart_city_notification_delete_message: 'Az értesítés sikeresen törölve',
        label_giftcard_transaction_date: 'Tranzakció dátum',
        label_features: 'Lehetőségek',
        stemx_blogs_create: 'Blog létrehozása',
        admin_menu_survey: 'Kérdőív',
        'label_a229bb16-ce2e-481a-83da-c7a337d8b3f9': 'alma',
        stemx_survey_status_published_label: 'Közétett',
        label_contact_email: 'E-mail',
        label_smart_city_notification_pending: 'Függőben',
        general_lang_send: 'Küldés',
        smart_city_government_view: 'Önkormányzati szolgáltatás megtekintése',
        label_feedback_report: 'Vélemény riport',
        general_lang_cancel: 'Mégsem',
        stemx_blogs_article_list: 'Bejegyzés lista',
        forgot_your_password: 'Elfelejtette a jelszavát?',
        stemx_tags_create: 'Címke létrehozása',
        stemx_load_article_statuses_error: 'Bejegyzés státuszok betöltése sikertelen',
        lang_label_danish: 'Danish',
        smart_city_government_desc: 'Leírás',
        label_contact_information: 'Kapcsolati adatok',
        label_no: 'Nem',
        stemx_user_status_wait_for_confirmation: 'Regisztráció megerősítésre vár',
        calendar_select_end_date: 'Válassza ki a záró dátumot!',
        label_form_reset: 'Visszaállítás',
        label_copy_venue_address: 'Előadóhely címének másolása',
        admin_label_name: 'Név',
        stemx_user_status_deleted: 'Törölt',
        label_admin_save_success: 'Sikeres rögzítés!',
        email_new_password_subject: 'Új jelszó',
        label_preview: 'Előnézet',
        acceptable_files: 'Elfogadható formátumok',
        label_smart_city_place_type_accommodations: 'Szálláshelyek',
        label_audit: 'Nézőtér',
        label_max_value: 'Max érték: %0',
        admin_events_gallery: 'Galéria',
        label_teszt: 'Teszt_magyar22',
        smart_city_notification_view: 'Értesítés megnézése',
        label_gc_email_address: 'Email cím',
        admin_events_program_venue_edit: 'Helyszín szerkesztése',
        label_venue_info: 'Előadóhely információ',
        lang_label_czech: 'Czech',
        stemx_user_status_inactive: 'Inaktív',
        label_no_data_to_display: 'Nincs megjeleníthető adat',
        label_giftcard_transaction_tokentype: 'Token típus',
        footer_help: 'Segítség',
        admin_rsuser_create: 'Új felhasználó létrehozása',
        account_info_background_error: 'Hiba történt a háttérben. Kérjük, próbálja meg később!',
        label_alias_domain: 'Alias domén',
        label_payment_settings: 'Fizetési beállítások',
        admin_menu_account_settings: 'Fiókbeállítások',
        lang_label_slovak: 'Slovak',
        label_all: 'Összes',
        admin_menu_events: 'Eseményeim',
        admin_events_program_short_desc: 'Rövid leírás',
        login_lost_password: 'Elfelejtett jelszó',
        label_smart_city_notification_delivered: 'Elküldött',
        smart_city_government_name: 'Név',
        teszt_uj_egyketto_ujabb: 'Teszt Valami',
        ss_lang_invalid_email: 'Érvénytelen email cím!',
        profile_picture: 'Profilkép',
        label_validation_pattern: 'A szükséges minta: %0',
        'label_05dd140b-fa8b-4394-9365-5de08c030e84': 'alma',
        label_error_saving: 'Hiba a mentés során!',
        label_validation_birthyear: 'The year must be a valid number between %0 and %1',
        smart_city_government_create: 'Új létrehozása',
        label_gc_max_volume: 'Max volume',
        statuses_load_fail: 'Az állapotokat nem sikerült betölteni',
        lang_label_search: 'Keresés',
        label_validation_datetime_filter: 'Hibás dátum',
        forgot_password_token: 'Token',
        general_lang_comment: 'Megjegyzés',
        admin_address_label_region: 'Régió',
        general_lang_male: 'Férfi',
        teszt_uj_egyketto: 'teszt0123éáűáéőúőé',
        pay_lang_card_number: 'Kártyaszám',
        label_billing_floor: 'Emelet',
        admin_sales_report: 'Értékesítési riport',
        general_lang_clear: 'Ürít',
        label_audit_info: 'Nézőtér információ',
        label_smart_city_notification_target: 'Címzett',
        basket_lang_basket_transcharge: 'Tranzakciós díj',
        admin_admission_web_admission_title: 'Webes beléptetés',
        label_billing_bank_account: 'Bankszámlaszám',
        feedback_report_download_file_name: 'feedback_report',
        label_go_to_admin: 'Ugrás az admin felületre',
        label_map: 'Térkép',
        admin_label_add: 'Felvesz',
        label_validation_date: 'Érvénytelen dátum',
        label_validation_datetime_parse: 'Hibás dátum',
        admin_menu_smart_city_votes: 'Véleménynyílvánítások',
        stemx_user_delete_error: 'Hiba történt a felhasználó törlése közben',
        label_drag_to_the_right_pos: 'Húzza a jelölőt a megfelelő helyre!',
        stemx_article_featured: 'Kiemelt',
        label_day_long_tue: 'Kedd',
        stem_general_paginator_items_per_page: 'Elem per oldal',
        label_module_gc_token: 'Token',
        label_server_is_unavailable: 'A kiszolgáló épp nem elérhető. Kérjük látogasson vissza később.',
        general_lang_error: 'Hiba',
        admin_menu_survey_editor: 'Kérdőív szerkesztő',
        label_gc_accept_message: 'Kérelem elfogadva',
        lang_address: 'Cím',
        create_new: 'Új létrehozása',
        admin_lang_language: 'Nyelv',
        label_smart_city_notification_error: 'Sikertelen',
        label_activated: 'Aktiválva',
        label_module_manage_card: 'kezelje a kártyát',
        label_billing_city: 'Település',
        general_lang_gender: 'Nem',
        admin_events_program_audit_create_label: 'Új nézőtér létrehozása',
        label_gc_accept: 'Elfogad',
        label_audit_address: 'Nézőtér címe',
        admin_menu_appgen: 'AppGen',
        stemx_load_partner_statuses_error: 'Partner státuszok betöltése sikertelen',
        admin_admission_settings: 'IT Admission Server beállítások',
        admin_menu_smart_city_notification_update_error_message: 'Az elküldött üzenetek nem módosíthatóak',
        teszt_dinamikus: 'teszt03fsaasdgfdas',
        admin_menu_boxoffice: 'Jegypénztár',
        general_lang_yes: 'Igen',
        label_gc_card_request_module: 'Kártya kérelmek',
        admin_menu_tools: 'Eszközök',
        label_developer_tools: 'Fejlesztői eszközök',
        label_gc_image_delete_success: 'Feltöltött képek sikeresen törölve',
        customerevent_type_search: 'Keresés',
        label_contact_webpage: 'Weboldal',
        dear_user: 'Kedves felhasználó',
        admin_create_event_title_create: 'Esemény létrehozása',
        label_barcode_type: 'Vonalkódtípus',
        smart_city_government_edit: 'Önkormányzati szolgáltatás szerkesztése',
        smart_city_place_create: 'Új helyszín létrehozása',
        survey_close_at: 'Záró dátum',
        label_day_long_sun: 'Vasárnap',
        general_lang_previous: 'Előző',
        label_first: 'első',
        admin_menu_smart_city_notification_update_message: 'Az értesítés frissítése megtörtént',
        general_lang_name: 'Név',
        stemx_blogs_info: 'Blog adatok',
        label_gc_reject_message: 'Kérelem elutasítva',
        teszt_uj: 'teszt012?',
        label_billing_street: 'Utca',
        general_lang_view: 'Megtekint',
        general_lang_group: 'Csoport',
        admin_menu_survey_edit: 'Kérdőív szerkesztése',
        label_home: 'Kezdőoldal',
        general_lang_zipcode: 'Irányítószám',
        stemx_user_status_active: 'Aktív',
        label_audits: 'Nézőterek',
        label_validation_password: 'A jelszónak legalább egy számot, egy kisbetűt és egy nagybetűt, valamint legalább 8 karaktert kell tartalmaznia.',
        label_gc_allocation_start_date: 'Allocation start date',
        label_general_info: 'Általános információ',
        general_lang_delete: 'Törlés',
        admin_admission_download_barcode_title: 'Jegy letöltés',
        stemx_role_translate_hu: 'Magyar',
        label_smart_city_vote_description: 'Leírás',
        admin_menu_smart_city_government: 'Önkormányzati szolgáltatások',
        lang_label_empty_only: 'Csak üresek mutatása',
        general_lang_forgotten_changepass: 'Új jelszó beállítása',
        waiting_for_approve: 'Jóváhagyásra vár',
        label_smart_city_notification_title: 'Cím',
        label_you_sure_to_delete_entry: 'Biztosan törölni szeretné ezt a bejegyzést?',
        admin_label_choose: 'Válasszon',
        lang_label_cyprian: 'Görög',
        stemx_tag_info: 'Címke adatok',
        survey_name: 'Kérdőív megnevezése',
        admin_address_label_zip: 'ISz',
        label_contact_phone: 'Telefon',
        label_smart_city_place_info: 'Helyszín adatok',
        'label_dda8646b-5f7b-4c18-aae5-853fb3b309f8': 'alma',
        label_country_703: 'Szlovákia',
        stem_general_paginator_last_page: 'Utolsó oldal',
        admin_label_data_modified: 'Adatok módosítva!',
        label_primary_domain: 'Elsődleges domén',
        label_smart_city_place_type_govermentservices: 'Önkormányzati szolgáltatások',
        general_lang_continue: 'Tovább',
        label_menu_dashboard: 'Dashboard',
        general_lang_login: 'Bejelentkezés',
        label_login_with_fb: 'Belépés facebook fiókkal',
        label_at_least_one_field_required: 'Legalább egy mező kitöltése kötelező',
        stemx_article_title: 'Cím',
        label_admin_save_fail: 'Sikertelen mentés!',
        label_module_new_card: 'Új kártya',
        admin_events_program_tickets: 'Jegyek',
        label_field_is_required: 'A mező kitöltése kötelező.',
        smart_city_place_edit: 'Helyszín szerkesztése',
        label_country_616: 'Lengyelország',
        admin_website_report: 'Web riport',
        stemx_interticket_copyright: '2018 InterTicket.',
        label_billing_street_number: 'Házszám',
        label_create_venue: 'Helyszín létrehozása',
        lang_last_name: 'Vezetéknév',
        'label_3194531a-9c67-425e-b1b4-ef015030cfde': 'alma',
        label_show_password: 'Jelszó mutatása',
        admin_address_label_address: 'Cím',
        stemx_article_publish_date: 'Közzétételi dátum',
        label_test: 'Magyar teszt2',
        label_redirect: 'Átirányítás',
        label_billing_staircase: 'Lépcsőház',
        stemx_survey_status_draft_label: 'Vázlat',
        stemx_role_translate_en: 'Angol',
        admin_label_day: 'nap',
        general_lang_back: 'Vissza',
        label_smart_city_place_type_sights: 'Látnivalók',
        hauth_login_normal_help: 'Jelentkezzen be a regisztrált fiókjával!',
        stemx_role_translate_de: 'Deutsch',
        smart_city_vote_view: 'Véleménynyílvánítás megnézése',
        stem_general_paginator_first_page: 'Első oldal',
        admin_menu_blogs: 'Blogok',
        label_giftcard_token_create: 'Új token létrehozása',
        admin_events_program_long_desc: 'Részletes leírás',
        label_save_error: 'Nem sikerült menteni a módosításokat.',
        stemx_article_scheduled_publish_date: 'Ütemezett közzétételi dátum',
        admin_create_event_create_success: 'Event created successfully!',
        stemx_user_delete_success: 'Felhasználó sikeresen törölve',
        stemx_tags_edit: 'Címke szerkesztése',
        general_lang_name_day: 'Névnap',
        label_ticketissuers: 'Jegykibocsátók',
        admin_menu_blog: 'Blog',
        lang_audit_name: 'Nézőtér neve',
        label_day_long_mon: 'Hétfő',
        admin_no_permission: 'Önnek nincs jogosultsága ehhez az adminisztrációs oldalhoz.',
        server_error: 'Szerver hiba',
        label_main_menu_user_management: 'Felhasználók karbantartása',
        general_lang_birth_name: 'Születési név',
        smart_city_government_delete_success: 'Az önkormányzati szolgáltatás sikeresen törölve',
        stemx_article_delete_error: 'Hiba történt a bejegyzés törlése közben',
        label_gc_search_user: 'Felhasználó keresés',
        teszt_uj_egyketto0: 'teszt0123éáűáéőúőé',
        label_gc_allocation_end_date: 'Allocation end date',
        stemx_blogs_delete_error: 'Hiba történt a blog törlése közben',
        general_lang_email: 'E-mail cím',
        label_billing_name: 'Név',
        stemx_blogs_edit: 'Blog szerkesztése',
        label_billing_country: 'Ország',
        admin_label_create: 'Létrehozás',
        stemx_role_permissions: 'Partner jogosultságai',
        general_lang_status: 'Állapot',
        label_gc_amount_issued: 'Amount issued',
        label_inactivated: 'Inaktiválva',
        published: 'Közzétett',
        admin_export_tickets: 'Jegyek exportálása',
        general_lang_inactive: 'Inaktív',
        admin_label_duration: 'Időtartam',
        label_transaction_module: 'Ajándékutalvány tranzakció',
        label_change_password: 'Jelszó módosítása',
        min_resolution: 'Min felbontás',
        admin_lang_transaction_id: 'Tranzakció azonosító',
        label_from: 'Mettől',
        stemx_article_tags: 'Címkék',
        general_lang_select: 'Válasszon',
        lang_label_turkish: 'Turkish',
        label_gc_card_type: 'Kártya típus',
        label_gc_legitimacy: 'Jogosultásg',
        general_lang_female: 'Nő',
        lang_max_capacity: 'Max Capacity',
        survey_open_at: 'Kezdő dátum',
        label_ticketissuer_id: 'Ticketissuer azonosító',
        label_all_rights_reserved: 'Minden jog fenntartva',
        rejected: 'Elutasított',
        stemx_load_statuses_error: 'Blog státuszok betöltése sikertelen',
        label_day_long_wed: 'Szerda',
        label_organization_name: 'Szervezet neve',
        stemx_partner_role_delete_success: 'Partner jogosultság sikeresen törölve',
        label_billing_company_number: 'Cégjegyzékszám',
        smart_city_government_info: 'Önkormányzati szolgáltatás adatai',
        max_file_size: 'Max fájlméret',
        label_validation_datetime_range: 'Hibás intervallum',
        lang_label_russian: 'Russian',
        label_draft: 'Piszkozat',
        label_module_gift_card: 'Ajándékutalvány',
        label_user_view: 'Felhasználó adatinak megtekintése',
        admin_label_default: 'Alapértelmezett',
        'label_d137794a-101b-45d7-bff4-91e685108bee': 'teszt szerepkor mod',
        label_password_confirmation_not_match: 'A jelszó nem egyezik meg a megerősítéssel',
        smart_city_vote_create: 'Új véleménynyílvánítás létrehozása',
        stemx_survey_status_archived_label: 'Archiválva',
        general_lang_birthday: 'Születésnap',
        label_smart_city_notification_datetime: 'Küldés időpontja',
        general_lang_save: 'Mentés',
        stemx_article_description: 'Leírás',
        label_smart_city_notification_payload: 'Payload',
        label_billing_tax_number_eu: 'EU adószám',
        label_admin_save_warning: 'Hibás kérés',
    },
};

class TranslateSourceMockService {
    getTranslations(language, tags) {
        return of(TRANSLATE_HU).pipe(delay(300));
    }
}
TranslateSourceMockService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TranslateSourceMockService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
TranslateSourceMockService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TranslateSourceMockService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TranslateSourceMockService, decorators: [{
            type: Injectable
        }] });

const HTTP_MODULE_CONFIG = new InjectionToken('HTTP_MODULE_CONFIG');

class HttpService {
    constructor(httpClient, config, serviceDomain) {
        this.httpClient = httpClient;
        this.config = config;
        this.serviceDomain = serviceDomain;
    }
    get(url, options, extraInfo) {
        return this.httpClient.get(this.getApiUrl(url, extraInfo), options);
    }
    post(url, data, options, extraInfo) {
        return this.httpClient.post(this.getApiUrl(url, extraInfo), data, options);
    }
    put(url, data, options, extraInfo) {
        return this.httpClient.put(this.getApiUrl(url, extraInfo), data, options);
    }
    delete(url, options, extraInfo) {
        return this.httpClient.delete(this.getApiUrl(url, extraInfo), options);
    }
    patch(url, data, options, extraInfo) {
        return this.httpClient.patch(this.getApiUrl(url, extraInfo), data, options);
    }
    getApiUrl(url, extraInfo) {
        return extraInfo?.static ? url : (this.serviceDomain || '') + this.config.serviceUrl + url;
    }
}
HttpService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: HttpService, deps: [{ token: i1$2.HttpClient }, { token: HTTP_MODULE_CONFIG }, { token: 'serviceDomain', optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
HttpService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: HttpService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: HttpService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [HTTP_MODULE_CONFIG]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['serviceDomain']
                }] }]; } });

class TranslateSourceService {
    constructor(httpService, config) {
        this.httpService = httpService;
        this.config = config;
    }
    getTranslations(language, tags) {
        const params = this.setHeaderTags(tags);
        const headers = new HttpHeaders().set('X-Lang', language);
        return this.httpService.get(`/${this.config.serviceVersion}/translations/languages/get-language-labels`, { params, headers });
    }
    setHeaderTags(tags) {
        let params = new HttpParams();
        if (tags) {
            tags.forEach((tag) => {
                params = params.append('tags', tag);
            });
        }
        return params;
    }
}
TranslateSourceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TranslateSourceService, deps: [{ token: HttpService }, { token: TRANSLATE_MODULE_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable });
TranslateSourceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TranslateSourceService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TranslateSourceService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: HttpService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [TRANSLATE_MODULE_CONFIG]
                }] }]; } });

class TranslateModule {
    static forRoot(config, isMock = false) {
        return {
            ngModule: TranslateModule,
            providers: [
                TranslateService,
                {
                    provide: ITranslateSource,
                    useClass: isMock ? TranslateSourceMockService : TranslateSourceService,
                },
                {
                    provide: TRANSLATE_MODULE_CONFIG,
                    useValue: { ...DEFAULT_TRANSLATE_MODULE_CONFIG, ...config },
                },
            ],
        };
    }
}
TranslateModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TranslateModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TranslateModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: TranslateModule, declarations: [TranslatePipe], imports: [SsrModule], exports: [TranslatePipe] });
TranslateModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TranslateModule, imports: [SsrModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TranslateModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TranslatePipe],
                    imports: [SsrModule],
                    exports: [TranslatePipe],
                    providers: [],
                }]
        }] });

class AppFormControlDirective {
    constructor(inputField, formControl) {
        this.inputField = inputField;
        this.formControl = formControl;
        this.SPECTRE_INPUT_CLASS = 'form-input';
        this.SPECTRE_INVALID_INPUT_CLASS = 'is-error';
        this.SPECTRE_VALID_INPUT_CLASS = 'is-success';
        this.destroy$ = new Subject();
        this.ENTER_KEY_CODE = 13;
        this.needNull = true;
        this.needTrim = true;
        this.decimals = 2;
        this.needDecimals = true;
    }
    onBlur() {
        if (!this.isCleanValue) {
            this.clearValue();
        }
        this.isCleanValue = false;
    }
    onKeydown(event) {
        if (event.keyCode === this.ENTER_KEY_CODE) {
            this.clearValue();
            this.isCleanValue = true;
        }
        else if (this.isNumberInput && !this.isValidNumberKeyboardEvent(event)) {
            event.preventDefault();
        }
    }
    onPaste(event) {
        const clipboardData = event.clipboardData || window['clipboardData'];
        const pastedText = clipboardData?.getData('text');
        if (this.isNumberInput && !this.isValidNumberValue(pastedText)) {
            event.preventDefault();
        }
    }
    ngOnInit() {
        this.isNumberInput = this.isNumberInputType();
        this.formControl.statusChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe({
            next: () => this.setInvalidClass(),
        });
        this.formControl.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe({
            next: () => {
                if (this.isNumberInput && this.inputField.nativeElement.validity.badInput) {
                    this.formControl.control.setErrors({ invalidNumberInput: true });
                }
            },
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    isNumberInputType() {
        return this.inputField.nativeElement.tagName.toLowerCase() === 'input' && this.inputField.nativeElement.type.toLowerCase() === 'number';
    }
    isValid() {
        return !Utils.isInvalidControl(this.formControl);
    }
    setInvalidClass() {
        const isValid = this.isValid();
        const method = isValid ? 'remove' : 'add';
        this.inputField.nativeElement.classList[method](AppFormControlDirective.INVALID_INPUT_CLASS);
        this.setSpectreInvalidClass(isValid);
    }
    setSpectreInvalidClass(isValid) {
        if (this.inputField.nativeElement.classList.contains(this.SPECTRE_INPUT_CLASS)) {
            const inValidState = isValid ? 'remove' : 'add';
            const validState = isValid && this.formControl.value ? 'add' : 'remove';
            if (this.formControl.touched) {
                this.inputField.nativeElement.classList[validState](this.SPECTRE_VALID_INPUT_CLASS);
                this.inputField.nativeElement.classList[inValidState](this.SPECTRE_INVALID_INPUT_CLASS);
            }
        }
    }
    setEmptyToNull() {
        if (this.needNull && this.formControl.value === '') {
            this.formControl.control.setValue(null);
        }
    }
    trimValue() {
        if (this.needTrim && this.formControl.value) {
            if (typeof this.formControl.value === 'number' && this.isNumberInput) {
                this.formControl.control.setValue(Utils.round10(this.formControl.value, this.decimals));
            }
            else if (typeof this.formControl.value === 'string') {
                this.formControl.control.setValue(this.formControl.value.trim());
            }
        }
    }
    clearValue() {
        if (this.inputField.nativeElement.type !== 'password') {
            this.trimValue();
            this.setEmptyToNull();
        }
        this.formControl.control.updateValueAndValidity();
    }
    isValidNumberValue(value) {
        const numberPattern = /^(-)|\d+$/;
        return numberPattern.test(value);
    }
    isCopyPasteKeyboardEvent(event) {
        return event.ctrlKey && (event.code === 'KeyX' || event.code === 'KeyC' || event.code === 'KeyV' || event.code === 'KeyA');
    }
    isValidNumberKeyboardEvent(event) {
        const standardInputPattern = '^(Delete|Backspace|ArrowLeft|ArrowRight|Home|End|Tab|Enter|NumpadEnter)';
        const decimalInputPattern = '|(\\,|\\.)';
        const requiredRegexPattern = this.needDecimals ? standardInputPattern + decimalInputPattern : standardInputPattern;
        const validKeyPattern = new RegExp(requiredRegexPattern);
        return this.isValidNumberValue(event.key) || validKeyPattern.test(event.key) || this.isCopyPasteKeyboardEvent(event);
    }
}
AppFormControlDirective.INVALID_INPUT_CLASS = 'is-invalid-input';
AppFormControlDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: AppFormControlDirective, deps: [{ token: i0.ElementRef }, { token: i1$3.NgControl }], target: i0.ɵɵFactoryTarget.Directive });
AppFormControlDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: AppFormControlDirective, selector: "[appFormControl]", inputs: { needNull: "needNull", needTrim: "needTrim", decimals: "decimals", needDecimals: "needDecimals" }, host: { listeners: { "focusout": "onBlur()", "keydown": "onKeydown($event)", "paste": "onPaste($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: AppFormControlDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appFormControl]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$3.NgControl }]; }, propDecorators: { needNull: [{
                type: Input
            }], needTrim: [{
                type: Input
            }], decimals: [{
                type: Input
            }], needDecimals: [{
                type: Input
            }], onBlur: [{
                type: HostListener,
                args: ['focusout']
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onPaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }] } });

const showErrorAnimation = trigger('showErrorAnimation', [
    transition(':enter', [
        style({ transform: 'translateY(-40%)', opacity: 0 }),
        animate(100, style({ transform: 'translateY(0)', opacity: 1 })),
    ]),
]);

// @dynamic
class ShowErrorsComponent {
    constructor() {
        this.defaultDateTimeFormat = 'D';
        this.isInvalid$ = new BehaviorSubject(false);
        this.dateTimeFormat = this.defaultDateTimeFormat;
        this.hasError = new EventEmitter();
    }
    get invalidInputClass() {
        return ShowErrorsComponent.INVALID_INPUT_CLASS;
    }
    ngOnInit() {
        this.setErrorMessageStream$();
    }
    setErrorMessageStream$() {
        this.errorMessage$ = this.control.statusChanges
            .pipe(startWith(this.control.valid ? 'VALID' : 'INVALID'), filter((status) => status === 'VALID' || status === 'INVALID'), switchMap(() => of(Utils.isInvalidControl(this.control) && this.control.errors)), distinctUntilChanged(), map((validationError) => !!validationError), tap((isInvalid) => this.isInvalid$.next(isInvalid)), delayWhen((isInvalid) => timer(isInvalid ? 0 : 100)), tap((isInvalid) => this.hasError.emit(isInvalid)), map((isInvalid) => isInvalid ? this.getFirstErrorMessage() : null));
    }
    getFirstErrorMessage() {
        if (this.control?.errors) {
            return Object.keys(this.control.errors)
                .map((field) => this.getMessage(field, this.control.errors[field]))
                .shift();
        }
    }
    getMessageParams(params, type) {
        switch (type) {
            case 'owlDateTimeMin': return { ...params, format: this.dateTimeFormat };
            case 'owlDateTimeMax': return { ...params, format: this.dateTimeFormat };
            default: return params;
        }
    }
    getMessage(type, params) {
        if (this.customMessage) {
            return { label: this.customMessage };
        }
        const messageType = ShowErrorsComponent.errorMessages[type] ? type : 'custom';
        const messageParams = this.getMessageParams(params, type);
        return ShowErrorsComponent.errorMessages[messageType](messageParams);
    }
}
ShowErrorsComponent.INVALID_INPUT_CLASS = 'input-error-message';
ShowErrorsComponent.errorMessages = {
    /**
     * @dynamic
     * For default Angular validators
     * {@link} https://angular.io/api/forms/Validators
     */
    invalidNumberInput: () => ({ label: 'invalid_number_input' }),
    required: () => ({ label: 'label_field_is_required' }),
    email: () => ({ label: 'ss_lang_invalid_email' }),
    min: (params) => ({ label: 'label_min_value', params: [params.min] }),
    max: (params) => ({ label: 'label_max_value', params: [params.max] }),
    minlength: (params) => ({ label: 'label_validation_min_length', params: [params.requiredLength] }),
    maxlength: (params) => ({ label: 'label_validation_max_length', params: [params.requiredLength] }),
    pattern: (params) => ({ label: 'label_validation_pattern', params: [params.requiredPattern] }),
    emailConflict: () => ({ label: 'email_already_registered_label' }),
    /**
     * For DateTimePicker validators
     * {@link} https://danielykpan.github.io/date-time-picker/
     */
    owlDateTimeParse: () => ({ label: 'label_validation_datetime_parse' }),
    owlDateTimeMin: (params) => ({ label: 'label_validation_datetime_min', params: [params.min.toFormat(params.format)] }),
    owlDateTimeMax: (params) => ({ label: 'label_validation_datetime_max', params: [params.max.toFormat(params.format)] }),
    owlDateTimeFilter: () => ({ label: 'label_validation_datetime_filter' }),
    owlDateTimeRange: () => ({ label: 'label_validation_datetime_range' }),
    /**
     * For custom app validators
     */
    custom: (params) => params,
};
ShowErrorsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ShowErrorsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ShowErrorsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: ShowErrorsComponent, selector: "app-show-errors", inputs: { control: "control", customMessage: "customMessage", dateTimeFormat: "dateTimeFormat" }, outputs: { hasError: "hasError" }, ngImport: i0, template: "<ul @showErrorAnimation *ngIf=\"errorMessage$ | async as errorMessage\" class=\"{{ invalidInputClass }} app-show-error\" [class.hide-message]=\"(isInvalid$ | async) === false\">\n  <li>{{ errorMessage.label | translate: errorMessage?.params }}</li>\n</ul>\n", styles: [":host{display:flex;height:16px;margin-top:-16px}:host ul.app-show-error{display:flex;width:100%;margin:0;color:#d9534f;font-size:.72rem;font-style:italic;list-style-type:none;transition:opacity .1s ease-in-out,transform .1s ease-in-out}:host ul.app-show-error.hide-message{opacity:0;transform:translateY(-40%)}:host ul.app-show-error li{overflow:hidden;width:100%;text-overflow:ellipsis;white-space:nowrap}\n"], dependencies: [{ kind: "directive", type: i1$4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: TranslatePipe, name: "translate" }, { kind: "pipe", type: i1$4.AsyncPipe, name: "async" }], animations: [showErrorAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ShowErrorsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-show-errors', changeDetection: ChangeDetectionStrategy.OnPush, animations: [showErrorAnimation], template: "<ul @showErrorAnimation *ngIf=\"errorMessage$ | async as errorMessage\" class=\"{{ invalidInputClass }} app-show-error\" [class.hide-message]=\"(isInvalid$ | async) === false\">\n  <li>{{ errorMessage.label | translate: errorMessage?.params }}</li>\n</ul>\n", styles: [":host{display:flex;height:16px;margin-top:-16px}:host ul.app-show-error{display:flex;width:100%;margin:0;color:#d9534f;font-size:.72rem;font-style:italic;list-style-type:none;transition:opacity .1s ease-in-out,transform .1s ease-in-out}:host ul.app-show-error.hide-message{opacity:0;transform:translateY(-40%)}:host ul.app-show-error li{overflow:hidden;width:100%;text-overflow:ellipsis;white-space:nowrap}\n"] }]
        }], propDecorators: { control: [{
                type: Input
            }], customMessage: [{
                type: Input
            }], dateTimeFormat: [{
                type: Input
            }], hasError: [{
                type: Output
            }] } });

const resolvedPromise = Promise.resolve(null);
class AppFormDirective {
    constructor(parentForm, // for nestable forms
    injector, element) {
        this.parentForm = parentForm;
        this.injector = injector;
        this.element = element;
        this.scrollIntoViewOptions = { block: 'start', behavior: 'smooth' };
        this.groupName = '';
        this.arrayName = AppFormDirective.FORM_ARRAY_NAME;
        this.needValidate = true;
        this.rootAppForm = false;
    }
    ngOnInit() {
        if (!this.currentForm) {
            // NOTE: at this point both NgForm and ReactiveFrom should be available
            this.executePostponed(() => this.resolveAndRegister());
        }
    }
    ngOnDestroy() {
        this.executePostponed(() => {
            if (this.parentForm) {
                this.parentForm.removeControl(this.currentForm, this.groupName, this.arrayName);
            }
        });
    }
    onsubmit() {
        if (this.needValidate) {
            this.validate();
        }
    }
    registerNestedForm(control, childFormGroupName, childFormArrayName) {
        // NOTE: prevent circular reference (adding to itself)
        if (control === this.currentForm) {
            throw new Error('Trying to add itself! Nestable form can be added only on parent "NgForm" or "FormGroup".');
        }
        if (childFormGroupName) {
            this.currentForm.addControl(childFormGroupName, control);
        }
        else {
            if (!this.currentForm.get(childFormArrayName)) {
                this.currentForm.addControl(childFormArrayName, new UntypedFormArray([]));
            }
            this.currentForm.get(childFormArrayName).push(control);
        }
    }
    removeControl(control, childFormGroupName, childFormArrayName) {
        if (childFormGroupName && this.currentForm.get(childFormGroupName) !== null) {
            // Group, Control
            this.currentForm.removeControl(childFormGroupName);
        }
        else if (this.currentForm.get(childFormArrayName) !== null) {
            // Array
            const array = this.currentForm.get(childFormArrayName);
            const idx = array.controls.indexOf(control);
            array.removeAt(idx);
        }
    }
    validate(scroll = true, path) {
        const formGroup = path ? this.formGroup.get(path) : this.formGroup;
        this.touchInvalidFields(formGroup);
        if (this.formGroup.invalid && scroll) {
            if (!this.scrollToFirstInvalidField()) {
                setTimeout(() => this.scrollToFirstInvalidMessage());
            }
        }
    }
    resolveAndRegister() {
        this.currentForm = this.resolveCurrentForm();
        this.registerToParent();
    }
    resolveCurrentForm() {
        // NOTE: template-driven or model-driven => determine by the formGroup input
        return this.formGroup ? this.formGroup : this.injector.get(NgForm).control;
    }
    registerToParent() {
        if (this.parentForm !== null && !this.rootAppForm) {
            this.parentForm.registerNestedForm(this.currentForm, this.groupName, this.arrayName);
        }
    }
    executePostponed(callback) {
        resolvedPromise.then(() => callback());
    }
    markAsEdited(control, self = true) {
        control.markAsTouched({ onlySelf: self });
        control.markAsDirty({ onlySelf: self });
        control.updateValueAndValidity({ onlySelf: self });
    }
    /**
     * Összes invalid mező érintése a validációs hibaüzenetek megjelenítéséhez
     *
     * @method touchInvalidFields
     * @access private
     */
    touchInvalidFields(formGroup) {
        Object.keys(formGroup.controls).forEach((field) => {
            const control = formGroup.get(field);
            if (control.valid) {
                return;
            }
            if (control instanceof UntypedFormControl) {
                this.markAsEdited(control);
            }
            else if (control instanceof UntypedFormGroup) {
                this.markAsEdited(control);
                this.touchInvalidFields(control);
            }
            else if (control instanceof UntypedFormArray) {
                this.markAsEdited(control);
                for (const iterator of control.controls) {
                    if (iterator.valid) {
                        continue;
                    }
                    if (iterator instanceof UntypedFormControl) {
                        this.markAsEdited(control);
                    }
                    else if (iterator instanceof UntypedFormGroup) {
                        this.touchInvalidFields(iterator);
                    }
                }
            }
        });
    }
    /**
     * Az első invalid input mezőhöz scrollozza a képernyőt
     * {@link} Scrolling based on this: http://iamdustan.com/smoothscroll/
     *
     * @method scrollToFirstInvalidField
     * @access private
     */
    scrollToFirstInvalidField() {
        const invalidField = this.element.nativeElement.querySelector(`.${AppFormControlDirective.INVALID_INPUT_CLASS}`);
        if (invalidField) {
            const fieldLabel = invalidField.closest('label');
            if (fieldLabel) {
                fieldLabel.scrollIntoView(this.scrollIntoViewOptions);
            }
            else {
                invalidField.scrollIntoView(this.scrollIntoViewOptions);
            }
            return true;
        }
        return false;
    }
    /**
     * Az első aktív ShowErrorsComponent-hez scrollozza a képernyőt
     * {@link} Scrolling based on this: http://iamdustan.com/smoothscroll/
     *
     * @method scrollToFirstInvalidMessage
     * @access private
     */
    scrollToFirstInvalidMessage() {
        const invalidMessage = this.element.nativeElement.querySelector(`.${ShowErrorsComponent.INVALID_INPUT_CLASS}`);
        if (invalidMessage) {
            invalidMessage.scrollIntoView({ behavior: 'smooth' });
            return true;
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
    }
}
AppFormDirective.FORM_ARRAY_NAME = 'CHILD_FORMS';
AppFormDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: AppFormDirective, deps: [{ token: AppFormDirective, optional: true, skipSelf: true }, { token: i0.Injector }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
AppFormDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: AppFormDirective, selector: "[appForm]", inputs: { formGroup: "formGroup", formName: "formName", groupName: ["appFormGroupName", "groupName"], arrayName: ["appFormArrayName", "arrayName"], needValidate: "needValidate", rootAppForm: "rootAppForm" }, host: { listeners: { "submit": "onsubmit()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: AppFormDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appForm]',
                }]
        }], ctorParameters: function () { return [{ type: AppFormDirective, decorators: [{
                    type: SkipSelf
                }, {
                    type: Optional
                }] }, { type: i0.Injector }, { type: i0.ElementRef }]; }, propDecorators: { formGroup: [{
                type: Input
            }], formName: [{
                type: Input
            }], groupName: [{
                type: Input,
                args: ['appFormGroupName']
            }], arrayName: [{
                type: Input,
                args: ['appFormArrayName']
            }], needValidate: [{
                type: Input
            }], rootAppForm: [{
                type: Input
            }], onsubmit: [{
                type: HostListener,
                args: ['submit']
            }] } });

class FormModule {
}
FormModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FormModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FormModule, declarations: [ShowErrorsComponent, AppFormControlDirective, AppFormDirective], imports: [TranslateModule, CommonModule], exports: [ShowErrorsComponent, AppFormControlDirective, AppFormDirective] });
FormModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FormModule, imports: [TranslateModule, CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FormModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [TranslateModule, CommonModule],
                    declarations: [ShowErrorsComponent, AppFormControlDirective, AppFormDirective],
                    exports: [ShowErrorsComponent, AppFormControlDirective, AppFormDirective],
                }]
        }] });

class MaterialIconComponent {
    constructor() {
        this.class = 'material-icons';
        this.translate = 'no';
    }
}
MaterialIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: MaterialIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MaterialIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: MaterialIconComponent, selector: "material-icon", host: { properties: { "class": "this.class", "attr.translate": "this.translate" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: MaterialIconComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'material-icon',
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], translate: [{
                type: HostBinding,
                args: ['attr.translate']
            }] } });

class MaterialModule {
}
MaterialModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: MaterialModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MaterialModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: MaterialModule, declarations: [MaterialIconComponent], imports: [CommonModule], exports: [MaterialIconComponent] });
MaterialModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: MaterialModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: MaterialModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [MaterialIconComponent],
                    exports: [MaterialIconComponent],
                }]
        }] });

class InlineInputComponent {
    get formControl() {
        return this.form.get(this.controlName);
    }
}
InlineInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: InlineInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
InlineInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: InlineInputComponent, selector: "inline-input", inputs: { form: "form", controlName: "controlName", editorMode: "editorMode" }, ngImport: i0, template: "<div class=\"inline-editor-input\" [class.editor-mode]=\"editorMode\" [formGroup]=\"form\">\n  <div class=\"input-group\">\n    <div class=\"input-value\">\n      <input type=\"text\" class=\"input-group-field\" appFormControl [formControlName]=\"controlName\">\n      <p>{{ formControl.value }}</p>\n    </div>\n    <div class=\"input-group-button\">\n      <ng-content select=\"[toggle-button]\"></ng-content>\n    </div>\n  </div>\n  <app-show-errors [control]=\"formControl\"></app-show-errors>\n</div>\n", styles: [":host{display:block}:host .inline-editor-input.editor-mode p{visibility:hidden;height:0}:host .inline-editor-input .input-value{min-width:175px}:host .inline-editor-input p{height:36px;margin:0;padding-right:10px;font-size:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}:host .inline-editor-input:not(.editor-mode) input{display:none}\n"], dependencies: [{ kind: "directive", type: i1$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$3.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: ShowErrorsComponent, selector: "app-show-errors", inputs: ["control", "customMessage", "dateTimeFormat"], outputs: ["hasError"] }, { kind: "directive", type: AppFormControlDirective, selector: "[appFormControl]", inputs: ["needNull", "needTrim", "decimals", "needDecimals"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: InlineInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'inline-input', template: "<div class=\"inline-editor-input\" [class.editor-mode]=\"editorMode\" [formGroup]=\"form\">\n  <div class=\"input-group\">\n    <div class=\"input-value\">\n      <input type=\"text\" class=\"input-group-field\" appFormControl [formControlName]=\"controlName\">\n      <p>{{ formControl.value }}</p>\n    </div>\n    <div class=\"input-group-button\">\n      <ng-content select=\"[toggle-button]\"></ng-content>\n    </div>\n  </div>\n  <app-show-errors [control]=\"formControl\"></app-show-errors>\n</div>\n", styles: [":host{display:block}:host .inline-editor-input.editor-mode p{visibility:hidden;height:0}:host .inline-editor-input .input-value{min-width:175px}:host .inline-editor-input p{height:36px;margin:0;padding-right:10px;font-size:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}:host .inline-editor-input:not(.editor-mode) input{display:none}\n"] }]
        }], propDecorators: { form: [{
                type: Input
            }], controlName: [{
                type: Input
            }], editorMode: [{
                type: Input
            }] } });

class PasswordInputComponent {
    constructor() {
        this.inputType$ = new BehaviorSubject('password');
        this.inputId = '';
        this.onFocus = new EventEmitter();
        this.onBlur = new EventEmitter();
    }
    toggleInputType() {
        if (this.form.get(this.controlName).enabled) {
            this.inputType$.next(this.inputType$.getValue() === 'password' ? 'text' : 'password');
        }
    }
}
PasswordInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: PasswordInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PasswordInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: PasswordInputComponent, selector: "password-input", inputs: { form: "form", controlName: "controlName", inputClass: "inputClass", placeholder: "placeholder", inputId: "inputId" }, outputs: { onFocus: "onFocus", onBlur: "onBlur" }, ngImport: i0, template: "<div class=\"input-group password-input password-input-{{ controlName }}\" [formGroup]=\"form\">\n\n  <input\n    appFormControl\n    class=\"input-group-field {{ inputClass }}\"\n    [id]=\"inputId\"\n    [type]=\"inputType$ | async\"\n    [formControlName]=\"controlName\"\n    [placeholder]=\"placeholder | translate\"\n    (focus)=\"onFocus.next()\"\n    (blur)=\"onBlur.next()\"\n    autocomplete=\"off\">\n\n  <span class=\"input-group-label\" (click)=\"toggleInputType()\">\n    <material-icon>{{ (inputType$ | async) === 'password' ? 'visibility' : 'visibility_off' }}</material-icon>\n  </span>\n\n</div>\n", styles: [":host{display:block}:host .password-input{display:flex;width:100%;align-items:stretch}:host .password-input .input-group-field{min-width:0;flex:1 1 0;margin:0;white-space:nowrap}:host .password-input .input-group-label{display:flex;flex:0 0 auto;align-items:center;padding:0 10px;border:1px solid #999;background-color:#fff;color:#000;cursor:pointer;text-align:center;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;user-select:none}:host .password-input .input-group-label material-icon{padding:0;margin:0;font-size:20px}:host .password-input input:disabled+.input-group-label{cursor:not-allowed;opacity:.75}\n"], dependencies: [{ kind: "directive", type: i1$3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$3.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: AppFormControlDirective, selector: "[appFormControl]", inputs: ["needNull", "needTrim", "decimals", "needDecimals"] }, { kind: "component", type: MaterialIconComponent, selector: "material-icon" }, { kind: "pipe", type: i1$4.AsyncPipe, name: "async" }, { kind: "pipe", type: TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: PasswordInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'password-input', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"input-group password-input password-input-{{ controlName }}\" [formGroup]=\"form\">\n\n  <input\n    appFormControl\n    class=\"input-group-field {{ inputClass }}\"\n    [id]=\"inputId\"\n    [type]=\"inputType$ | async\"\n    [formControlName]=\"controlName\"\n    [placeholder]=\"placeholder | translate\"\n    (focus)=\"onFocus.next()\"\n    (blur)=\"onBlur.next()\"\n    autocomplete=\"off\">\n\n  <span class=\"input-group-label\" (click)=\"toggleInputType()\">\n    <material-icon>{{ (inputType$ | async) === 'password' ? 'visibility' : 'visibility_off' }}</material-icon>\n  </span>\n\n</div>\n", styles: [":host{display:block}:host .password-input{display:flex;width:100%;align-items:stretch}:host .password-input .input-group-field{min-width:0;flex:1 1 0;margin:0;white-space:nowrap}:host .password-input .input-group-label{display:flex;flex:0 0 auto;align-items:center;padding:0 10px;border:1px solid #999;background-color:#fff;color:#000;cursor:pointer;text-align:center;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;user-select:none}:host .password-input .input-group-label material-icon{padding:0;margin:0;font-size:20px}:host .password-input input:disabled+.input-group-label{cursor:not-allowed;opacity:.75}\n"] }]
        }], propDecorators: { form: [{
                type: Input
            }], controlName: [{
                type: Input
            }], inputClass: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], inputId: [{
                type: Input
            }], onFocus: [{
                type: Output
            }], onBlur: [{
                type: Output
            }] } });

const components$1 = [
    PasswordInputComponent,
    InlineInputComponent,
];
class CustomInputModule {
}
CustomInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: CustomInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CustomInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: CustomInputModule, declarations: [PasswordInputComponent,
        InlineInputComponent], imports: [CommonModule,
        ReactiveFormsModule,
        FormModule,
        TranslateModule,
        MaterialModule], exports: [PasswordInputComponent,
        InlineInputComponent] });
CustomInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: CustomInputModule, imports: [CommonModule,
        ReactiveFormsModule,
        FormModule,
        TranslateModule,
        MaterialModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: CustomInputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormModule,
                        TranslateModule,
                        MaterialModule,
                    ],
                    declarations: [
                        ...components$1,
                    ],
                    exports: [
                        ...components$1,
                    ],
                }]
        }] });

class PageNotFoundComponent {
}
PageNotFoundComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: PageNotFoundComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PageNotFoundComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: PageNotFoundComponent, selector: "app-page-not-found", ngImport: i0, template: "<div class=\"jumbo\">\n  <div class=\"jumbo-icon\">404</div>\n  <p class=\"jumbo-title\">{{ 'stemx_page_not_found' | translate }}</p>\n  <p class=\"jumbo-subtitle\">\n    <a class=\"jumbo-btn\" [routerLink]=\"[ '/' ]\">{{ 'label_home' | translate }}</a>\n  </p>\n</div>\n", styles: [":host{display:flex;height:100%;flex:1 1 100%;flex-flow:column;justify-content:center;background:#fdfdfd;color:#8c8c8c;font-family:Verdana,Geneva,Tahoma,sans-serif}:host .jumbo{padding:64px 32px;text-align:center}:host .jumbo .jumbo-icon{font-size:100px;line-height:100px}:host .jumbo .jumbo-title,:host .jumbo .jumbo-subtitle{margin:8px auto}:host .jumbo .jumbo-title{font-size:30px}:host .jumbo .jumbo-subtitle{padding-top:10px;font-size:20px}:host .jumbo .jumbo-btn{padding:10px 23px;background:#39b4e3;border-radius:23px;color:#fdfdfd;letter-spacing:.75px;text-transform:uppercase}:host .jumbo .jumbo-btn:hover{background:#2d9dc9}\n"], dependencies: [{ kind: "directive", type: i1$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "pipe", type: TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: PageNotFoundComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-page-not-found', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"jumbo\">\n  <div class=\"jumbo-icon\">404</div>\n  <p class=\"jumbo-title\">{{ 'stemx_page_not_found' | translate }}</p>\n  <p class=\"jumbo-subtitle\">\n    <a class=\"jumbo-btn\" [routerLink]=\"[ '/' ]\">{{ 'label_home' | translate }}</a>\n  </p>\n</div>\n", styles: [":host{display:flex;height:100%;flex:1 1 100%;flex-flow:column;justify-content:center;background:#fdfdfd;color:#8c8c8c;font-family:Verdana,Geneva,Tahoma,sans-serif}:host .jumbo{padding:64px 32px;text-align:center}:host .jumbo .jumbo-icon{font-size:100px;line-height:100px}:host .jumbo .jumbo-title,:host .jumbo .jumbo-subtitle{margin:8px auto}:host .jumbo .jumbo-title{font-size:30px}:host .jumbo .jumbo-subtitle{padding-top:10px;font-size:20px}:host .jumbo .jumbo-btn{padding:10px 23px;background:#39b4e3;border-radius:23px;color:#fdfdfd;letter-spacing:.75px;text-transform:uppercase}:host .jumbo .jumbo-btn:hover{background:#2d9dc9}\n"] }]
        }] });

function Browser() {
    return (target, propertyKey, propertyDescriptor) => {
        const originalMethod = propertyDescriptor.value;
        propertyDescriptor.value = function (...args) {
            if (isBrowser) {
                return originalMethod.call(this, ...args);
            }
        };
    };
}

class PageServerErrorComponent {
    constructor(route, ssrService) {
        this.route = route;
        this.ssrService = ssrService;
        this.translations = {
            [LanguageCode.EN]: {
                title: 'An error has occured!',
                description: 'The server is unavailable now.<br>Please come back later.',
                refresh: 'Refresh',
            },
            [LanguageCode.HU]: {
                title: 'Hiba történt!',
                description: 'A kiszolgáló épp nem elérhető.<br>Kérjük látogasson vissza később.',
                refresh: 'Frissítés',
            },
            [LanguageCode.DA]: {
                title: 'Der er opstået en fejl!',
                description: 'Serveren er ikke tilgængelig.<br>Prøv venligst igen senere.',
                refresh: 'Opdater',
            },
            [LanguageCode.PL]: {
                title: 'Wystąpił błąd!',
                description: 'Serwer jest teraz niedostępny.<br>Proszę spróbować później.',
                refresh: 'Odśwież',
            },
        };
    }
    ngOnInit() {
        this.reloadUrl = this.route.snapshot.queryParams['reloadUrl'];
        this.setLang();
        this.setTranslation();
    }
    setLang() {
        this.lang = (this.ssrService.navigator.language.replace(/-.*/, '') || 'en');
    }
    setTranslation() {
        this.translation = this.translations[this.lang] || this.translations[LanguageCode.EN];
    }
    reload() {
        if (this.reloadUrl) {
            this.ssrService.location.href = decodeURI(this.reloadUrl);
            this.ssrService.location.reload();
        }
        else {
            this.ssrService.location.href = this.ssrService.location.origin;
        }
    }
}
PageServerErrorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: PageServerErrorComponent, deps: [{ token: i1$1.ActivatedRoute }, { token: SsrService }], target: i0.ɵɵFactoryTarget.Component });
PageServerErrorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: PageServerErrorComponent, selector: "app-page-server-error", ngImport: i0, template: "<div class=\"jumbo\">\n  <div class=\"jumbo-icon\">\n    <material-icon>cloud_off</material-icon>\n  </div>\n  <p class=\"jumbo-title\">{{ translation.title }}</p>\n  <div class=\"jumbo-subtitle\">\n    <p [innerHTML]=\"translation.description\"></p>\n    <button class=\"jumbo-btn\" (click)=\"reload()\">{{ translation.refresh }}</button>\n  </div>\n</div>\n", styles: [":host{display:flex;height:100%;flex:1 1 100%;flex-flow:column;justify-content:center;background:#fdfdfd;color:#8c8c8c;font-family:Verdana,Geneva,Tahoma,sans-serif}:host .jumbo{padding:64px 32px;text-align:center}:host .jumbo .jumbo-icon{margin-bottom:16px}:host .jumbo .jumbo-icon material-icon{font-size:100px}:host .jumbo .jumbo-title,:host .jumbo .jumbo-subtitle{margin:8px auto}:host .jumbo .jumbo-title{font-size:30px}:host .jumbo .jumbo-subtitle{font-size:20px}:host .jumbo .jumbo-btn{padding:10px 23px;border:none;background:#39b4e3;border-radius:23px;color:#fdfdfd;letter-spacing:.75px;text-transform:uppercase}:host .jumbo .jumbo-btn:hover{background:#2d9dc9}\n"], dependencies: [{ kind: "component", type: MaterialIconComponent, selector: "material-icon" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    Browser()
], PageServerErrorComponent.prototype, "setLang", null);
__decorate([
    Browser()
], PageServerErrorComponent.prototype, "reload", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: PageServerErrorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-page-server-error', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"jumbo\">\n  <div class=\"jumbo-icon\">\n    <material-icon>cloud_off</material-icon>\n  </div>\n  <p class=\"jumbo-title\">{{ translation.title }}</p>\n  <div class=\"jumbo-subtitle\">\n    <p [innerHTML]=\"translation.description\"></p>\n    <button class=\"jumbo-btn\" (click)=\"reload()\">{{ translation.refresh }}</button>\n  </div>\n</div>\n", styles: [":host{display:flex;height:100%;flex:1 1 100%;flex-flow:column;justify-content:center;background:#fdfdfd;color:#8c8c8c;font-family:Verdana,Geneva,Tahoma,sans-serif}:host .jumbo{padding:64px 32px;text-align:center}:host .jumbo .jumbo-icon{margin-bottom:16px}:host .jumbo .jumbo-icon material-icon{font-size:100px}:host .jumbo .jumbo-title,:host .jumbo .jumbo-subtitle{margin:8px auto}:host .jumbo .jumbo-title{font-size:30px}:host .jumbo .jumbo-subtitle{font-size:20px}:host .jumbo .jumbo-btn{padding:10px 23px;border:none;background:#39b4e3;border-radius:23px;color:#fdfdfd;letter-spacing:.75px;text-transform:uppercase}:host .jumbo .jumbo-btn:hover{background:#2d9dc9}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.ActivatedRoute }, { type: SsrService }]; }, propDecorators: { setLang: [], reload: [] } });

const ErrorPageRoutes = [
    {
        path: 'server-error',
        component: PageServerErrorComponent,
    },
    {
        path: '**',
        component: PageNotFoundComponent,
    },
];

class ErrorPageModule {
}
ErrorPageModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ErrorPageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ErrorPageModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: ErrorPageModule, declarations: [PageServerErrorComponent,
        PageNotFoundComponent], imports: [i1$1.RouterModule, SsrModule,
        TranslateModule,
        MaterialModule] });
ErrorPageModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ErrorPageModule, imports: [RouterModule.forChild(ErrorPageRoutes),
        SsrModule,
        TranslateModule,
        MaterialModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ErrorPageModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        RouterModule.forChild(ErrorPageRoutes),
                        SsrModule,
                        TranslateModule,
                        MaterialModule,
                    ],
                    declarations: [
                        PageServerErrorComponent,
                        PageNotFoundComponent,
                    ],
                }]
        }] });

/**
 * {@link} https://gist.github.com/ShreyKumar/43ebb040383c90ed976439245423aa38
 * {@link} https://stackoverflow.com/a/7185241/13183117
 */
const zipCodePattern = {
    ad: /^[0-9]{5}$/,
    af: /^[0-9]{4}$/,
    ai: /^AI-2640$/,
    al: /^(120|122)[0-9]{2}$/,
    am: /^[0-9]{4}$/,
    ar: /^[A-Z]{1}[0-9]{4}[A-Z]{3}$/,
    as: /^[0-9]{5}$/,
    at: /^[0-9]{4}$/,
    au: /^[0-9]{4}$/,
    ax: /^22\d{3}$/,
    az: /^[0-9]{4}$/,
    ba: /^[0-9]{5}$/,
    bb: /^BB[0-9]{5}$/,
    bd: /^[0-9]{4}$/,
    be: /^[0-9]{4}$/,
    bg: /^[0-9]{4}$/,
    bl: /^[0-9]{5}$/,
    bm: /^[A-Z]{2}[0-9]{2}$/,
    bn: /^[A-Z]{2}[0-9]{4}$/,
    br: /^[0-9]{5}-[0-9]{3}$/,
    bt: /^[0-9]{5}$/,
    by: /^[0-9]{6}$/,
    ca: /^[A-Z][0-9][A-Z] ?[0-9][A-Z][0-9]$/,
    cc: /^6799$/,
    ch: /^[0-9]{4}$/,
    ci: /^[0-9]{5}$/,
    cl: /^[0-9]{7}$/,
    cn: /^[0-9]{6}$/,
    co: /^[0-9]{6}$/,
    cr: /^[0-9]{5}$/,
    cu: /^[0-9]{5}$/,
    cv: /^[0-9]{4}$/,
    cx: /^6798$/,
    cy: /^[0-9]{4}$/,
    cz: /^[0-9]{3} [0-9]{2}$/,
    de: /^[0-9]{5}$/,
    dk: /^[0-9]{4}$/,
    do: /^[0-9]{5}$/,
    dz: /^[0-9]{5}$/,
    ec: /^[0-9]{6}$/,
    ee: /^[0-9]{5}$/,
    eg: /^[0-9]{5}$/,
    es: /^[0-9]{5}$/,
    et: /^[0-9]{4}$/,
    fi: /^[0-9]{5}$/,
    fk: /^FIQQ 1ZZ$/,
    fm: /^(9694[1-4])([ -]\d{4})?$/,
    fo: /^[0-9]{3}$/,
    fr: /^[0-9]{5}$/,
    gb: /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/,
    gf: /^973[0-9]{2}$/,
    gg: /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/,
    gi: /^GX11 1AA$/,
    gl: /^[0-9]{4}$/,
    gn: /^[0-9]{3}$/,
    gp: /^971[0-9]{2}$/,
    gr: /^[0-9]{3} [0-9]{2}$/,
    gs: /^SIQQ 1ZZ$/,
    gt: /^[0-9]{5}$/,
    gu: /^\d{5}(?:[-\s]\d{4})?$/,
    gw: /^[0-9]{4}$/,
    hm: /^\d{4}$/,
    hn: /^[0-9]{5}$/,
    hr: /^[0-9]{5}$/,
    ht: /^[0-9]{4}$/,
    hu: /^[0-9]{4}$/,
    id: /^[0-9]{5}$/,
    ie: /^(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/,
    il: /^[0-9]{5}|[0-9]{7}$/,
    im: /^IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
    in: /^[1-9][0-9]{5}$/,
    io: /^BBND 1ZZ$/,
    iq: /^[0-9]{5}$/,
    ir: /^[0-9]{5}$/,
    is: /^[0-9]{3}$/,
    it: /^[0-9]{5}$/,
    je: /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/,
    jo: /^[0-9]{5}$/,
    jp: /^[0-9]{3}-[0-9]{4}$/,
    ke: /^[0-9]{5}$/,
    kg: /^[0-9]{6}$/,
    kh: /^[0-9]{5}$/,
    kn: /^[A-Z]{2}[0-9]{4}$/,
    kr: /^[0-9]{5}$/,
    kw: /^[0-9]{5}$/,
    ky: /^[A-Z]{2}[0-9]-[0-9]{4}$/,
    kz: /^[0-9]{6}$/,
    la: /^[0-9]{5}$/,
    lb: /^[0-9]{4} [0-9]{4}$/,
    lc: /^[A-Z]{2}[0-9]{2} [0-9]{3}$/,
    li: /^[0-9]{4}$/,
    lk: /^[0-9]{4}$/,
    lr: /^[0-9]{4}$/,
    ls: /^[0-9]{3}$/,
    lt: /^LT-[0-9]{5}$/,
    lu: /^[0-9]{4}$/,
    lv: /^LV-[0-9]{4}$/,
    ma: /^[0-9]{5}$/,
    mc: /^980[0-9]{2}$/,
    md: /^MD-?[0-9]{4}$/,
    me: /^[0-9]{5}$/,
    mg: /^[0-9]{3}$/,
    mh: /^\d{5}(?:[-\s]\d{4})?$/,
    mk: /^[0-9]{4}$/,
    mm: /^[0-9]{5}$/,
    mn: /^[0-9]{5}$/,
    mp: /^\d{5}(?:[-\s]\d{4})?$/,
    mq: /^972[0-9]{2}$/,
    ms: /^MSR [0-9]{4}$/,
    mt: /^[A-Z]{3} [0-9]{4}$/,
    mu: /^[0-9]{5}$/,
    mv: /^[0-9]{5}$/,
    mx: /^[0-9]{5}$/,
    my: /^[0-9]{5}$/,
    mz: /^[0-9]{4}$/,
    nc: /^988[0-9]{2}$/,
    ne: /^[0-9]{4}$/,
    nf: /^2899$/,
    ng: /^[0-9]{6}$/,
    nl: /^(?:NL-)?(\d{4})\s*([A-Z]{2})$/i,
    no: /^[0-9]{4}$/,
    np: /^[0-9]{5}$/,
    nz: /^[0-9]{4}$/,
    om: /^[0-9]{3}$/,
    pa: /^[0-9]{4}$/,
    pe: /^[0-9]{5}$/,
    pf: /^987[0-9]{2}$/,
    pg: /^[0-9]{3}$/,
    ph: /^[0-9]{4}$/,
    pk: /^[0-9]{5}$/,
    pl: /^[0-9]{2}-[0-9]{3}$/,
    pm: /^9[78]5\d{2}$/,
    pn: /^PCRN 1ZZ$/,
    pr: /^\d{5}(?:[-\s]\d{4})?$/,
    pt: /^[0-9]{4}-[0-9]{3}$/,
    pw: /^\d{5}(?:[-\s]\d{4})?$/,
    py: /^[0-9]{4}$/,
    re: /^974[0-9]{2}$/,
    ro: /^[0-9]{6}$/,
    rs: /^[0-9]{5}$/,
    ru: /^[0-9]{6}$/,
    sa: /^[0-9]{5}(-[0-9]{4})?$/,
    sd: /^[0-9]{5}$/,
    se: /^\d{3} ?\d{2}$/,
    sg: /^[0-9]{6}$/,
    sh: /^STHL 1ZZ$/,
    si: /^[0-9]{4}$/,
    sj: /^\d{4}$/,
    sk: /^[0-9]{3} [0-9]{2}$/,
    sm: /^4789\d$/,
    sn: /^[0-9]{5}$/,
    so: /^[A-Z]{2} [0-9]{5}$/,
    sv: /^[0-9]{4}$/,
    sz: /^[A-Z]{1}[0-9]{3}$/,
    tc: /^TKCA 1ZZ$/,
    th: /^[0-9]{5}$/,
    tj: /^\d{6}$/,
    tm: /^[0-9]{6}$/,
    tn: /^[0-9]{4}$/,
    tr: /^[0-9]{5}$/,
    tt: /^[0-9]{6}$/,
    tw: /^[0-9]{3}(-[0-9]{2})?$/,
    tz: /^[0-9]{5}$/,
    ua: /^[0-9]{5}$/,
    us: /^\d{5}(?:[-\s]\d{4})?$/,
    uy: /^[0-9]{5}$/,
    uz: /^[0-9]{6}$/,
    va: /^00120$/,
    vc: /^VC[0-9]{4}$/,
    ve: /^[0-9]{4}(-[A-Z]{1})?$/,
    vg: /^VG[0-9]{4}$/,
    vi: /^[0-9]{5}$/,
    vn: /^[0-9]{6}$/,
    wf: /^986\d{2}$/,
    ws: /^WS[0-9]{4}$/,
    xk: /^[0-9]{5}$/,
    yt: /^976[0-9]{2}$/,
    za: /^[0-9]{4}$/,
    zm: /^[0-9]{5}$/,
};

const acceptTermsValidator = (formControl) => {
    const accepted = formControl.value === true;
    const message = { acceptTerms: { label: 'label_accept_terms_mandatory' } };
    return accepted ? null : message;
};

/**
 * Check phone number on pattern
 * - 7-20 digits
 * - optional prefix: +
 * - optional separators: single space or -
 * - parenthesis: digits at their open sides, digits or optional separators at their closed sides
 */
const advancedPhoneValidator = (formControl) => {
    const phonePattern = /^(\+\s?)?(((\(?\d\)?)(\s|-)?)){6,19}(\()?[\d](\))?$/;
    const message = { phone: { label: 'label_validation_phone_advanced' } };
    return phonePattern.test(formControl.value) || !formControl.value ? null : message;
};

/**
 * Check that all controls is empty or valid in FormGroup on the parameter passed ValidatorFn
 */
const allEmptyOrValidValidator = (validator, errorMessage) => (group) => {
    if (!group || !group.controls) {
        return null;
    }
    const hasAnyFilled = Object.keys(group.controls).some((key) => group.controls[key].value !== '' && group.controls[key].value !== null);
    if (!hasAnyFilled) {
        // all fields are empty
        return null;
    }
    const hasAnyInvalid = Object.keys(group.controls).some((key) => !!validator(group.controls[key]));
    if (!hasAnyInvalid) {
        // all fields are valid
        return null;
    }
    return { allEmptyOrValid: { label: errorMessage } };
};

const arrayLengthValidator = (formControl) => {
    const message = { arrayLength: { label: 'lang_select_at_least_one' } };
    const value = formControl.value;
    return Array.isArray(value) && value.length > 0 ? null : message;
};

/**
 * Check that at least one control is filled in array
 */
const atLeastOneRequiredValidator = (array) => {
    const hasAtLeastOneFilled = array && array.controls && array.controls.some((group) => group.value.value);
    const message = { atLeastOneRequired: { label: 'label_at_least_one_field_required' } };
    return hasAtLeastOneFilled ? null : message;
};

/**
 * Check that at least one control is valid in group
 */
const atLeastOneValidator = (validator, errorMessage) => (group) => {
    const hasAtLeastOne = group && group.controls && Object.keys(group.controls).some((key) => !validator(group.controls[key]));
    const message = { atLeastOne: { label: errorMessage } };
    return hasAtLeastOne ? null : message;
};

/**
 * Compares two dates
 */
const compareDateValidator = (otherControlName, compareBy = 'isBefore', customLabel) => {
    let thisControl;
    let otherControl;
    return (control) => {
        if (!control.parent) {
            return null;
        }
        // Initializing the validator.
        if (!thisControl) {
            thisControl = control;
            otherControl = control.parent.get(otherControlName);
            if (!otherControl) {
                throw new Error('AppValidator.compareDate(): other control is not found in parent group');
            }
            otherControl.valueChanges
                .pipe(filter(() => !thisControl.disabled || !otherControl.disabled))
                .subscribe({
                next: () => thisControl.updateValueAndValidity({ onlySelf: true, emitEvent: false }),
            });
        }
        if (!thisControl.value || !otherControl || !otherControl.value) {
            return null;
        }
        const thisDateTime = DateTime.fromISO(thisControl.value);
        const otherDateTime = DateTime.fromISO(otherControl.value);
        let isValid = true;
        let label = '';
        switch (compareBy) {
            case 'isAfter':
                isValid = thisDateTime > otherDateTime;
                label = 'label_error_end_date_start_date';
                break;
            case 'isBefore':
                isValid = thisDateTime < otherDateTime;
                label = 'label_error_start_date_end_date';
                break;
            case 'isSame':
                isValid = +thisDateTime === +otherDateTime;
                label = 'date_validation_not_same';
                break;
            case 'isSameOrAfter':
                isValid = thisDateTime >= otherDateTime;
                label = 'label_error_end_date_start_date';
                break;
            case 'isSameOrBefore':
                isValid = thisDateTime <= otherDateTime;
                label = 'label_error_start_date_end_date';
                break;
            default:
                break;
        }
        return !isValid ? { compareDate: { label: customLabel ? customLabel : label } } : null;
    };
};

/**
 * Check form control value is a Luxon DateTime instance
 */
const ValidatorDateTime = (formControl) => {
    const message = { dateTime: { label: 'label_validation_date' } };
    let isDateTime = false;
    if (Array.isArray(formControl.value)) {
        isDateTime = Utils.isDateTime(formControl.value[0]) && Utils.isDateTime(formControl.value[1]);
    }
    else {
        isDateTime = Utils.isDateTime(formControl.value);
    }
    return isDateTime ? null : message;
};

/**
 * Check form control value is a Date instance
 */
const date = (formControl) => {
    const message = { date: { label: 'label_validation_date' } };
    return Utils.isDate(formControl.value) ? null : message;
};

/**
 * Check email on pattern
 * {@link} http://emailregex.com/
 */
const emailValidator = (formControl) => {
    if (formControl.value && formControl.value.length > 127) {
        return { maxlength: { requiredLength: 127 } };
    }
    // eslint-disable-next-line no-useless-escape
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const message = { email: { label: 'ss_lang_invalid_email' } };
    return pattern.test(formControl.value) ? null : message;
};

/**
 * Check that control is empty or valid for the parameter passed ValidatorFn
 */
function emptyOrValidValidator(validator, errorMessage) {
    return (control) => {
        const valid = control && (!control.value || !validator(control));
        const message = { emptyOrValid: { label: errorMessage } };
        return valid ? null : message;
    };
}

/**
 * Check that control value is a valid 6 characters length hexadecimal number.
 * @param manageHash boolean, default true - regexp contains #
 */
function hexaColorValidator(manageHash = true) {
    const hash = manageHash ? '' : '#';
    const hexaColorPattern = `^${hash}([0-9a-fA-F]{6})$`;
    const message = { hexaColor: { label: 'label_invalid_hexa_color_value' } };
    return (control) => new RegExp(hexaColorPattern).test(control.value) ? null : message;
}

const hourValidator = (control) => {
    const pattern = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/i;
    const message = { hour: { label: 'label_hour_validatior_error' } };
    return pattern.test(control.value) ? null : message;
};

const compareHoursValidator = (firstControlName, secondControlName, errorMessage = 'stemx_hour_validator_text') => (group) => {
    if (!group || !group.controls) {
        return null;
    }
    if (!group.get(firstControlName).value || !group.get(secondControlName).value) {
        return null;
    }
    const firstControlDateTime = DateTime.fromFormat(group.get(firstControlName).value, 'HH:mm');
    const secondControlDateTime = DateTime.fromFormat(group.get(secondControlName).value, 'HH:mm');
    if (firstControlDateTime > secondControlDateTime) {
        return { startIsSmallerThanEnd: { label: errorMessage } };
    }
    return null;
};

const ImageUploadConfig = {
    max_size: 1,
    acceptable_formats: [FileExtension.JPG, FileExtension.PNG, FileExtension.GIF],
};

class ImageUploadValidator {
    constructor(config = ImageUploadConfig) {
        this.config = config;
    }
    validate(file) {
        if (!file || file.size === 0) {
            return 'stemx_file_not_found';
        }
        else if (file.size >= Utils.convertMegabytesToBytes(this.config.max_size)) {
            return 'stemx_file_is_too_big';
        }
        else if (!this.isValidExtension(file)) {
            return 'stemx_file_extension_wrong';
        }
        return null;
    }
    validateResolution(file) {
        return new Observable((observer) => {
            const url = URL.createObjectURL(file);
            const img = new Image();
            img.onload = () => {
                if (!this.isValidMinResolution(img)) {
                    observer.next({ label: 'stemx_img_invalid_min_resolution', params: [this.config.min_resolution.width, this.config.min_resolution.height] });
                }
                else if (!this.isValidMaxResolution(img)) {
                    observer.next({ label: 'stemx_img_invalid_max_resolution', params: [this.config.max_resolution.width, this.config.max_resolution.height] });
                }
                else {
                    observer.next(null);
                }
                URL.revokeObjectURL(img.src);
                observer.complete();
            };
            img.src = url;
        });
    }
    isValidExtension(file) {
        const fileExtension = this.getFileExtension(file);
        return !!this.config.acceptable_formats.includes(fileExtension);
    }
    getFileExtension(file) {
        return file.name.toLowerCase().slice(file.name.lastIndexOf('.') + 1);
    }
    isValidMinResolution(img) {
        return !this.config.min_resolution || (img.width >= this.config.min_resolution.width && img.height >= this.config.min_resolution.height);
    }
    isValidMaxResolution(img) {
        return !this.config.max_resolution || (img.width <= this.config.max_resolution.width && img.height <= this.config.max_resolution.height);
    }
}

const kebabCaseValidator = (formControl) => {
    const pattern = /^([a-z][a-z0-9]*)(-[a-z0-9]+)*$/;
    const message = { kebabCase: { label: 'label_validation_kebab' } };
    return pattern.test(formControl.value) ? null : message;
};

const letterNumberValidator = (control) => {
    const pattern = /^[a-z\d\u00c0-\u017e\s\-.]+$/i;
    const message = { letter: { label: 'label_validation_only_alphanumeric_number_error' } };
    return pattern.test(control.value) ? null : message;
};

const letterValidator = (control) => {
    const pattern = /^[a-z\u00c0-\u017e\s\-.]+$/i;
    const message = { letter: { label: 'label_validation_only_alphanumeric_error' } };
    return pattern.test(control.value) ? null : message;
};

/**
 * Check that control contains separated list of valid or empty values for the parameter passed ValidatorFn
 */
const listedValuesValidator = (validator, errorMessage, valueSeparator = ',') => (control) => {
    const valid = !(control?.value?.split(valueSeparator) || []).find((value) => {
        const trimmedValue = value.trim();
        return trimmedValue ? validator(new UntypedFormControl(trimmedValue)) : false;
    });
    const message = { listedValues: { label: errorMessage } };
    return valid ? null : message;
};

/**
 * Match two FormControl value
 */
const matchValidator = (otherControlName, errorMessage) => {
    let thisControl;
    let otherControl;
    return (control) => {
        if (!control.parent) {
            return null;
        }
        // Initializing the validator.
        if (!thisControl) {
            thisControl = control;
            otherControl = control.parent.get(otherControlName);
            if (!otherControl) {
                throw new Error('AppValidator.match(): other control is not found in parent group');
            }
            otherControl.valueChanges
                .subscribe({
                next: () => thisControl.updateValueAndValidity(),
            });
        }
        if (!otherControl) {
            return null;
        }
        if (otherControl.value !== thisControl.value) {
            return { match: { label: errorMessage } };
        }
        return null;
    };
};

const noWhitespaceValidator = (control) => {
    const pattern = /^\S+$/;
    const message = { noWhitespace: { label: 'no_whitespace_validation_error' } };
    return pattern.test(control.value) ? null : message;
};

// Contains at least 1 number, 1 lowercase and 1 uppercase letter and at least 8 chars
const passwordPattern = /(?=.*\d)(?=.*\p{Lu})(?=.*\p{Ll}).{8,}/u;

/**
 * Check password on password pattern
 * Contains at least 1 number, 1 lowercase and 1 uppercase letter and at least 8 chars
 */
const passwordValidator = (pattern = passwordPattern) => (formControl) => {
    const message = { password: { label: 'label_validation_password_weak' } };
    return pattern.test(formControl.value) ? null : message;
};

/**
 * Check phone number on pattern
 */
const phoneValidator = (formControl) => {
    const phonePattern = /^(\+)?\d{7,15}$/;
    const message = { phone: { label: 'label_validation_phone' } };
    return phonePattern.test(formControl.value) || !formControl.value ? null : message;
};

const wholeNumberValidator = (positiveOnly = true) => (control) => {
    const message = {
        positiveWholeNumber: {
            label: 'label_positive_whole_number',
        },
    };
    return Utils.isWholeNumber(control.value, positiveOnly) ? null : message;
};

/**
 * Check URL on pattern
 * {@link} http://urlregex.com/
 */
const urlValidator = (formControl) => {
    // eslint-disable-next-line no-useless-escape
    const pattern = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;
    const message = { url: { label: 'label_validation_url' } };
    return pattern.test(formControl.value) ? null : message;
};

class VatNumberValidator {
    /**
     * Hungarian VAT Number:
     * source: https://hu.wikipedia.org/wiki/Ad%C3%B3sz%C3%A1m
     *
     * xxxxxxxx-y-zz
     * törzsszám - ÁFA-kód - területi kód
     *
     * törzsszám:
     * SUM = (9 * x[1] + 7*x[2] + 3 * x[3] + x[4] + 9 * x[5] + 7 * x[6] + 3 * x[7])
     * x[8] = (10 - (SUM mod 10)) mod 10
     *
     * ÁFA-kód: 1-5
     *
     * területi kód: 2-20, 22-44, 51
     */
    get validate() {
        return (vatNumberFormControl) => {
            const vatNumber = `${vatNumberFormControl.value}`;
            if (!vatNumber) {
                return { validVatNumber: { label: 'label_error_invalid_vatnumber' } };
            }
            const [stemNumber, vatCode, areaCode] = vatNumber.split('-');
            const isValid = this.checkFormat(vatNumber) &&
                this.checkStemNumber(stemNumber) &&
                this.checkVatCode(vatCode) &&
                this.checkAreaCode(areaCode);
            if (!isValid) {
                return { validVatNumber: { label: 'label_error_invalid_vatnumber' } };
            }
            return null;
        };
    }
    checkFormat(vatNumber) {
        const regex = new RegExp(/^\d{8}-\d{1}-\d{2}$/);
        return !!regex.exec(vatNumber);
    }
    checkStemNumber(digits) {
        const multipliers = [9, 7, 3, 1, 9, 7, 3];
        const sum = digits
            .substring(0, 7)
            .split('')
            .reduce((acc, digit, index) => acc + (+digit * multipliers[index]), 0);
        return (10 - (sum % 10)) % 10 === +digits[7];
    }
    checkVatCode(digit) {
        return digit >= '1' && digit <= '5';
    }
    checkAreaCode(digits) {
        return (digits >= '02' && digits <= '20') || (digits >= '22' && digits <= '44') || digits === '51';
    }
}

const zipCodeValidator = (countryCode) => (formControl) => {
    const pattern = zipCodePattern[countryCode?.toLowerCase()];
    const message = { zipCode: { label: 'label_error_invalid_customer_zip_code' } };
    return !pattern || pattern.test(formControl.value) ? null : message;
};

class HttpLoaderStoreService extends StoreService {
    constructor() {
        super();
        this.defaultState = {
            activeRequestCount: 0,
        };
        this.activeRequestCount$ = this.shareState(({ activeRequestCount }) => activeRequestCount);
        this.isLoading$ = this.activeRequestCount$.pipe(debounceTime(50), map(Boolean), distinctUntilChanged());
        this.resetState();
    }
    increaseActiveRequestCount() {
        this.patchState({ activeRequestCount: this.state.activeRequestCount + 1 });
    }
    decreaseActiveRequestCount() {
        this.patchState({ activeRequestCount: Math.max(this.state.activeRequestCount - 1, 0) });
    }
    resetState() {
        this.setState(this.defaultState);
    }
}
HttpLoaderStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: HttpLoaderStoreService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HttpLoaderStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: HttpLoaderStoreService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: HttpLoaderStoreService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

class HttpLoaderInterceptor {
    constructor(httpLoaderStore) {
        this.httpLoaderStore = httpLoaderStore;
    }
    intercept(request, next) {
        this.httpLoaderStore.increaseActiveRequestCount();
        return next.handle(request)
            .pipe(finalize(() => this.httpLoaderStore.decreaseActiveRequestCount()));
    }
}
HttpLoaderInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: HttpLoaderInterceptor, deps: [{ token: HttpLoaderStoreService }], target: i0.ɵɵFactoryTarget.Injectable });
HttpLoaderInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: HttpLoaderInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: HttpLoaderInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: HttpLoaderStoreService }]; } });

class HttpModule {
    static forRoot(config = null) {
        return {
            ngModule: HttpModule,
            providers: [
                HttpService,
                HttpLoaderStoreService,
                { provide: HTTP_INTERCEPTORS, useClass: HttpLoaderInterceptor, multi: true },
                { provide: HTTP_MODULE_CONFIG, useValue: config },
            ],
        };
    }
}
HttpModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: HttpModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HttpModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: HttpModule, imports: [HttpClientModule], exports: [HttpClientModule] });
HttpModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: HttpModule, imports: [HttpClientModule, HttpClientModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: HttpModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [HttpClientModule],
                    exports: [HttpClientModule],
                }]
        }] });

class SetHrefDirective {
    constructor(element, router) {
        this.element = element;
        this.router = router;
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        const href = this.element?.nativeElement?.getAttribute('href');
        const isInAppLink = typeof href === 'string' && /^(?!https?|www).*$/.test(href);
        if (isInAppLink) {
            fromEvent(this.element.nativeElement, 'click')
                .pipe(filter((event) => typeof event?.preventDefault === 'function'), takeUntil(this.destroy$))
                .subscribe((event) => {
                event.preventDefault();
                this.router.navigateByUrl(href);
            });
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
SetHrefDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: SetHrefDirective, deps: [{ token: i0.ElementRef }, { token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Directive });
SetHrefDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: SetHrefDirective, selector: "[setHref]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: SetHrefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[setHref]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$1.Router }]; } });

class HyperlinkModule {
}
HyperlinkModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: HyperlinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HyperlinkModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: HyperlinkModule, declarations: [SetHrefDirective], exports: [SetHrefDirective] });
HyperlinkModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: HyperlinkModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: HyperlinkModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SetHrefDirective],
                    exports: [SetHrefDirective],
                }]
        }] });

class MetaTagServiceDefaultOptions {
    constructor() {
        this.facebookAppId = '';
        this.truncatePostfix = '...';
        this.descriptionMaxLength = 160 - this.truncatePostfix.length;
        this.socialPreviewMaxLength = 120 - this.truncatePostfix.length;
        this.titleMaxLength = 60 - this.truncatePostfix.length;
        this.siteUrl = '';
        this.imageIdToUrlConverter = (imageId) => '';
        this.normalizeFns = {
            title: (value) => value ? UtilString.truncate(value, this.titleMaxLength, this.truncatePostfix) : null,
            description: (value, length) => value ? UtilString.truncate(value, length ?? this.socialPreviewMaxLength, this.truncatePostfix) : null,
            image: (imageId) => imageId ? this.imageIdToUrlConverter(imageId) : null,
        };
        this.socialPreviewOptions = {
            delimiter: '-',
            regionPart: '',
            tabTextPart: '',
        };
    }
}

class MetaTagService {
    constructor(meta) {
        this.meta = meta;
        this.normalizedOptions = {};
    }
    get options() {
        return this.normalizedOptions;
    }
    /**
     * Load config options for service
     * @param config {Partial<IMetaTagServiceOptions>} - service options
     */
    loadConfig(config) {
        const defaultOptions = new MetaTagServiceDefaultOptions();
        if (config?.imageIdToUrlConverter) {
            defaultOptions.imageIdToUrlConverter = config.imageIdToUrlConverter;
        }
        this.normalizedOptions = {
            ...defaultOptions,
            ...config,
        };
    }
    /**
     * Set title meta tag. Not the <title> tag, but the <meta name="title" content="..."> tag
     * Falsy values will be ignored
     * @param title {string} - title of page
     */
    updateTitle(title) {
        this.setCommonMetaTags({ title });
        this.setFacebookMetaTags({ title });
        this.setTwitterMetaTags({ title });
    }
    /**
     * Set initial meta tags for page: description and image
     * Falsy values will be ignored
     * @param description {string} - description of page
     * @param imageId {AAGUID} - id of image to use for social media previews
     */
    setInitialMetaTags(description, imageId) {
        const initialTags = {
            description: this.normalizedOptions.normalizeFns.description(description, this.normalizedOptions.descriptionMaxLength),
            image: this.normalizedOptions.normalizeFns.image(imageId),
        };
        this.setCommonMetaTags({ description: initialTags.description });
        this.setFacebookInitialTags(initialTags);
        this.setTwitterInitialTags(initialTags);
    }
    /**
     * Update meta tags for a desired page
     * Falsy config values will be ignored
     * @param config {Partial<IMetaTagConfig>} - meta tag configuration object
     */
    updateMetaTags(config = {}) {
        const normalizedConfig = this.normalizeTags(config);
        this.setCommonMetaTags(normalizedConfig);
        this.setFacebookMetaTags(normalizedConfig);
        this.setTwitterMetaTags(normalizedConfig);
    }
    normalizeTags(config) {
        return Object.entries(config)
            .reduce((acc, [key, value]) => ({
            ...acc,
            [key]: this.normalizedOptions.normalizeFns[key]?.(value) || value,
        }), {});
    }
    filterConfig(config) {
        return Object.entries(config).filter(([, content]) => !!content);
    }
    setCommonMetaTags(config = {}) {
        this.filterConfig(config).forEach(([name, content]) => {
            this.meta.updateTag({ name, content });
        });
    }
    setFacebookMetaTags(config = {}) {
        this.filterConfig({ ...config, title: this.createSocialTitle(config.title) }).forEach(([name, content]) => {
            this.meta.updateTag({ property: `og:${name}`, content });
        });
    }
    setFacebookInitialTags(initialTags) {
        this.meta.updateTag({ property: 'og:type', content: 'website' });
        this.normalizedOptions.siteUrl && this.meta.updateTag({ property: 'og:url', content: this.normalizedOptions.siteUrl });
        this.normalizedOptions.facebookAppId && this.meta.updateTag({ property: 'fb:app_id', content: this.normalizedOptions.facebookAppId });
        this.setFacebookMetaTags(initialTags);
    }
    setTwitterInitialTags(initialTags) {
        this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
        this.normalizedOptions.siteUrl && this.meta.updateTag({ name: 'twitter:url', content: this.normalizedOptions.siteUrl });
        this.setTwitterMetaTags(initialTags);
    }
    setTwitterMetaTags(config = {}) {
        this.filterConfig({ ...config, title: this.createSocialTitle(config.title) }).forEach(([name, content]) => {
            this.meta.updateTag({ name: `twitter:${name}`, content });
        });
    }
    createSocialTitle(endPart) {
        const { socialPreviewOptions: { tabTextPart, regionPart, delimiter } } = this.normalizedOptions;
        let normalizedEndPart = endPart || '';
        if (normalizedEndPart) {
            const wordToReplace = tabTextPart || regionPart;
            normalizedEndPart = normalizedEndPart.replace(new RegExp(` ?[-|] ?${wordToReplace}$`), '');
        }
        // example output: TabTextFromPartnerConfig - RegionPartnerName - ProgramName
        // or without tabText: RegionPartnerName - ProgramName
        return Array.from(new Set([tabTextPart, regionPart, normalizedEndPart]))
            .filter((part) => typeof part === 'string')
            .join(` ${delimiter} `);
    }
}
MetaTagService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: MetaTagService, deps: [{ token: i1.Meta }], target: i0.ɵɵFactoryTarget.Injectable });
MetaTagService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: MetaTagService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: MetaTagService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.Meta }]; } });

class MetaModule {
}
MetaModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: MetaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MetaModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: MetaModule, imports: [CommonModule] });
MetaModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: MetaModule, providers: [MetaTagService], imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: MetaModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    providers: [MetaTagService],
                }]
        }] });

class CountryPipe {
    transform(countryCode) {
        return countryCode ? 'label_country_' + countryCode.toLowerCase() : null;
    }
}
CountryPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: CountryPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CountryPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: CountryPipe, name: "country" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: CountryPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'country',
                }]
        }] });

class AddressMultiPropPipe {
    constructor(countryPipe, translate) {
        this.countryPipe = countryPipe;
        this.translate = translate;
        this.useLineBreakBeforeCountry = true;
    }
    transform(address, useLineBreakBeforeCountry = true) {
        this.useLineBreakBeforeCountry = useLineBreakBeforeCountry;
        return this.generateAddressString(address);
    }
    generateAddressString(address) {
        let result = this.addZipCode(address?.zipCode);
        result = this.addCity(address?.city, result);
        result = this.addAddress(address?.address, result);
        return this.addCountry(address?.country, result);
    }
    addZipCode(zipCode) {
        return zipCode || '';
    }
    addCity(city, result) {
        return result + (city ? ` ${city}` : '');
    }
    addAddress(address, result) {
        return result + (address ? `, ${address}` : '');
    }
    addCountry(country, result) {
        if (country) {
            const translatedCountry = this.translate.get(this.countryPipe.transform(country));
            result += result.length > 0 && this.useLineBreakBeforeCountry ? '<br>' : '';
            result += result.length > 0 && !this.useLineBreakBeforeCountry ? ` ${translatedCountry}` : translatedCountry;
        }
        return result;
    }
}
AddressMultiPropPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: AddressMultiPropPipe, deps: [{ token: CountryPipe }, { token: TranslateService }], target: i0.ɵɵFactoryTarget.Pipe });
AddressMultiPropPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: AddressMultiPropPipe, name: "addressMultiProp" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: AddressMultiPropPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'addressMultiProp',
                }]
        }], ctorParameters: function () { return [{ type: CountryPipe }, { type: TranslateService }]; } });

class AddressPipe {
    constructor(translate) {
        this.translate = translate;
    }
    transform(address) {
        if (!address) {
            return '';
        }
        const floorTranslation = this.translate.get('general_lang_floor');
        return address.bound(this.translate.currentLang, floorTranslation);
    }
}
AddressPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: AddressPipe, deps: [{ token: TranslateService }], target: i0.ɵɵFactoryTarget.Pipe });
AddressPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: AddressPipe, name: "address" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: AddressPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'address',
                }]
        }], ctorParameters: function () { return [{ type: TranslateService }]; } });

/**
 * Luxon duration formats:
 * {@link} https://moment.github.io/luxon/docs/class/src/duration.js~Duration.html#instance-method-toFormat
 */
class DateTimeDurationPipe {
    constructor(translate) {
        this.translate = translate;
    }
    transform(durationInMinutes, format) {
        let toFormat = format;
        if (!toFormat) {
            if (durationInMinutes < 60) {
                toFormat = `mm ${this.translate.get('admin_label_mins')}`;
            }
            else if (durationInMinutes > 1440) {
                toFormat = `d ${this.translate.get('admin_label_days')}`;
            }
            else {
                toFormat = `hh:mm`;
            }
        }
        return Duration.fromObject({ minutes: durationInMinutes }).toFormat(toFormat);
    }
}
DateTimeDurationPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: DateTimeDurationPipe, deps: [{ token: TranslateService }], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeDurationPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: DateTimeDurationPipe, name: "dateTimeDuration" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: DateTimeDurationPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeDuration',
                }]
        }], ctorParameters: function () { return [{ type: TranslateService }]; } });

class DisplayPipe {
    transform(string, placeholder) {
        if (string === 0) {
            return 0;
        }
        return string ? string : placeholder || '-';
    }
}
DisplayPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: DisplayPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DisplayPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: DisplayPipe, name: "display" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: DisplayPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'display',
                }]
        }] });

class DurationPipe {
    constructor(translate) {
        this.translate = translate;
    }
    transform(duration) {
        return duration ? `${duration} ${this.translate.get('admin_label_mins')}` : this.translate.get('label_unknown');
    }
}
DurationPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: DurationPipe, deps: [{ token: TranslateService }], target: i0.ɵɵFactoryTarget.Pipe });
DurationPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: DurationPipe, name: "duration" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: DurationPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'duration',
                }]
        }], ctorParameters: function () { return [{ type: TranslateService }]; } });

class EllipsisPipe {
    transform(string, limit = 60, suffix = '...') {
        return UtilString.truncate(string, limit, suffix);
    }
}
EllipsisPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: EllipsisPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
EllipsisPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: EllipsisPipe, name: "ellipsis" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: EllipsisPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'ellipsis',
                }]
        }] });

class JoinPipe {
    transform(strings, separator = ', ') {
        return strings.join(separator);
    }
}
JoinPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: JoinPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
JoinPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: JoinPipe, name: "join" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: JoinPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'join',
                    pure: true,
                }]
        }] });

class MaxCapacityPipe {
    constructor(translate) {
        this.translate = translate;
    }
    transform(piece) {
        if (piece === null) {
            return this.translate.get('no_limit');
        }
        return `${piece} ${this.translate.get('label_short_pieces')}`;
    }
}
MaxCapacityPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: MaxCapacityPipe, deps: [{ token: TranslateService }], target: i0.ɵɵFactoryTarget.Pipe });
MaxCapacityPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: MaxCapacityPipe, name: "maxcapacity" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: MaxCapacityPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'maxcapacity',
                }]
        }], ctorParameters: function () { return [{ type: TranslateService }]; } });

/**
 * {@link} https://angular.io/api/common/CurrencyPipe#parameters
 */
class MoneyPipe extends CurrencyPipe {
    transform(value, _currencyCode, _display) {
        let currencyCode = _currencyCode;
        let display;
        let digitsInfo;
        switch (currencyCode) {
            case Currency.HUF: {
                currencyCode = currencyCode + ' ';
                display = _display ?? 'symbol';
                digitsInfo = '0.0-0';
                break;
            }
            default: {
                display = _display ?? 'symbol';
                digitsInfo = '0.2';
                break;
            }
        }
        return super.transform(value, currencyCode, display, digitsInfo);
    }
}
MoneyPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: MoneyPipe, deps: null, target: i0.ɵɵFactoryTarget.Pipe });
MoneyPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: MoneyPipe, name: "money" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: MoneyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'money',
                }]
        }] });

class NamePipe {
    constructor(translate) {
        this.translate = translate;
    }
    transform(value, firstNameKey = 'firstName', lastNameKey = 'lastName') {
        if (!value || (!value[firstNameKey] && !value[lastNameKey])) {
            return null;
        }
        if (this.translate.currentLang === LanguageCode.HU) {
            return `${value[lastNameKey]} ${value[firstNameKey]}`.trim();
        }
        return `${value[firstNameKey]} ${value[lastNameKey]}`.trim();
    }
}
NamePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: NamePipe, deps: [{ token: TranslateService }], target: i0.ɵɵFactoryTarget.Pipe });
NamePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: NamePipe, name: "name" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: NamePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'name',
                }]
        }], ctorParameters: function () { return [{ type: TranslateService }]; } });

class PercentSignPipe {
    transform(num) {
        return (!num && num !== 0) || isNaN(num) ? null : num + '%';
    }
}
PercentSignPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: PercentSignPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
PercentSignPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: PercentSignPipe, name: "percentSign" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: PercentSignPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'percentSign',
                }]
        }] });

class PiecePipe {
    constructor(decimalPipe, translate) {
        this.decimalPipe = decimalPipe;
        this.translate = translate;
    }
    transform(piece) {
        if (piece === null) {
            return null;
        }
        return `${this.decimalPipe.transform(piece)} ${this.translate.get('label_short_pieces')}`;
    }
}
PiecePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: PiecePipe, deps: [{ token: i1$4.DecimalPipe }, { token: TranslateService }], target: i0.ɵɵFactoryTarget.Pipe });
PiecePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: PiecePipe, name: "piece" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: PiecePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'piece',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.DecimalPipe }, { type: TranslateService }]; } });

/**
 * Bypass security and trust url for a given value.
 *
 * @deprecated Use the new {@link SafePipe} instead.
 */
class SafeUrlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
SafeUrlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: SafeUrlPipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SafeUrlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: SafeUrlPipe, name: "safeUrl" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: SafeUrlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safeUrl',
                }]
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }]; } });

/**
 * Sanitize and bypass a value for use in the DOM.
 */
class SafePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, type) {
        switch (type) {
            case 'html':
                return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default: throw new Error(`Invalid safe type specified: ${type}`);
        }
    }
}
SafePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: SafePipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SafePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: SafePipe, name: "safe" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: SafePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safe',
                }]
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }]; } });

/**
 * Joins non empty and distinct items of the array.
 */
class SmartJoinPipe {
    transform(items, separator) {
        return [...new Set(items.filter(item => !!item))].join(separator);
    }
}
SmartJoinPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: SmartJoinPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
SmartJoinPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: SmartJoinPipe, name: "smartJoin" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: SmartJoinPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'smartJoin',
                }]
        }] });

function formatDateWithTimezone(value, format = DateTimeFormat.DATETIME_FULL, locale = LanguageCode.EN, timezone = TimeZone.LOCAL) {
    if (!value) {
        return '';
    }
    const dateTime = DateTime.fromISO(value);
    if (!dateTime.isValid) {
        return '';
    }
    const formats = DATE_TIME_FORMATS[locale];
    const dateTimeFormat = formats[format] || format;
    return dateTime
        .setLocale(locale)
        .setZone(timezone)
        .toFormat(dateTimeFormat);
}
class TimezonePipe {
    constructor(translate) {
        this.translate = translate;
    }
    transform(value, format = DateTimeFormat.DATETIME_FULL, locale = this.translate.currentLang, timezone = TimeZone.LOCAL) {
        return formatDateWithTimezone(value, format, locale, timezone);
    }
}
TimezonePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TimezonePipe, deps: [{ token: TranslateService }], target: i0.ɵɵFactoryTarget.Pipe });
TimezonePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: TimezonePipe, name: "timezone" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: TimezonePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'timezone',
                }]
        }], ctorParameters: function () { return [{ type: TranslateService }]; } });

class YesNoPipe {
    transform(value) {
        return value ? 'label_yes' : 'label_no';
    }
}
YesNoPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: YesNoPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
YesNoPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: YesNoPipe, name: "yesno" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: YesNoPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'yesno',
                }]
        }] });

const pipes = [
    AddressMultiPropPipe,
    AddressPipe,
    CountryPipe,
    DateTimeDurationPipe,
    DisplayPipe,
    DurationPipe,
    EllipsisPipe,
    JoinPipe,
    MaxCapacityPipe,
    MoneyPipe,
    NamePipe,
    PercentSignPipe,
    PiecePipe,
    SafePipe,
    SafeUrlPipe,
    SmartJoinPipe,
    TimezonePipe,
    YesNoPipe,
];
class PipeModule {
    static forRoot() {
        return {
            ngModule: PipeModule,
            providers: [
                DecimalPipe,
                ...pipes,
            ],
        };
    }
}
PipeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: PipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PipeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: PipeModule, declarations: [AddressMultiPropPipe,
        AddressPipe,
        CountryPipe,
        DateTimeDurationPipe,
        DisplayPipe,
        DurationPipe,
        EllipsisPipe,
        JoinPipe,
        MaxCapacityPipe,
        MoneyPipe,
        NamePipe,
        PercentSignPipe,
        PiecePipe,
        SafePipe,
        SafeUrlPipe,
        SmartJoinPipe,
        TimezonePipe,
        YesNoPipe], imports: [CommonModule,
        TranslateModule], exports: [AddressMultiPropPipe,
        AddressPipe,
        CountryPipe,
        DateTimeDurationPipe,
        DisplayPipe,
        DurationPipe,
        EllipsisPipe,
        JoinPipe,
        MaxCapacityPipe,
        MoneyPipe,
        NamePipe,
        PercentSignPipe,
        PiecePipe,
        SafePipe,
        SafeUrlPipe,
        SmartJoinPipe,
        TimezonePipe,
        YesNoPipe] });
PipeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: PipeModule, imports: [CommonModule,
        TranslateModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: PipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TranslateModule,
                    ],
                    declarations: [
                        ...pipes,
                    ],
                    exports: [
                        ...pipes,
                    ],
                }]
        }] });

// @dynamic
class ScriptLoaderService {
    constructor(document) {
        this.document = document;
        this.scriptPromises = [];
    }
    loadCrisp(config) {
        // Config
        const configPromise = new Promise(resolve => {
            const scriptTag = this.document.createElement('script');
            scriptTag.onload = resolve;
            let script = `window.$crisp=[];window.CRISP_WEBSITE_ID="${config.websiteId}";`;
            if (config.cookieDomain) {
                script += `CRISP_COOKIE_DOMAIN="${config.cookieDomain}";`;
            }
            if (config.safeMode) {
                script += `$crisp.push(["safe", true]);`;
            }
            scriptTag.innerHTML = script;
            this.document.head.appendChild(scriptTag);
        });
        // Script
        const scriptTagPromise = new Promise(resolve => {
            const scriptTag = this.document.createElement('script');
            scriptTag.src = 'https://client.crisp.chat/l.js';
            scriptTag.async = true;
            scriptTag.onload = resolve;
            this.document.head.appendChild(scriptTag);
        });
        this.scriptPromises.push(configPromise);
        this.scriptPromises.push(scriptTagPromise);
    }
    loadGoogleAnalytics(config) {
        // injecting GA main script asynchronously
        const scriptTagPromise = new Promise(resolve => {
            const scriptTag = this.document.createElement('script');
            scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${config.apiKey}`;
            scriptTag.async = true;
            scriptTag.onload = resolve;
            this.document.head.insertBefore(scriptTag, this.document.head.firstChild);
        });
        // preparing GA API to be usable even before the async script is loaded
        const configPromise = new Promise(resolve => {
            const scriptTag = this.document.createElement('script');
            scriptTag.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', '${config.apiKey}');
      `;
            this.document.head.insertBefore(scriptTag, scriptTag.nextSibling);
        });
        this.scriptPromises.push(scriptTagPromise);
        this.scriptPromises.push(configPromise);
    }
    loadGoogleTagManager(config) {
        // Google Tag Manager Script
        const scriptTagPromise = new Promise(resolve => {
            const scriptTag = this.document.createElement('script');
            scriptTag.onload = resolve;
            scriptTag.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${config.apiKey}');
      `;
            this.document.head.insertBefore(scriptTag, this.document.head.firstChild);
        });
        // Google Tag Manager Iframe
        const iframePromise = new Promise(resolve => {
            const iframe = this.document.createElement('iframe');
            iframe.onload = resolve;
            iframe.src = `https://www.googletagmanager.com/ns.html?id=${config.apiKey}`;
            iframe.height = '0';
            iframe.width = '0';
            iframe.style.display = 'none';
            iframe.style.visibility = 'hidden';
            const noscript = this.document.createElement('noscript');
            noscript.appendChild(iframe);
            this.document.body.insertBefore(noscript, this.document.body.firstChild);
        });
        this.scriptPromises.push(scriptTagPromise);
        this.scriptPromises.push(iframePromise);
    }
    load(config) {
        if (config) {
            Object.keys(config).forEach((key) => {
                switch (key) {
                    case 'googleAnalytics':
                        this.loadGoogleAnalytics(config.googleAnalytics);
                        break;
                    case 'googleTagManager':
                        this.loadGoogleTagManager(config.googleTagManager);
                        break;
                    case 'crisp':
                        this.loadCrisp(config.crisp);
                        break;
                }
            });
            return Promise.all(this.scriptPromises);
        }
    }
}
ScriptLoaderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ScriptLoaderService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
ScriptLoaderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ScriptLoaderService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ScriptLoaderService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

class ScriptLoaderModule {
}
ScriptLoaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ScriptLoaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ScriptLoaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: ScriptLoaderModule });
ScriptLoaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ScriptLoaderModule, providers: [ScriptLoaderService] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: ScriptLoaderModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [ScriptLoaderService],
                }]
        }] });

var SocketConcurrentType;
(function (SocketConcurrentType) {
    SocketConcurrentType["VIDEO_PLAYBACK_STARTED"] = "VIDEO_PLAYBACK_STARTED";
    SocketConcurrentType["VIDEO_PLAYBACK_ONGOING"] = "VIDEO_PLAYBACK_ONGOING";
    SocketConcurrentType["PAUSE_VIDEO_PLAYBACK"] = "PAUSE_VIDEO_PLAYBACK";
    SocketConcurrentType["PLAY_VIDEO_PLAYBACK"] = "PLAY_VIDEO_PLAYBACK";
})(SocketConcurrentType || (SocketConcurrentType = {}));

var SocketEvent;
(function (SocketEvent) {
    SocketEvent["AUTHENTICATION"] = "authentication";
    SocketEvent["AUTHENTICATED"] = "authenticated";
    SocketEvent["CONCURRENT"] = "concurrent";
    SocketEvent["CONNECT"] = "connect";
    SocketEvent["RECONNECT"] = "reconnect";
    SocketEvent["JOIN"] = "join";
    SocketEvent["CHAT"] = "chat";
    SocketEvent["MESSAGE"] = "message";
})(SocketEvent || (SocketEvent = {}));

class SocketConnection {
    constructor(socketConfig) {
        this.socketConfig = socketConfig;
        this.unsentMessages = [];
        this.sendToken = () => {
            this.socket.once(SocketEvent.AUTHENTICATED, this.onReady);
            this.socket.emit(SocketEvent.AUTHENTICATION, { token: this.socketConfig?.getToken() });
        };
        this.onReady = () => {
            while (this.unsentMessages.length) {
                const [event, payload] = this.unsentMessages.shift();
                this.sendMessage(event, payload);
            }
        };
        this.socket = io(socketConfig?.socketUrl || '', {
            transports: ['websocket'],
            path: '/api/v1/socket.io',
            ...socketConfig?.options,
        });
        this.connect();
    }
    connect() {
        this.close();
        if (this.socketConfig?.getToken) {
            if (this.socket.connected) {
                this.sendToken();
            }
            this.authenticate();
        }
        else {
            this.onReady();
        }
    }
    close() {
        if (this.socket.connected) {
            this.socket.close();
        }
        if (this.socket.hasListeners(SocketEvent.CONNECT)) {
            this.socket.off(SocketEvent.CONNECT, this.sendToken);
        }
        if (this.socket.hasListeners(SocketEvent.AUTHENTICATED)) {
            this.socket.off(SocketEvent.AUTHENTICATED, this.onReady);
        }
    }
    sendMessage(event, payload) {
        if (this.socket.connected) {
            this.socket.emit(event, payload);
        }
        else {
            this.unsentMessages.push([event, payload]);
        }
    }
    listen(event) {
        const listener$ = new Subject();
        const handler = (response) => {
            listener$.next(response);
        };
        return of(null)
            .pipe(switchMap(() => {
            this.socket.on(event, handler);
            return listener$;
        }), finalize(() => this.socket.off(event, handler)));
    }
    concurrent(payload) {
        this.sendMessage(SocketEvent.CONCURRENT, payload);
    }
    onConcurrent() {
        return this.listen(SocketEvent.CONCURRENT);
    }
    authenticate() {
        this.socket.on(SocketEvent.CONNECT, this.sendToken);
    }
}

function ServerSide() {
    return (target, propertyKey, propertyDescriptor) => {
        const originalMethod = propertyDescriptor.value;
        propertyDescriptor.value = function (...args) {
            if (isNode) {
                return originalMethod.call(this, ...args);
            }
        };
    };
}

class UiKitLoaderComponent {
    constructor() {
        this.size = 60;
        this.colorful = false;
        this.fillContainer = false;
        this.position = 'center';
    }
    get loaderSize() {
        return `${this.size}px`;
    }
}
UiKitLoaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: UiKitLoaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
UiKitLoaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: UiKitLoaderComponent, selector: "ui-kit-loader", inputs: { size: "size", colorful: "colorful", fillContainer: "fillContainer", position: "position" }, host: { properties: { "style.--ui-kit-loader-size": "this.loaderSize", "class.fill-container": "this.fillContainer", "style.--ui-kit-loader-position": "this.position" } }, ngImport: i0, template: "<div class=\"ui-kit-loader-container\">\n  <div class=\"ui-kit-loader\" [class.colorful]=\"colorful\">\n    <div></div>\n    <div></div>\n    <div></div>\n    <div></div>\n    <div></div>\n  </div>\n</div>\n", styles: [":host{--ui-kit-loader-position: center;display:flex;justify-content:var(--ui-kit-loader-position);align-items:center;height:100%}:host.fill-container{display:flex;width:100%;min-height:100%;flex:1 1 100%;flex-flow:column}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: UiKitLoaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ui-kit-loader', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ui-kit-loader-container\">\n  <div class=\"ui-kit-loader\" [class.colorful]=\"colorful\">\n    <div></div>\n    <div></div>\n    <div></div>\n    <div></div>\n    <div></div>\n  </div>\n</div>\n", styles: [":host{--ui-kit-loader-position: center;display:flex;justify-content:var(--ui-kit-loader-position);align-items:center;height:100%}:host.fill-container{display:flex;width:100%;min-height:100%;flex:1 1 100%;flex-flow:column}\n"] }]
        }], propDecorators: { size: [{
                type: Input
            }], colorful: [{
                type: Input
            }], loaderSize: [{
                type: HostBinding,
                args: ['style.--ui-kit-loader-size']
            }], fillContainer: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.fill-container']
            }], position: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['style.--ui-kit-loader-position']
            }] } });

const components = [
    UiKitLoaderComponent,
];
class UiKitCoreModule {
}
UiKitCoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: UiKitCoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
UiKitCoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: UiKitCoreModule, declarations: [UiKitLoaderComponent], imports: [CommonModule], exports: [UiKitLoaderComponent] });
UiKitCoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: UiKitCoreModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: UiKitCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                    ],
                    declarations: [
                        ...components,
                    ],
                    exports: [
                        ...components,
                    ],
                }]
        }] });

const AllPaymentMethod = {
    ...BoxofficePaymentMethod,
    ...OnlinePaymentMethod,
};

class FormUtils {
    /**
     * Updates every value of given control array
     */
    static patchControls(controls, value, options = FormUtils.defaultOptions) {
        if (!Array.isArray(controls)) {
            return;
        }
        controls.forEach(control => control.patchValue(value, options));
    }
    /**
     * Disables each control in the array
     */
    static disableControls(controls, options = FormUtils.defaultOptions) {
        if (!Array.isArray(controls)) {
            return;
        }
        controls.forEach(control => control.disable(options));
    }
    /**
     * Enables each control in the array
     */
    static enableControls(controls, options = FormUtils.defaultOptions) {
        if (!Array.isArray(controls)) {
            return;
        }
        controls.forEach(control => control.enable(options));
    }
}
FormUtils.defaultOptions = {
    onlySelf: false,
    emitEvent: true,
};

const DEFAULT_RETRY_STRATEGY_OPTIONS = {
    attempts: 3,
    scalingDuration: 1000,
    excludedStatusCodes: [],
};
const genericRetryStrategy = ({ attempts = DEFAULT_RETRY_STRATEGY_OPTIONS.attempts, scalingDuration = DEFAULT_RETRY_STRATEGY_OPTIONS.scalingDuration, excludedStatusCodes = DEFAULT_RETRY_STRATEGY_OPTIONS.excludedStatusCodes, } = {}) => (_attempts) => _attempts.pipe(mergeMap((error, i) => {
    const retryAttempt = i + 1;
    if (retryAttempt > attempts ||
        !(error instanceof HttpErrorResponse) ||
        excludedStatusCodes.find((statusCode) => statusCode === error.status)) {
        return throwError(error);
    }
    return timer(retryAttempt * scalingDuration);
}));

class UtilHtml {
    /**
     * Get the text content of an HTML string
     * @param html input string
     * @returns {string} The text content of the HTML
     */
    static getTextContent(html) {
        try {
            const parser = new DOMParser();
            const parsedHtml = parser.parseFromString(html, 'text/html');
            return parsedHtml?.body?.textContent || '';
        }
        catch (e) {
            console.error(`Error while parsing HTML: ${e}`);
            return '';
        }
    }
    /**
     * Unescape HTML entities
     * @param text input string
     * @returns {string} The unescaped string
     * @source https://github.com/angular/angular/blob/15.1.5/packages/platform-browser/src/browser/transfer_state.ts#L23
     */
    static unescapeHtml(text) {
        const unescapedText = {
            '&a;': '&',
            '&q;': '"',
            '&s;': '\'',
            '&l;': '<',
            '&g;': '>',
        };
        return text.replace(/&[^;]+;/g, s => unescapedText[s]);
    }
    /**
     * Get the parsed data from a script tag from the Document html content
     * @param doc Document model
     * @param scriptId The id of the script tag in Document html content
     * @returns {T} The parsed data from the script tag. If the script tag is not found or the data is not parsable, an empty object is returned
     * @source https://github.com/angular/angular/blob/15.1.5/packages/platform-browser/src/browser/transfer_state.ts#L160
     */
    static getParsedDataFromScriptTag(doc, scriptId) {
        const script = doc.getElementById(scriptId);
        let initialState;
        if (script?.textContent) {
            try {
                initialState = JSON.parse(UtilHtml.unescapeHtml(script.textContent));
            }
            catch (e) {
                console.warn('Exception while parsing data', e);
                return {};
            }
        }
        return initialState || {};
    }
}

class UtilNumber {
    /**
     * Getting a random integer between two values, inclusive
     * @link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random#getting_a_random_integer_between_two_values_inclusive
     */
    static getRandomInt(_min, _max) {
        const min = Math.ceil(_min);
        const max = Math.floor(_max);
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
}

class UtilUrl {
    /**
     * Source: https://stackoverflow.com/a/23945027/13183117
     */
    static getRootDomain(url) {
        let domain = UtilUrl.getHostName(url);
        const splitArr = domain.split('.');
        const arrLen = splitArr.length;
        // extracting the root domain here if there is a subdomain
        if (arrLen > 2) {
            domain = splitArr[arrLen - 2] + '.' + splitArr[arrLen - 1];
            // check to see if it's using a Country Code Top Level Domain (ccTLD) (i.e. ".me.uk")
            if (splitArr[arrLen - 2].length === 2 && splitArr[arrLen - 1].length === 2) {
                // this is using a ccTLD
                domain = splitArr[arrLen - 3] + '.' + domain;
            }
        }
        return domain;
    }
    static getHostName(url) {
        let hostname;
        // find & remove protocol (http, ftp, etc.) and get hostname
        if (url.indexOf('//') > -1) {
            hostname = url.split('/')[2];
        }
        else {
            hostname = url.split('/')[0];
        }
        // find & remove port number
        hostname = hostname.split(':')[0];
        // find & remove "?"
        hostname = hostname.split('?')[0];
        return hostname;
    }
    /**
     * Source: https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
     */
    static getQueryParam(name, url) {
        // eslint-disable-next-line no-useless-escape
        const paramName = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + paramName + '(=([^&#]*)|&|#|$)');
        const results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}

/*
 * Public API Surface of core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ALL_SUPPORTED_LANGUAGE, Address, AddressMultiPropPipe, AddressPipe, AllPaymentMethod, ApiError, ApiErrorMessage, ApiErrorResponse, AppFormControlDirective, AppFormDirective, AuthModule, AuthService, BoxofficePaymentMethod, Browser, COUNTRY_LIST, ContinentCode, Country, CountryCode, CountryPipe, Currency, CustomHttpParamEncoder, CustomInputModule, CustomerDataField, DATE_TIME_FORMATS, DEFAULT_RETRY_STRATEGY_OPTIONS, DEFAULT_TRANSLATE_MODULE_CONFIG, DateTimeDurationPipe, DateTimeFormat, DisplayPipe, DurationPipe, EllipsisPipe, EncodedHttpParams, ErrorPageModule, ErrorPageRoutes, FileExtension, FormModule, FormUtils, GENERAL_CONFIG, GeneralConfig, HTTP_MODULE_CONFIG, HttpLoaderStoreService, HttpModule, HttpService, HyperlinkModule, ImageUploadValidator, InlineInputComponent, InvoiceConfig, InvoiceProvider, InvoiceProviderName, InvoiceStatus, JoinPipe, LANGUAGE_LOCALE_CODE, LanguageCode, LanguageCountryCode, LocalizationConfig, MaterialIconComponent, MaterialModule, MaxCapacityPipe, MetaModule, MetaTagService, MetaTagServiceDefaultOptions, MoneyPipe, NamePipe, OnlinePaymentMethod, PARTNER_CONFIG, PARTNER_THEME, PARTNER_THEME_LIST, PARTNER_WEB_CONFIG, PageNotFoundComponent, PageServerErrorComponent, PartnerConfig, PartnerType, PartnerWebConfig, PartnerWebConfigTheme, PasswordInputComponent, PercentSignPipe, PiecePipe, PipeModule, PublicPageTemplate, RefreshStrategy, RegionCode, SafePipe, SafeUrlPipe, ScriptLoaderModule, ScriptLoaderService, ServerSide, SetHrefDirective, ShowErrorsComponent, SmartJoinPipe, SocketConcurrentType, SocketConnection, SocketEvent, SsrModule, SsrService, Status, StoreService, TRANSLATE_MODULE_CONFIG, TimeZone, TimezonePipe, TranslateModule, TranslatePipe, TranslateService, UiKitCoreModule, UiKitLoaderComponent, UtilHtml, UtilNumber, UtilString, UtilUrl, Utils, ValidatorDateTime, VatNumberValidator, WEB_CONFIG, WebConfig, YesNoPipe, acceptTermsValidator, advancedPhoneValidator, allEmptyOrValidValidator, arrayLengthValidator, atLeastOneRequiredValidator, atLeastOneValidator, compareDateValidator, compareHoursValidator, countryListByRegion, date, emailValidator, emptyOrValidValidator, formatDateWithTimezone, genericRetryStrategy, getQueryParam, hexaColorValidator, hourValidator, isBrowser, isNode, kebabCaseValidator, letterNumberValidator, letterValidator, listedValuesValidator, matchValidator, noWhitespaceValidator, parseArray, passwordValidator, phoneValidator, showErrorAnimation, urlValidator, wholeNumberValidator, zipCodePattern, zipCodeValidator };
